var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1100,
    height: 750,
    viewBox: "0 0 291.042 198.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2834.646h4251.968V0H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2066.45 1293.03h70.05v-186.09h-70.05z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2211.74 1676.68h255.01v-253.19h-255.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2205.52 1454.59h408.18v-390.65h-408.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2521.52 1510.89h73.13v-91.69h-73.13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2490.57 1549.14h93.58v-82.16h-93.58z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2230.33 1609.63h288.03v-217.74h-288.03z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2288.18 1547.51h230.75v-167.05h-230.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2284.54 1494.68h238.37V1330.6h-238.37z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2282.77 1432.13h249.19v-133.84h-249.19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2325.63 1365.89h208.44v-104.44h-208.44z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2305.72 1271.04h208.09v-49.59h-208.09z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2238.25 1276.4h265.8v-111.53h-265.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2201.75 1274.57h263.53v-153.56h-263.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2095.46 1292.36h305.73v-193.18h-305.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2174.94 1386.32h124.17v-119.81h-124.17z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2137.84 1020.08h23.55v-28.677h-23.55z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2199.61 1064.1h34.86v-35h-34.86z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2115.47 1293.03h70.06v-186.09h-70.06z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1785.22 1676.68h255.01v-253.19h-255.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1638.27 1454.59h408.18v-390.65h-408.18z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1657.32 1510.89h73.13v-91.69h-73.13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1667.82 1549.14h93.58v-82.16h-93.58z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1733.61 1609.63h288.03v-217.74h-288.03z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1733.04 1547.51h230.75v-167.05h-230.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1729.06 1494.68h238.37V1330.6h-238.37z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1720.01 1432.13h249.19v-133.84h-249.19Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1717.9 1365.89h208.44v-104.44H1717.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1738.16 1271.04h208.09v-49.59h-208.09z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1747.92 1276.4h265.8v-111.53h-265.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1786.69 1274.57h263.53v-153.56h-263.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1850.78 1292.36h305.73v-193.18h-305.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1952.86 1386.32h124.17v-119.81h-124.17z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2090.58 1020.08h23.55v-28.677h-23.55z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2017.5 1064.1h34.86v-35h-34.86z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2152.04 1057.5h36.11v-63.615h-36.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2181.67 1062.56h15.19v-66.239h-15.19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2063.75 1057.49h36.11v-63.618h-36.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2055.04 1062.55h15.19v-66.242h-15.19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2303.35 1598.25h74.92v-73.48h-74.92z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1873.7 1598.25h74.92v-73.48h-74.92z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1816.62 1557.48h91.87v-67.61h-91.87z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2343.48 1557.48h91.86v-66.78h-91.86z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2160.52 1020.85h58.98v-36.402h-58.98z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2032.47 1020.85h58.98v-36.402h-58.98z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1932.9 1644.69h46.83v-21.91h-46.83z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1912.44 1606.12h43.57v-34.67h-43.57z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1973.3 1568.01h416.04v-434.46H1973.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2031.12 1552.73h344.05v-368.24h-344.05z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1978.01 1600.9h19.79v-20.81h-19.79z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1964.25 1584.49h16.4v-19.48h-16.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1862.63 1568.01h416.04v-434.46h-416.04z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1876.8 1552.73h344.05v-368.24H1876.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2254.17 1600.9h19.79v-20.81h-19.79z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2271.32 1584.49h16.4v-19.48h-16.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2028.34 1202.53h204.21v-55.25h-204.21z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M0 198.437h291.042v-66.139H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M0 132.298h291.042V66.14H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M0 66.14h291.042V0H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.07 0 0 -.07 -3.307 198.466)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M2493.016 985.422c1.904 2.46 1.844 6-.346 8.127l-715.049 697.004c-2.204 2.13-5.607 1.965-7.587-.375-2.01-2.354-1.844-5.982.344-8.127l715.051-696.988a5.4 5.4 0 0 1 2.594-1.41s3.09-.66 4.993 1.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2493.016 985.422c1.904 2.46 1.844 6-.346 8.127l-715.049 697.004c-2.204 2.13-5.607 1.965-7.587-.375-2.01-2.354-1.844-5.982.344-8.127l715.051-696.988a5.4 5.4 0 0 1 2.594-1.41s3.09-.66 4.993 1.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M2555.333 1077.518c1.8.18 3.493 1.29 4.364 3.15 1.35 2.847.269 6.296-2.37 7.736l-876.554 473.003c-2.653 1.425-5.877.286-7.212-2.549s-.27-6.282 2.37-7.72l876.552-473.02a5.4 5.4 0 0 1 2.85-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2555.333 1077.518c1.8.18 3.493 1.29 4.364 3.15 1.35 2.847.269 6.296-2.37 7.736l-876.554 473.003c-2.653 1.425-5.877.286-7.212-2.549s-.27-6.282 2.37-7.72l876.552-473.02a5.4 5.4 0 0 1 2.85-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M2535.014 1022.999c1.8-.091 3.614.78 4.694 2.52 1.68 2.637 1.02 6.208-1.424 7.976l-813.158 588.58c-2.46 1.785-5.804 1.08-7.453-1.544-1.664-2.624-1.019-6.193 1.425-7.977l813.16-588.595c.853-.601 1.797-.931 2.756-.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2535.014 1022.999c1.8-.091 3.614.78 4.694 2.52 1.68 2.637 1.02 6.208-1.424 7.976l-813.158 588.58c-2.46 1.785-5.804 1.08-7.453-1.544-1.664-2.624-1.019-6.193 1.425-7.977l813.16-588.595c.853-.601 1.797-.931 2.756-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2067.028 1284.38c2.999-34.816 5.127-114.107 5.623-128.473.494-14.363 27.604-49.84 29.958-27.288 2.369 22.58-15.563 150.003-15.563 150.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2079.667 1287.468c7.542-49.69 12.64-178.492 25.7-182.092 13.076-3.568 21.068-2.608 24.891 8.518 3.838 11.125-12.55 66.126-12.55 66.126l-19.763 68.613-5.938 39.436Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2136.497 1106.937c-14.53.21-18.818 0-27.965 49.032-9.131 49.031-14.155 90.206-20.977 86.427-6.823-3.81-11.757-1.71-13.75 6.807-1.98 8.516-9.162 31.19-6.928 38.775 2.219 7.587 28.579 4.38 28.579 4.38l23.393-101.782Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M1758.954 985.422c-1.904 2.46-1.844 6 .346 8.127l715.049 697.004c2.203 2.13 5.606 1.965 7.586-.375 2.01-2.354 1.845-5.982-.343-8.127L1766.54 985.063a5.37 5.37 0 0 0-2.593-1.41s-3.09-.66-4.993 1.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1758.954 985.422c-1.904 2.46-1.844 6 .346 8.127l715.049 697.004c2.203 2.13 5.606 1.965 7.586-.375 2.01-2.354 1.845-5.982-.343-8.127L1766.54 985.063a5.37 5.37 0 0 0-2.593-1.41s-3.09-.66-4.993 1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2493.826 1576.912c-3.313 38.97-22.491 67.534-21.337 113.867l-94.87-92.53c11.097-15.88 30.32-48.162 34.938-87.567 45.448 36.526 81.269 66.23 81.269 66.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "m2303.353 1525.797-106.836-104.227c12.282-10.377 20.514-28.812 29.24-44.255 3.48-6.088 46.392 24.058 96.908 62.668-.014 15.79 1.034 35.148-19.312 85.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m2377.62 1598.249-74.267-72.452c20.346-50.666 19.298-70.025 19.313-85.813 29.494 22.536 61.553 47.937 89.892 70.698-4.62 39.405-23.842 71.688-34.938 87.567"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2466.747 1676.684c-27.246-67.354-128.742-171.325-255.01-253.194 58.794 24.53 198.87 135.684 223.852 167.232 31.832 40.185 31.158 85.962 31.158 85.962"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M1696.637 1077.518c-1.8.18-3.493 1.29-4.364 3.15-1.349 2.847-.27 6.296 2.37 7.736l876.554 473.003c2.653 1.425 5.893.286 7.212-2.549 1.334-2.834.27-6.282-2.369-7.72l-876.553-473.02a5.4 5.4 0 0 0-2.85-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1696.637 1077.518c-1.8.18-3.493 1.29-4.364 3.15-1.349 2.847-.27 6.296 2.37 7.736l876.554 473.003c2.653 1.425 5.893.286 7.212-2.549 1.334-2.834.27-6.282-2.369-7.72l-876.553-473.02a5.4 5.4 0 0 0-2.85-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m2501.098 1234.299 54.534 2.729-4.018 91.945-54.536-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2163.89 1181.188c45.148-48.37 131.456-130.149 245.877-115.846 61.328 7.677 96.653 30.47 125.397 59.558 28.761 29.06 16.151 32.237 34.922 45.464 18.79 13.224 23.557 49.99 23.796 50.77.226.78-1.529 13.734 7.378 28.758 8.892 15.025 10.301 37.756 7.347 45.074-2.954 7.316 5.323 29.99 5.084 36.136-.24 6.117-6.868 25.7-7.978 34.847-1.095 9.176-3.194 30.078-3.194 30.078-1.994 32.411-18.127 155.5-15.339 175.697l-78.96-41.819c3.284-58.014 8.712-177.84 15.82-195.384 7.121-17.543 20.976-37.756 12.294-51.82-21.516-34.818 9.852-39.405-20.976-47.082-21.023-5.248-351.469-54.43-351.469-54.43"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2613.691 1331.102c-.24 6.117-6.868 25.7-7.978 34.847-1.095 9.176-3.194 30.078-3.194 30.078-.689 11.268-3.088 33.505-5.817 58.561-9.072-15.819-18.338-36.45-17.979-44.564.541-12.377-25.985-34.448-52.525-48.034-3.597-1.86-5.652-2.968-6.507-3.569.031-.21.045-.358.075-.569 4.814.54 41.684 13.404 61.641 7.048 26.225-8.338 32.584-18.054 16.09-29.06-12.836-8.546-40.035-19.702-62.572-25.46-6.402-1.649-12.446-2.879-17.663-3.449-23.556-2.579-44.653-28.19-2.774-18.412 8.082 1.888 16.344 4.557 24.411 7.526 33.752 12.356 64.205 29.87 64.491 16.884.315-14.635-14.29-46.422-73.892-64.775-6.029-1.86-12.506-3.57-19.479-5.128-27.228-6.028-39.046-11.397-41.818-15.474-4.964-7.348 19.267-10.587 37.036-6.239 27.663 6.748 93.113 18.473 79.74-3.688-13.375-22.162-69.724-28.82-100.613-27.29-30.903 1.53-9.836-21.202 15.265-21.503 25.115-.268 37.71 5.818 37.231-9.625-.735-23.81-111.229-153.482-273.798-40.575-24.62 17.094-45.642 20.574-57.547 25.101 48.116-36.347 118.755-89.097 204.252-78.39 61.328 7.676 96.653 30.468 125.398 59.557 28.76 29.06 12.22 29.27 31.007 42.464 18.775 13.225 27.471 52.99 27.71 53.77.226.78-1.529 13.734 7.378 28.758 8.892 15.025 10.301 37.756 7.347 45.074-2.954 7.316 5.323 29.99 5.084 36.136"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2524.73 1436.834c-13.12-33.362 16.552-13.599 42.27 11.546 10.854 10.617 19.941 18.923 27.647 25.116-1.35 12.594-2.697 25.355-3.883 37.396-25.416-20.888-56.588-50.02-66.035-74.058"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2582.681 1545.138c-14.304-22.4-34.17-46.332-74.295-68.075-40.126-21.755.074-1.543.074-1.543l8.052 31.233c21.651 10.841 77.341 55.9 66.17 38.385"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M1716.954 1022.999c-1.798-.091-3.613.78-4.692 2.52-1.68 2.637-1.02 6.208 1.424 7.976l813.158 588.58c2.459 1.785 5.801 1.08 7.452-1.544 1.665-2.624 1.019-6.193-1.425-7.977l-813.158-588.595c-.854-.601-1.8-.931-2.759-.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1716.954 1022.999c-1.798-.091-3.613.78-4.692 2.52-1.68 2.637-1.02 6.208 1.424 7.976l813.158 588.58c2.459 1.785 5.801 1.08 7.452-1.544 1.665-2.624 1.019-6.193-1.425-7.977l-813.158-588.595c-.854-.601-1.8-.931-2.759-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2081.062 1312.329c-.135.21-.284.42-.42.6.12-.21.269-.39.42-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2267.322 1218.82c35.161-.54 53.919 13.437 64.504 17.034 10.602 3.63 21.863 24.89 25.611 37.365 3.764 12.447 7.888 16.496 9.087 21.923 1.199 5.457.27 10.016 0 16.135-.255 6.117 4.078 21.682 4.333 32.446.24 10.738-14.184 29.21-11.41 47.743 2.773 18.57-1.17 42.92-9.117 60.943-5.113 11.562-6.523 26.467-6.853 39.512l-131.98-95.506c42.419-34.788-8.127-157.772-96.487-88.53-4.395 1.622-14.126 11.548-27.71 10.888-7.768-.39-7.947-2.908-6.688-4.978 38.565-6.567 65.45-43.483 98.093-68.704 32.657-25.221 53.47-25.73 88.617-26.27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2536.26 1397.226c.3 9.23-1.485 33.686-3.989 42.008-2.518 8.306-8.276 8.785-7.24 34.157 1.048 25.385 1.228 37.665.208 44.518s7.377 54.04-1.8 103.476l-88.3-63.905c3.179-18.204 4.858-51.672 6.356-59.109 1.83-9.116 8.518-31.038 6.328-46.498-2.188-15.458 7.438-38.759 10.527-43.963 3.09-5.217-1.334-51.467-4.798-70.84-3.448-19.343 8.052-36.437.479-59.827-13.945-58.239-68.54-121.604-140.766-125.984-72.228-4.377-159.614 75.661-176.903 93.956-16.63 17.633-37.426 40.724-53.77 64.895-2.804 0-12.656-.57-11.051-9.056 1.875-9.867-10.257 4.858-2.354-11.606 7.886-16.493 47.337-65.946 79.575-98.094 32.223-32.147 107.06-104.899 205.003-97.132 78.599 6.236 126.087 51.58 137.843 94.374 3.568 12.985 26.014 28.158 27.423 45.104 1.41 16.943-5.907 20.421 2.684 36.975 8.593 16.523 9.807 28.07 10.047 32.717.735 15.175 7.197 31.818 7.092 67.115-.045 16.553-2.908 17.484-2.594 26.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m2080.612 1312.989.03-.06zM2081.062 1312.329c.494-.75 1.02-1.47 1.529-2.22.45 0 .75-.028.75-.028s-1.32.989-2.28 2.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2313.264 1151.26c72.228 4.38 126.821 67.744 140.766 125.982 7.573 23.391-3.927 40.485-.479 59.828 3.464 19.373 7.888 65.623 4.798 70.84-3.089 5.203-12.715 28.505-10.526 43.963 2.19 15.46-4.497 37.382-6.329 46.497-1.498 7.438-3.177 40.906-6.356 59.11l-91.66-66.366c.33-13.045 1.738-27.949 6.851-39.51 7.948-18.024 11.891-42.374 9.118-60.945-2.775-18.532 11.65-37.005 11.41-47.742-.255-10.765-4.588-26.33-4.333-32.447.27-6.118 1.2-10.677 0-16.134-1.199-5.428-5.323-9.476-9.087-21.923-3.748-12.475-15.009-33.736-25.61-37.366-10.586-3.598-29.344-17.572-64.505-17.032-35.148.54-55.96 1.05-88.618 26.27-32.642 25.22-59.527 62.136-98.093 68.703l.031-.059c.135-.18.284-.39.42-.6.96-1.259 2.28-2.249 2.28-2.249s-.302.03-.75.03c16.343-24.17 37.14-47.262 53.77-64.895 17.288-18.295 104.674-98.333 176.902-93.956"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2230.33 1391.89c117.092 60.33 282.044 190.585 288.027 217.74.299-23.002-102.215-154.727-288.026-217.74"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2518.927 1547.507c-17.153-35.252-96.25-140.362-230.747-167.045 52.21 3.12 226.264 56.343 230.747 167.045"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2521.236 1494.683c13.87-36.136-57.924-183.972-236.7-161.841 74.521 1.019 198.403 54.039 236.7 161.84"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2528.283 1432.127c-2.969-30.844-86.231-143.218-245.518-124.326 31.668-19.133 177.039-15.084 238.021 65.945 9.401 14.725 15.443 40.359 7.497 58.38"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2534.07 1365.888c-10.945-29.179-50.515-107.869-208.436-87.387 43.11-18.563 146.315-34.126 195.496 22.072 8.862 10.407 12.94 65.315 12.94 65.315"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2305.722 1265.217c117.436-36.316 159.824-21.92 208.091 5.817-.795-14.604-56.678-100.283-208.09-5.817"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2504.052 1215.286c-16.703-11.576-119.16-45.853-265.806 61.117 27.322-34.697 120.72-104.421 223.132-101.601 15.774.03 18.247-.87 16.208-9.927 8.878 9.656 7.889 16.493 11.803 25.13 3.927 8.636 14.662 25.28 14.662 25.28"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2465.277 1151.2c-17.454-6.088-165.343-22.852-263.525 123.374 11.56-34.697 60.142-128.952 162.733-146.824 33.272-4.14 77.655-21.443 100.792 23.45"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2095.456 1292.357c51.596-111.049 214.014-209.44 305.734-184.25-28.234-11.516-115.336-21.203-186.453 33.616-71.105 54.85-119.28 150.634-119.28 150.634"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2176.666 1287.56c-9.491-2.97 23.376-22.884 20.213-16.135-3.165 6.746-4.934 14.334-.676 15.323 4.275.991 17.918-15.984 10.737.54-7.168 16.525 22.715-11.156 22.715-11.156s-6.777 7.347-2.428 12.176c4.334 4.8 40.125-21.8 40.125-21.8s-15.01 15.382-23.107 26.93c-8.097 11.543 35.733-4.05 35.733-4.05s-7.184.42-24.306 14.904c-17.124 14.485 24.739 8.158 24.739 8.158s-3.193 7.496-16.448 15.143c-13.24 7.647 35.147 16.494 35.147 16.494s-26.165 7.887-32.222 15.264c-6.06 7.348 36.076 11.006 23.21 10.347-32.538-1.62-71.57 18.802-70.354 16.433 13.195-25.4 8.442-82.439-43.078-98.572"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M2545.271 1624.894c7.092 3.6 11.396-.735 15.055-4.813 8.172 23.78 36.931 45.657 44.307 51.835-8.127-4.978-37.904-25.265-61.565-24.396 2.158-5.158 4.288-11.05-1.485-16.733Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2545.271 1624.894c7.092 3.6 11.396-.735 15.055-4.813 8.172 23.78 36.931 45.657 44.307 51.835-8.127-4.978-37.904-25.265-61.565-24.396 2.158-5.158 4.288-11.05-1.485-16.733Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M2537.16 1633.515c3.014 2.174 7.437.795 9.866-3.074 2.445-3.867 1.964-8.787-1.05-10.946-3.014-2.174-7.437-.793-9.867 3.074-2.442 3.883-1.978 8.787 1.05 10.946"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2537.16 1633.515c3.014 2.174 7.437.795 9.866-3.074 2.445-3.867 1.964-8.787-1.05-10.946-3.014-2.174-7.437-.793-9.867 3.074-2.442 3.883-1.978 8.787 1.05 10.946ZM2543.698 1647.16l16.537-26.314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M2536.364 1622.764c-6.896 10.977-7.661 24.441-3.134 35.777-9.911-10.676-11.755-27.679-3.596-40.635 8.14-12.954 23.554-17.544 36.525-11.74-11.516-.21-22.896 5.608-29.795 16.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2536.364 1622.764c-6.896 10.977-7.661 24.441-3.134 35.777-9.911-10.676-11.755-27.679-3.596-40.635 8.14-12.954 23.554-17.544 36.525-11.74-11.516-.21-22.896 5.608-29.795 16.598Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m2531.027 1510.591 3.51.54c-2.566 18.923-1.996 86.263-1.336 96.46l-3.539.253c-.674-10.54-1.289-77.655 1.365-97.253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "m2531.027 1510.591 3.51.54c-2.566 18.923-1.996 86.263-1.336 96.46l-3.539.253c-.674-10.54-1.289-77.655 1.365-97.253Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2527.038 1500.545c-.66 95.274 1.005 101.347 2.505 106.701.194.749.419 1.529.629 2.518l-3.464.824a30 30 0 0 0-.57-2.263c-1.618-5.893-3.313-11.965-2.64-107.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2527.038 1500.545c-.66 95.274 1.005 101.347 2.505 106.701.194.749.419 1.529.629 2.518l-3.464.824a30 30 0 0 0-.57-2.263c-1.618-5.893-3.313-11.965-2.64-107.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2524.564 1625.763c1.14-4.692 3.554-10.572 8.742-14.694 5.188-4.138.404-8.036-2.984-5.293-3.373 2.758-9.042 9.011-9.146 13.735-.106 4.738 1.394 6.447 3.388 6.252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2524.564 1625.763c1.14-4.692 3.554-10.572 8.742-14.694 5.188-4.138.404-8.036-2.984-5.293-3.373 2.758-9.042 9.011-9.146 13.735-.106 4.738 1.394 6.447 3.388 6.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2536.32 1510.862c2.25-5.639 11.666-38.82 15.325-41.476-4.799-1.662-8.097-2.067-11.096-4.347-3-2.294-3.855-3.043-7.183-2.968 0 0-6.807 39.24-3.839 47.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2536.32 1510.862c2.25-5.639 11.666-38.82 15.325-41.476-4.799-1.662-8.097-2.067-11.096-4.347-3-2.294-3.855-3.043-7.183-2.968 0 0-6.807 39.24-3.839 47.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 1.556,
    d: "m2531.7 1509.782 8.864-32.657M2541.807 1486.795l4.89-18.952M2539.68 1464.38l-8.819 38.325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2527.953 1509.917c.225-1.68 2.58-2.699 5.248-2.278 2.669.403 4.648 2.114 4.424 3.792-.226 1.68-2.58 2.7-5.248 2.294-2.67-.419-4.65-2.114-4.424-3.808"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2527.953 1509.917c.225-1.68 2.58-2.699 5.248-2.278 2.669.403 4.648 2.114 4.424 3.792-.226 1.68-2.58 2.7-5.248 2.294-2.67-.419-4.65-2.114-4.424-3.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2529.213 1500.651c1.44-6.957 3.014-7.588 5.952-44.414-5.232-1.693-6.686 1.095-9.146 1.68-2.458.585-10.511-2.759-10.33 3.223.179 5.984 4.812 35.507 7.36 39.212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2529.213 1500.651c1.44-6.957 3.014-7.588 5.952-44.414-5.232-1.693-6.686 1.095-9.146 1.68-2.458.585-10.511-2.759-10.33 3.223.179 5.984 4.812 35.507 7.36 39.212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 1.556,
    d: "m2528.057 1487.156-.284-23.946M2531.282 1469.072l.599-13.375M2525.824 1497.936l-2.594-26.885M2518.7 1463.33l-.044-5.759"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2520.126 1501.041c-.016-1.71 2.159-3.105 4.858-3.134 2.7-.015 4.889 1.334 4.905 3.043.013 1.695-2.161 3.09-4.86 3.12-2.698.03-4.887-1.336-4.903-3.029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2520.126 1501.041c-.016-1.71 2.159-3.105 4.858-3.134 2.7-.015 4.889 1.334 4.905 3.043.013 1.695-2.161 3.09-4.86 3.12-2.698.03-4.887-1.336-4.903-3.029Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M2492.207 1696.178c6.552 4.647 11.395 1.019 15.55-2.445 4.887 24.77 30.423 50.846 36.9 58.089-7.378-6.164-34.128-30.815-57.653-33.603 2.835-4.768 5.727-10.271.765-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2492.207 1696.178c6.552 4.647 11.395 1.019 15.55-2.445 4.887 24.77 30.423 50.846 36.9 58.089-7.378-6.164-34.128-30.815-57.653-33.603 2.835-4.768 5.727-10.271.765-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M2483.03 1703.465c2.699 2.609 7.242 1.933 10.182-1.53 2.922-3.463 3.118-8.381.434-11.005-2.699-2.611-7.257-1.92-10.197 1.528-2.923 3.465-3.118 8.397-.419 11.006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2483.03 1703.465c2.699 2.609 7.242 1.933 10.182-1.53 2.922-3.463 3.118-8.381.434-11.005-2.699-2.611-7.257-1.92-10.197 1.528-2.923 3.465-3.118 8.397-.419 11.006ZM2487.664 1717.964l19.897-23.497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M2483.69 1692.698c-8.307 9.791-10.87 23.016-7.918 34.921-8.366-12.085-7.9-29.194 1.89-40.77 9.806-11.56 25.671-13.734 37.725-5.997-11.349-1.979-23.39 2.04-31.697 11.846"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2483.69 1692.698c-8.307 9.791-10.87 23.016-7.918 34.921-8.366-12.085-7.9-29.194 1.89-40.77 9.806-11.56 25.671-13.734 37.725-5.997-11.349-1.979-23.39 2.04-31.697 11.846Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2471.74 1578.35c-1.2 95.275.435 101.348 1.904 106.716.195.764.404 1.545.599 2.535l-3.448.794c-.18-.87-.36-1.545-.555-2.264-1.604-5.908-3.254-11.996-2.055-107.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2471.74 1578.35c-1.2 95.275.435 101.348 1.904 106.716.195.764.404 1.545.599 2.535l-3.448.794c-.18-.87-.36-1.545-.555-2.264-1.604-5.908-3.254-11.996-2.055-107.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2471.605 1693.853c1.753-4.468 4.933-9.911 10.63-13.195 5.683-3.298 1.47-7.902-2.248-5.698-3.705 2.22-10.166 7.528-10.902 12.19-.75 4.664.525 6.583 2.52 6.703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2471.605 1693.853c1.753-4.468 4.933-9.911 10.63-13.195 5.683-3.298 1.47-7.902-2.248-5.698-3.705 2.22-10.166 7.528-10.902 12.19-.75 4.664.525 6.583 2.52 6.703Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2473.914 1578.486c1.483-6.957 3.059-7.586 6.207-44.383-5.233-1.724-6.702 1.05-9.161 1.62-2.46.57-10.496-2.819-10.347 3.148.135 5.983 4.618 35.553 7.138 39.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2473.914 1578.486c1.483-6.957 3.059-7.586 6.207-44.383-5.233-1.724-6.702 1.05-9.161 1.62-2.46.57-10.496-2.819-10.347 3.148.135 5.983 4.618 35.553 7.138 39.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 1.556,
    d: "m2472.834 1564.976-.15-23.945M2476.162 1546.908l.66-13.359M2470.524 1575.742l-2.43-26.915M2463.597 1541.09v-5.757"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2464.812 1578.8c0-1.693 2.174-3.087 4.873-3.087 2.698-.015 4.888 1.348 4.903 3.059 0 1.709-2.189 3.088-4.874 3.088-2.699.015-4.886-1.364-4.902-3.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2464.812 1578.8c0-1.693 2.174-3.087 4.873-3.087 2.698-.015 4.888 1.348 4.903 3.059 0 1.709-2.189 3.088-4.874 3.088-2.699.015-4.886-1.364-4.902-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M2607.783 1571.62c7.467 2.593 11.216-2.28 14.35-6.824 10.93 22.462 42.058 40.245 50.11 45.358-8.65-3.823-40.589-19.882-63.95-15.804 1.529-5.397 2.924-11.544-3.48-16.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2607.783 1571.62c7.467 2.593 11.216-2.28 14.35-6.824 10.93 22.462 42.058 40.245 50.11 45.358-8.65-3.823-40.589-19.882-63.95-15.804 1.529-5.397 2.924-11.544-3.48-16.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M2600.75 1581.276c3.255 1.738 7.483-.226 9.433-4.41 1.949-4.167.898-8.965-2.34-10.705-3.27-1.739-7.482.224-9.431 4.393-1.965 4.184-.915 8.982 2.339 10.722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2600.75 1581.276c3.255 1.738 7.483-.226 9.433-4.41 1.949-4.167.898-8.965-2.34-10.705-3.27-1.739-7.482.224-9.431 4.393-1.965 4.184-.915 8.982 2.339 10.722ZM2608.862 1593.9l13.271-28.354"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M2598.681 1570.704c-5.532 11.831-4.679 25.295 1.154 35.926-11.094-9.236-14.949-25.864-8.41-39.824 6.537-13.96 21.276-20.602 34.83-16.615-11.44 1.35-22.025 8.683-27.574 20.513"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M2598.681 1570.704c-5.532 11.831-4.679 25.295 1.154 35.926-11.094-9.236-14.949-25.864-8.41-39.824 6.537-13.96 21.276-20.602 34.83-16.615-11.44 1.35-22.025 8.683-27.574 20.513Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m2598.277 1451.379 3.448.81c-3.838 19.912-7.827 91.48-7.856 102.351l-3.539.03c.03-11.245 3.958-82.544 7.947-103.191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.605,
    d: "m2598.277 1451.379 3.448.81c-3.838 19.912-7.827 91.48-7.856 102.351l-3.539.03c.03-11.245 3.958-82.544 7.947-103.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2594.962 1440.449c-7.105 101.12-5.831 107.689-4.723 113.477.166.809.33 1.648.466 2.714l-3.51.645c-.12-.93-.254-1.665-.404-2.444-1.23-6.358-2.505-12.926 4.634-114.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.605,
    d: "M2594.962 1440.449c-7.105 101.12-5.831 107.689-4.723 113.477.166.809.33 1.648.466 2.714l-3.51.645c-.12-.93-.254-1.665-.404-2.444-1.23-6.358-2.505-12.926 4.634-114.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2587.345 1575.292c.557-4.813 2.266-10.96 6.929-15.759 4.648-4.812-.571-8.037-3.6-4.843-3.013 3.194-7.901 10.166-7.435 14.875.448 4.707 2.158 6.192 4.106 5.727"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2587.345 1575.292c.557-4.813 2.266-10.96 6.929-15.759 4.648-4.812-.571-8.037-3.6-4.843-3.013 3.194-7.901 10.166-7.435 14.875.448 4.707 2.158 6.192 4.106 5.727Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2603.614 1451.379c2.564-5.458 13.991-37.906 17.814-40.32-4.694-1.979-7.962-2.624-10.826-5.097-2.85-2.49-3.659-3.3-6.988-3.464 0 0-9.19 38.671-6.702 46.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2603.614 1451.379c2.564-5.458 13.991-37.906 17.814-40.32-4.694-1.979-7.962-2.624-10.826-5.097-2.85-2.49-3.659-3.3-6.988-3.464 0 0-9.19 38.671-6.702 46.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 1.556,
    d: "m2599.055 1449.985 10.826-31.969M2610.542 1427.748l6.042-18.562M2609.793 1405.242l-11.141 37.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2595.307 1449.865c.33-1.665 2.744-2.52 5.368-1.919 2.654.6 4.528 2.442 4.184 4.093-.33 1.665-2.73 2.518-5.367 1.92-2.64-.6-4.515-2.429-4.185-4.094"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2595.307 1449.865c.33-1.665 2.744-2.52 5.368-1.919 2.654.6 4.528 2.442 4.184 4.093-.33 1.665-2.73 2.518-5.367 1.92-2.64-.6-4.515-2.429-4.185-4.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2597.123 1440.719c1.873-6.853 3.478-7.378 8.65-43.912-5.127-2.07-6.731.63-9.22 1.02-2.504.419-10.331-3.48-10.511 2.519-.18 5.96 2.639 35.754 4.962 39.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2597.123 1440.719c1.873-6.853 3.478-7.378 8.65-43.912-5.127-2.07-6.731.63-9.22 1.02-2.504.419-10.331-3.48-10.511 2.519-.18 5.96 2.639 35.754 4.962 39.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 1.556,
    d: "m2596.807 1427.163 1.17-23.916M2593.914 1437.765l-.944-27.02M2588.905 1402.737l.314-5.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2588.036 1440.449c.089-1.695 2.339-2.924 5.038-2.774 2.699.165 4.798 1.664 4.707 3.373-.09 1.694-2.338 2.94-5.037 2.774-2.7-.15-4.8-1.664-4.708-3.373"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M2588.036 1440.449c.089-1.695 2.339-2.924 5.038-2.774 2.699.165 4.798 1.664 4.707 3.373-.09 1.694-2.338 2.94-5.037 2.774-2.7-.15-4.8-1.664-4.708-3.373Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2519.766 1357.852c-.03.211-.044.36-.075.57-.645-.48-.585-.63.075-.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2085.066 1270.466c13.12-49.992 49.945-142.507 50.216-271.398.464-10.345 15.383-15.354 15.188-25.13-.209-9.807-3.238-9.957.751-17.245 2.294 7.019 9.7 9.687 9.402 16.584-.3 6.897-6.374 22.701.36 28.79 6.716 6.086 16.073 13.464 12.953 35.745-3.134 22.313-54.594 215.38-81.104 231.334-26.509 15.924-7.766 1.32-7.766 1.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2219.37 1017.577c1.305 6.957-6.388 25.094 1.064 26.594 7.467 1.529 19.553 7.888 15.22 20.9-4.335 13.046-32.134 74.073-60.772 110.929-28.64 36.856-58.358 67.835-58.358 67.835 16.478-44.622 68.059-197.175 73.666-221.317 2.655-11.365 29.18-4.941 29.18-4.941"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.334,
    d: "M2159.722 1018.41c-6.327-9.327-27.395-12.895-17.709-25.34"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.334,
    d: "M2203.281 1030.766c-11.081 5.667 27.38 37.814 29.208 30.618 2.055-8.486-6.673-9.476-6.088-12.025"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2102.368 1247.733c12.835-35.025 47.727-144.335 48.881-195.495.51-11.487 21.383-9.297 16.93-18.143-4.454-8.878-17.153-13.525-7.197-32.029 8.426 3.869 23.466 8.098 22.43-6.928-1.035-15.024 6.837-10.585 10.481-8.096 3.66 2.489 12.146 5.188 4.29 12.866-7.874 7.677-1.095 12.594 5.878 12.954s12.925-.51 14.904 3.63c1.964 4.106-1.859 5.667-6.179 6.026-4.317.36-27.514 14.155-22.49 22.462 5.007 8.308 12.415 10.977 8.651 23.451-3.778 12.476-43.079 111.769-65.525 145.745-22.462 34.007-31.054 33.557-31.054 33.557"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2184.942 1284.38c-2.999-34.816-5.113-114.107-5.623-128.473-.494-14.363-27.604-49.84-29.957-27.288-2.369 22.58 15.562 150.003 15.562 150.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2172.303 1287.468c-7.543-49.69-12.64-178.492-25.7-182.092-13.06-3.568-21.069-2.608-24.892 8.518-3.822 11.125 12.552 66.126 12.552 66.126l19.762 68.613 5.937 39.436z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2115.473 1106.937c14.53.21 18.818 0 27.965 49.032 9.131 49.031 14.155 90.206 20.992 86.427 6.808-3.81 11.741-1.71 13.734 6.807 1.98 8.516 9.163 31.19 6.944 38.775-2.235 7.587-28.595 4.38-28.595 4.38l-23.392-101.782Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M1758.144 1576.912c3.313 38.97 22.491 67.534 21.336 113.867l94.87-92.53c-11.096-15.88-30.319-48.162-34.938-87.567-45.447 36.526-81.268 66.23-81.268 66.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "m1948.632 1525.797 106.819-104.227c-12.28-10.377-20.511-28.812-29.24-44.255-3.476-6.088-46.39 24.058-96.907 62.668.016 15.79-1.035 35.148 19.328 85.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m1874.35 1598.249 74.282-72.452c-20.363-50.666-19.312-70.025-19.329-85.813-29.494 22.536-61.552 47.937-89.89 70.698 4.619 39.405 23.841 71.688 34.937 87.567"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1785.223 1676.684c27.246-67.354 128.742-171.325 255.009-253.194-58.793 24.53-198.869 135.684-223.851 167.232-31.832 40.185-31.158 85.962-31.158 85.962"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m1750.871 1234.299-54.533 2.729 4.018 91.945 54.535-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2088.078 1181.188c-45.147-48.37-131.455-130.149-245.876-115.846-61.327 7.677-96.653 30.47-125.398 59.558-28.76 29.06-16.149 32.237-34.92 45.464-18.79 13.224-23.558 49.99-23.797 50.77-.226.78 1.53 13.734-7.378 28.758-8.892 15.025-10.3 37.756-7.347 45.074 2.954 7.316-5.323 29.99-5.084 36.136.24 6.117 6.868 25.7 7.978 34.847 1.094 9.176 3.194 30.078 3.194 30.078 1.993 32.411 18.127 155.5 15.34 175.697l78.96-41.819c-3.285-58.014-8.712-177.84-15.82-195.384-7.123-17.543-20.977-37.756-12.296-51.82 21.518-34.818-9.85-39.405 20.977-47.082 21.023-5.248 351.467-54.43 351.467-54.43"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1638.279 1331.102c.24 6.117 6.868 25.7 7.978 34.847 1.093 9.176 3.194 30.078 3.194 30.078.689 11.268 3.087 33.505 5.817 58.561 9.072-15.819 18.338-36.45 17.992-44.564-.554-12.377 25.972-34.448 52.512-48.034 3.613-1.86 5.652-2.968 6.507-3.569-.031-.21-.044-.358-.075-.569-4.814.54-41.684 13.404-61.627 7.048-26.24-8.338-32.597-18.054-16.104-29.06 12.835-8.546 40.035-19.702 62.572-25.46 6.402-1.649 12.446-2.879 17.663-3.449 23.556-2.579 44.653-28.19 2.775-18.412-8.083 1.888-16.345 4.557-24.412 7.526-33.751 12.356-64.205 29.87-64.491 16.884-.315-14.635 14.29-46.422 73.892-64.775 6.029-1.86 12.506-3.57 19.479-5.128 27.229-6.028 39.059-11.397 41.818-15.474 4.964-7.348-19.268-10.587-37.035-6.239-27.666 6.748-93.116 18.473-79.741-3.688 13.375-22.162 69.725-28.82 100.613-27.29 30.903 1.53 9.836-21.202-15.265-21.503-25.115-.268-37.71 5.818-37.231-9.625.735-23.81 111.229-153.482 273.798-40.575 24.62 17.094 45.642 20.574 57.547 25.101-48.117-36.347-118.756-89.097-204.252-78.39-61.328 7.676-96.653 30.468-125.398 59.557-28.76 29.06-12.22 29.27-31.008 42.464-18.773 13.225-27.47 52.99-27.71 53.77-.225.78 1.53 13.734-7.377 28.758-8.892 15.025-10.301 37.756-7.347 45.074 2.954 7.316-5.323 29.99-5.084 36.136"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1727.241 1436.834c13.12-33.362-16.555-13.599-42.27 11.546-10.855 10.617-19.942 18.923-27.648 25.116 1.348 12.594 2.697 25.355 3.882 37.396 25.416-20.888 56.588-50.02 66.036-74.058"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1669.288 1545.138c14.304-22.4 34.171-46.332 74.296-68.075 40.125-21.755-.075-1.543-.075-1.543l-8.052 31.233c-21.637 10.841-77.34 55.9-66.169 38.385"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2170.908 1312.329c.136.21.284.42.42.6-.12-.21-.271-.39-.42-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M1984.648 1218.015c-35.161-.54-53.92 13.435-64.506 17.032-10.6 3.63-21.861 24.891-25.61 37.366-3.762 12.447-7.886 16.496-9.086 21.923-1.2 5.457-.27 10.016 0 16.134.27 6.117-4.078 21.682-4.333 32.447-.241 10.737 14.184 29.21 11.41 47.743-2.773 18.57 1.17 42.92 9.117 60.943 5.113 11.562 6.523 26.466 6.853 39.511l131.98-95.506c-42.42-34.788 8.127-157.77 96.487-88.528 4.394 1.621 14.126 11.546 27.71 10.886 7.767-.389 7.947-2.908 6.688-4.977-38.565-6.568-65.435-43.484-98.093-68.704-32.66-25.22-53.47-25.73-88.617-26.27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M1715.71 1397.226c-.3 9.23 1.485 33.686 3.989 42.008 2.518 8.306 8.276 8.785 7.24 34.157-1.047 25.385-1.227 37.665-.208 44.518s-7.377 54.04 1.8 103.476l88.3-63.905c-3.178-18.204-4.858-51.672-6.343-59.109-1.843-9.116-8.53-31.038-6.34-46.498 2.187-15.458-7.438-38.759-10.527-43.963-3.09-5.217 1.334-51.467 4.797-70.84 3.449-19.343-8.051-36.437-.48-59.827 13.946-58.239 68.54-121.604 140.768-125.984 72.227-4.377 159.614 75.661 176.903 93.956 16.628 17.633 37.425 40.724 53.77 64.895 2.804 0 12.655-.57 11.05-9.056-1.874-9.867 10.257 4.858 2.354-11.606-7.888-16.493-47.337-65.946-79.575-98.094-32.222-32.147-107.044-104.899-205.002-97.132-78.6 6.236-126.088 51.58-137.843 94.374-3.568 12.985-26.014 28.158-27.424 45.104-1.41 16.943 5.907 20.421-2.684 36.975-8.592 16.523-9.807 28.07-10.046 32.717-.735 15.175-7.198 31.818-7.094 67.115.047 16.553 2.91 17.484 2.595 26.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m2171.358 1312.989-.03-.06zM2170.908 1312.329c-.494-.75-1.02-1.47-1.529-2.22-.45 0-.75-.028-.75-.028s1.32.989 2.279 2.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1938.705 1151.26c-72.228 4.38-126.82 67.744-140.766 125.982-7.573 23.391 3.928 40.485.48 59.828-3.465 19.373-7.888 65.623-4.799 70.84 3.09 5.203 12.715 28.505 10.527 43.963-2.19 15.46 4.497 37.382 6.341 46.497 1.485 7.438 3.164 40.906 6.343 59.11l91.661-66.366c-.33-13.045-1.739-27.949-6.852-39.51-7.948-18.024-11.89-42.374-9.118-60.945 2.775-18.532-11.65-37.005-11.409-47.742.255-10.765 4.603-26.33 4.333-32.447s-1.199-10.677 0-16.134c1.2-5.428 5.323-9.476 9.086-21.923 3.748-12.475 15.01-33.736 25.61-37.366 10.586-3.598 29.344-17.572 64.505-17.032 35.148.54 55.96 1.05 88.617 26.27 32.66 25.22 59.528 62.136 98.094 68.703-.016-.029-.016-.029-.03-.059-.136-.18-.285-.39-.42-.6-.959-1.259-2.28-2.249-2.28-2.249s.301.03.75.03c-16.345-24.17-37.14-47.262-53.77-64.895-17.289-18.295-104.675-98.333-176.903-93.956"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2021.64 1391.89c-117.091 60.33-282.043 190.585-288.027 217.74-.3-23.002 102.216-154.727 288.026-217.74"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1733.043 1547.507c17.154-35.252 96.25-140.362 230.748-167.045-52.21 3.12-226.265 56.343-230.748 167.045"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1730.734 1494.683c-13.87-36.136 57.924-183.972 236.7-161.841-74.52 1.019-198.39 54.039-236.7 161.84"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1723.686 1432.127c2.97-30.844 86.232-143.218 245.52-124.326-31.669-19.133-177.04-15.084-238.022 65.945-9.402 14.725-15.445 40.359-7.498 58.38"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1717.9 1365.888c10.945-29.179 50.515-107.869 208.436-87.387-43.11-18.563-146.315-34.126-195.482 22.072-8.877 10.407-12.955 65.315-12.955 65.315"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1946.247 1265.217c-117.435-36.316-159.823-21.92-208.091 5.817.796-14.604 56.694-100.283 208.09-5.817"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1747.917 1215.286c16.704-11.576 119.16-45.853 265.806 61.117-27.32-34.697-120.72-104.421-223.132-101.601-15.773.03-18.247-.87-16.208-9.927-8.876 9.656-7.887 16.493-11.801 25.13-3.928 8.636-14.665 25.28-14.665 25.28"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1786.693 1151.2c17.455-6.088 165.343-22.852 263.525 123.374-11.56-34.697-60.142-128.952-162.733-146.824-33.272-4.14-77.655-21.443-100.792 23.45"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2156.513 1292.357c-51.596-111.049-214.014-209.44-305.734-184.25 28.233-11.516 115.336-21.203 186.454 33.616 71.103 54.85 119.28 150.634 119.28 150.634"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2075.304 1287.56c9.492-2.97-23.375-22.884-20.212-16.135 3.164 6.746 4.933 14.334.675 15.323-4.275.991-17.918-15.984-10.737.54 7.168 16.525-22.717-11.156-22.717-11.156s6.778 7.347 2.43 12.176c-4.333 4.8-40.124-21.8-40.124-21.8s15.009 15.382 23.105 26.93c8.098 11.543-35.731-4.05-35.731-4.05s7.183.42 24.306 14.904-24.74 8.158-24.74 8.158 3.193 7.496 16.449 15.143c13.239 7.647-35.148 16.494-35.148 16.494s26.165 7.887 32.222 15.264c6.06 7.348-36.076 11.006-23.195 10.347 32.523-1.62 71.568 18.802 70.339 16.433-13.195-25.4-8.443-82.439 43.078-98.572"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M1706.699 1624.894c-7.092 3.6-11.396-.735-15.055-4.813-8.171 23.78-36.931 45.657-44.307 51.835 8.127-4.978 37.904-25.265 61.565-24.396-2.16-5.158-4.288-11.05 1.5-16.733Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1706.699 1624.894c-7.092 3.6-11.396-.735-15.055-4.813-8.171 23.78-36.931 45.657-44.307 51.835 8.127-4.978 37.904-25.265 61.565-24.396-2.16-5.158-4.288-11.05 1.5-16.733Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M1714.81 1633.515c-3.014 2.174-7.437.795-9.867-3.074-2.444-3.867-1.964-8.787 1.051-10.946 3.013-2.174 7.437-.793 9.88 3.074 2.43 3.883 1.965 8.787-1.064 10.946"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1714.81 1633.515c-3.014 2.174-7.437.795-9.867-3.074-2.444-3.867-1.964-8.787 1.051-10.946 3.013-2.174 7.437-.793 9.88 3.074 2.43 3.883 1.965 8.787-1.064 10.946ZM1708.272 1647.16l-16.538-26.314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M1715.605 1622.764c6.897 10.977 7.662 24.441 3.134 35.777 9.911-10.676 11.755-27.679 3.597-40.635-8.14-12.954-23.554-17.544-36.525-11.74 11.515-.21 22.896 5.608 29.794 16.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1715.605 1622.764c6.897 10.977 7.662 24.441 3.134 35.777 9.911-10.676 11.755-27.679 3.597-40.635-8.14-12.954-23.554-17.544-36.525-11.74 11.515-.21 22.896 5.608 29.794 16.598Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m1720.943 1510.591-3.508.54c2.564 18.923 1.994 86.263 1.334 96.46l3.539.253c.674-10.54 1.29-77.655-1.365-97.253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "m1720.943 1510.591-3.508.54c2.564 18.923 1.994 86.263 1.334 96.46l3.539.253c.674-10.54 1.29-77.655-1.365-97.253Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1724.932 1500.545c.658 95.274-1.006 101.347-2.505 106.701-.194.749-.42 1.529-.613 2.518l3.447.824c.18-.853.36-1.543.57-2.263 1.619-5.893 3.313-11.965 2.639-107.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1724.932 1500.545c.658 95.274-1.006 101.347-2.505 106.701-.194.749-.42 1.529-.613 2.518l3.447.824c.18-.853.36-1.543.57-2.263 1.619-5.893 3.313-11.965 2.639-107.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1727.405 1625.763c-1.124-4.692-3.553-10.572-8.74-14.694-5.189-4.138-.406-8.036 2.982-5.293 3.374 2.758 9.042 9.011 9.147 13.735.106 4.738-1.394 6.447-3.389 6.252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1727.405 1625.763c-1.124-4.692-3.553-10.572-8.74-14.694-5.189-4.138-.406-8.036 2.982-5.293 3.374 2.758 9.042 9.011 9.147 13.735.106 4.738-1.394 6.447-3.389 6.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1715.65 1510.862c-2.25-5.639-11.667-38.82-15.325-41.476 4.798-1.662 8.097-2.067 11.096-4.347 3-2.294 3.854-3.043 7.183-2.968 0 0 6.822 39.24 3.838 47.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1715.65 1510.862c-2.25-5.639-11.667-38.82-15.325-41.476 4.798-1.662 8.097-2.067 11.096-4.347 3-2.294 3.854-3.043 7.183-2.968 0 0 6.822 39.24 3.838 47.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 1.556,
    d: "m1720.268 1509.782-8.862-32.657M1710.163 1486.795l-4.89-18.952M1712.29 1464.38l8.818 38.325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1724.017 1509.917c-.225-1.68-2.58-2.699-5.249-2.278-2.669.403-4.648 2.114-4.423 3.792.225 1.68 2.58 2.7 5.248 2.294 2.67-.419 4.65-2.114 4.423-3.808"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1724.017 1509.917c-.225-1.68-2.58-2.699-5.249-2.278-2.669.403-4.648 2.114-4.423 3.792.225 1.68 2.58 2.7 5.248 2.294 2.67-.419 4.65-2.114 4.423-3.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1722.758 1500.651c-1.44-6.957-3.014-7.588-5.953-44.414 5.233-1.693 6.687 1.095 9.147 1.68 2.458.585 10.51-2.759 10.33 3.223-.18 5.984-4.812 35.507-7.362 39.212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1722.758 1500.651c-1.44-6.957-3.014-7.588-5.953-44.414 5.233-1.693 6.687 1.095 9.147 1.68 2.458.585 10.51-2.759 10.33 3.223-.18 5.984-4.812 35.507-7.362 39.212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 1.556,
    d: "m1723.912 1487.156.284-23.946M1720.688 1469.072l-.585-13.375M1726.162 1497.936l2.577-26.885M1733.268 1463.33l.045-5.759"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1731.844 1501.041c.016-1.71-2.16-3.105-4.844-3.134-2.713-.015-4.903 1.334-4.918 3.043-.014 1.695 2.16 3.09 4.858 3.12 2.7.03 4.89-1.336 4.904-3.029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1731.844 1501.041c.016-1.71-2.16-3.105-4.844-3.134-2.713-.015-4.903 1.334-4.918 3.043-.014 1.695 2.16 3.09 4.858 3.12 2.7.03 4.89-1.336 4.904-3.029Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M1759.763 1696.178c-6.551 4.647-11.396 1.019-15.55-2.445-4.887 24.77-30.422 50.846-36.885 58.089 7.363-6.164 34.113-30.815 57.639-33.603-2.835-4.768-5.727-10.271-.765-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1759.763 1696.178c-6.551 4.647-11.396 1.019-15.55-2.445-4.887 24.77-30.422 50.846-36.885 58.089 7.363-6.164 34.113-30.815 57.639-33.603-2.835-4.768-5.727-10.271-.765-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M1768.94 1703.465c-2.684 2.609-7.243 1.933-10.181-1.53-2.923-3.463-3.12-8.381-.42-11.005 2.684-2.612 7.242-1.92 10.18 1.528 2.925 3.465 3.12 8.397.42 11.006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1768.94 1703.465c-2.684 2.609-7.243 1.933-10.181-1.53-2.923-3.463-3.12-8.381-.42-11.005 2.684-2.612 7.242-1.92 10.18 1.528 2.925 3.465 3.12 8.397.42 11.006ZM1764.306 1717.964l-19.897-23.497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M1768.28 1692.698c8.307 9.791 10.87 23.016 7.917 34.921 8.368-12.085 7.902-29.194-1.89-40.77-9.806-11.56-25.67-13.734-37.724-5.997 11.35-1.979 23.39 2.04 31.697 11.846"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1768.28 1692.698c8.307 9.791 10.87 23.016 7.917 34.921 8.368-12.085 7.902-29.194-1.89-40.77-9.806-11.56-25.67-13.734-37.724-5.997 11.35-1.979 23.39 2.04 31.697 11.846Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1780.23 1578.35c1.2 95.275-.435 101.348-1.904 106.716-.195.764-.404 1.545-.6 2.535l3.45.794c.179-.87.359-1.545.554-2.264 1.604-5.908 3.254-11.996 2.055-107.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1780.23 1578.35c1.2 95.275-.435 101.348-1.904 106.716-.195.764-.404 1.545-.6 2.535l3.45.794c.179-.87.359-1.545.554-2.264 1.604-5.908 3.254-11.996 2.055-107.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1780.365 1693.853c-1.753-4.468-4.934-9.911-10.63-13.195-5.684-3.298-1.47-7.902 2.248-5.698 3.703 2.22 10.166 7.528 10.902 12.19.75 4.664-.525 6.583-2.52 6.703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1780.365 1693.853c-1.753-4.468-4.934-9.911-10.63-13.195-5.684-3.298-1.47-7.902 2.248-5.698 3.703 2.22 10.166 7.528 10.902 12.19.75 4.664-.525 6.583-2.52 6.703Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1778.056 1578.486c-1.484-6.957-3.06-7.586-6.209-44.383 5.235-1.724 6.704 1.05 9.162 1.62 2.46.57 10.497-2.819 10.348 3.148-.135 5.983-4.619 35.553-7.138 39.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1778.056 1578.486c-1.484-6.957-3.06-7.586-6.209-44.383 5.235-1.724 6.704 1.05 9.162 1.62 2.46.57 10.497-2.819 10.348 3.148-.135 5.983-4.619 35.553-7.138 39.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 1.556,
    d: "m1779.137 1564.976.149-23.945M1775.808 1546.908l-.66-13.359M1781.444 1575.742l2.43-26.915M1788.372 1541.09v-5.757"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1787.158 1578.8c0-1.693-2.174-3.087-4.874-3.087-2.7-.015-4.887 1.348-4.902 3.059 0 1.709 2.19 3.088 4.874 3.088 2.699.015 4.887-1.364 4.902-3.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1787.158 1578.8c0-1.693-2.174-3.087-4.874-3.087-2.7-.015-4.887 1.348-4.902 3.059 0 1.709 2.19 3.088 4.874 3.088 2.699.015 4.887-1.364 4.902-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M1644.187 1571.62c-7.467 2.593-11.216-2.28-14.35-6.824-10.931 22.462-42.058 40.245-50.111 45.358 8.652-3.823 40.59-19.882 63.95-15.804-1.528-5.397-2.922-11.544 3.479-16.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1644.187 1571.62c-7.467 2.593-11.216-2.28-14.35-6.824-10.931 22.462-42.058 40.245-50.111 45.358 8.652-3.823 40.59-19.882 63.95-15.804-1.528-5.397-2.922-11.544 3.479-16.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M1651.22 1581.276c-3.254 1.738-7.483-.226-9.433-4.41-1.948-4.167-.9-8.965 2.355-10.705 3.254-1.739 7.467.224 9.415 4.393 1.966 4.184.916 8.982-2.338 10.722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1651.22 1581.276c-3.254 1.738-7.483-.226-9.433-4.41-1.948-4.167-.9-8.965 2.355-10.705 3.254-1.739 7.467.224 9.415 4.393 1.966 4.184.916 8.982-2.338 10.722ZM1643.108 1593.9l-13.271-28.354"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "M1653.289 1570.704c5.532 11.831 4.679 25.295-1.155 35.926 11.11-9.236 14.949-25.864 8.41-39.824-6.536-13.96-21.275-20.602-34.83-16.615 11.44 1.35 22.026 8.683 27.575 20.513"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.223,
    d: "M1653.289 1570.704c5.532 11.831 4.679 25.295-1.155 35.926 11.11-9.236 14.949-25.864 8.41-39.824-6.536-13.96-21.275-20.602-34.83-16.615 11.44 1.35 22.026 8.683 27.575 20.513Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m1653.693 1451.379-3.45.81c3.84 19.912 7.829 91.48 7.858 102.351l3.539.03c-.03-11.245-3.958-82.544-7.947-103.191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.605,
    d: "m1653.693 1451.379-3.45.81c3.84 19.912 7.829 91.48 7.858 102.351l3.539.03c-.03-11.245-3.958-82.544-7.947-103.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1657.008 1440.449c7.106 101.12 5.832 107.689 4.723 113.477-.166.809-.33 1.648-.465 2.714l3.508.645c.12-.93.255-1.665.406-2.444 1.229-6.358 2.504-12.926-4.634-114.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.605,
    d: "M1657.008 1440.449c7.106 101.12 5.832 107.689 4.723 113.477-.166.809-.33 1.648-.465 2.714l3.508.645c.12-.93.255-1.665.406-2.444 1.229-6.358 2.504-12.926-4.634-114.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1664.623 1575.292c-.554-4.813-2.263-10.96-6.913-15.759-4.663-4.812.557-8.037 3.584-4.843 3.014 3.194 7.903 10.166 7.438 14.875-.45 4.707-2.144 6.192-4.109 5.727"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1664.623 1575.292c-.554-4.813-2.263-10.96-6.913-15.759-4.663-4.812.557-8.037 3.584-4.843 3.014 3.194 7.903 10.166 7.438 14.875-.45 4.707-2.144 6.192-4.109 5.727Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1648.356 1451.379c-2.564-5.458-13.991-37.906-17.814-40.32 4.694-1.979 7.962-2.624 10.826-5.097 2.848-2.49 3.659-3.3 6.988-3.464 0 0 9.19 38.671 6.702 46.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1648.356 1451.379c-2.564-5.458-13.991-37.906-17.814-40.32 4.694-1.979 7.962-2.624 10.826-5.097 2.848-2.49 3.659-3.3 6.988-3.464 0 0 9.19 38.671 6.702 46.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 1.556,
    d: "m1652.913 1449.985-10.825-31.969M1641.428 1427.748l-6.043-18.562M1642.177 1405.242l11.141 37.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1656.663 1449.865c-.33-1.665-2.745-2.52-5.369-1.919-2.655.6-4.528 2.442-4.184 4.093.33 1.665 2.73 2.518 5.369 1.92 2.638-.6 4.513-2.429 4.183-4.094"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1656.663 1449.865c-.33-1.665-2.745-2.52-5.369-1.919-2.655.6-4.528 2.442-4.184 4.093.33 1.665 2.73 2.518 5.369 1.92 2.638-.6 4.513-2.429 4.183-4.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1654.848 1440.719c-1.874-6.853-3.478-7.378-8.652-43.912 5.128-2.07 6.733.63 9.22 1.02 2.506.419 10.333-3.48 10.513 2.519.18 5.96-2.64 35.754-4.963 39.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1654.848 1440.719c-1.874-6.853-3.478-7.378-8.652-43.912 5.128-2.07 6.733.63 9.22 1.02 2.506.419 10.333-3.48 10.513 2.519.18 5.96-2.64 35.754-4.963 39.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 1.556,
    d: "m1655.162 1427.163-1.168-23.916M1658.057 1437.765l.943-27.02M1663.065 1402.737l-.314-5.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1663.934 1440.449c-.089-1.695-2.338-2.924-5.038-2.774-2.683.165-4.798 1.664-4.707 3.373.089 1.694 2.338 2.94 5.037 2.774 2.7-.15 4.799-1.664 4.708-3.373"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.556,
    d: "M1663.934 1440.449c-.089-1.695-2.338-2.924-5.038-2.774-2.683.165-4.798 1.664-4.707 3.373.089 1.694 2.338 2.94 5.037 2.774 2.7-.15 4.799-1.664 4.708-3.373Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.204 1357.852c.03.211.044.36.075.57.645-.48.585-.63-.075-.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2166.904 1270.466c-13.12-49.992-49.946-142.507-50.216-271.398-.464-10.345-15.384-15.354-15.188-25.13.208-9.807 3.237-9.957-.75-17.245-2.295 7.019-9.702 9.687-9.403 16.584.301 6.897 6.374 22.701-.359 28.79-6.717 6.086-16.074 13.464-12.956 35.745 3.136 22.313 54.595 215.38 81.105 231.334 26.51 15.924 7.767 1.32 7.767 1.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2032.542 1017.833c-1.304 6.957 6.446 24.838-1.007 26.338-7.466 1.529-19.552 7.888-15.22 20.9 4.334 13.046 32.135 74.074 60.773 110.929 28.64 36.856 58.358 67.835 58.358 67.835-16.478-44.622-68.06-197.175-73.666-221.316-2.655-11.366-29.238-4.686-29.238-4.686"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.334,
    d: "M2092.247 1018.41c6.327-9.327 27.395-12.895 17.71-25.34"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.334,
    d: "M2048.689 1030.766c11.08 5.667-27.38 37.814-29.208 30.618-2.055-8.486 6.672-9.476 6.088-12.025"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2149.601 1247.733c-12.82-35.025-47.727-144.335-48.882-195.495-.51-11.487-21.382-9.297-16.93-18.143 4.455-8.878 17.154-13.525 7.2-32.029-8.428 3.869-23.467 8.098-22.432-6.928 1.048-15.024-6.839-10.585-10.482-8.096-3.658 2.489-12.146 5.188-4.289 12.866 7.872 7.677 1.095 12.594-5.877 12.954-6.973.36-12.926-.51-14.905 3.63-1.963 4.106 1.86 5.667 6.18 6.026 4.317.36 27.513 14.155 22.49 22.462-5.009 8.308-12.416 10.977-8.653 23.451 3.78 12.476 43.08 111.769 65.526 145.745 22.461 34.007 31.054 33.557 31.054 33.557"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.334,
    d: "M2164.313 1044.14c-30.989 22.858 15.107 14.98 22.171-48.588"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.334,
    d: "M2190.998 1049.879c17.604 27.619-28.004.726 4.167-51.891"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.334,
    d: "M2087.585 1044.127c30.989 22.859-15.107 14.98-22.171-48.588"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.334,
    d: "M2060.9 1049.866c-17.603 27.619 28.003.726-4.167-51.891"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2303.763 1524.774-.41 1.023 74.266 72.452.65-.933z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1948.207 1524.774.41 1.023-74.267 72.452-.648-.933z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1908.493 1489.87v1.244l-91.661 66.366-.21-1.233z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2343.512 1490.704-.035 1.216 91.662 65.56.201-1.234z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292723",
    d: "M2218.063 1016.922c-1.33-2.784-5.212-2.855-10.125-2.944-1.263-.024-2.568-.047-3.929-.119-4.905-.25-8.828-2.414-9.995-5.506-.726-1.927-.715-5.08 3.47-9.16 2.112-2.066 3.091-3.85 2.906-5.305-.26-2.054-2.818-3.522-5.074-4.818-.72-.413-1.399-.803-1.986-1.203-.877-.598-3.543-2.42-5.64-2.42-.773 0-1.383.251-1.865.77-.86.92-1.804 3.204-1.415 8.852.273 3.97-.523 6.986-2.368 8.962-1.668 1.787-4.144 2.693-7.359 2.694-5.179 0-11.113-2.378-14.164-3.779l.463-.88c3.9 1.791 9.217 3.66 13.7 3.66 5.204-.002 9.286-2.518 8.731-10.588-.576-8.355 1.602-10.69 4.277-10.69 2.135 0 4.586 1.49 6.203 2.593 3.66 2.49 12.147 5.19 4.29 12.866-7.873 7.677-1.095 12.595 5.878 12.954 6.972.361 12.925-.509 14.904 3.63 0 0 1.124 2.05.11 3.521 0 0-.106.26-.76.833 0 0 .822-1.813-.252-3.923"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#S)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292723",
    d: "M2033.907 1016.922c1.332-2.784 5.212-2.855 10.125-2.944 1.263-.024 2.569-.047 3.929-.119 4.905-.25 8.828-2.414 9.994-5.506.727-1.927.716-5.08-3.468-9.16-2.114-2.066-3.092-3.85-2.907-5.305.26-2.054 2.818-3.522 5.074-4.818.72-.413 1.4-.803 1.987-1.203.876-.598 3.542-2.42 5.639-2.42.772 0 1.382.251 1.865.77.86.92 1.804 3.204 1.415 8.852-.274 3.97.523 6.986 2.368 8.962 1.668 1.787 4.144 2.693 7.359 2.694 5.178 0 11.113-2.378 14.163-3.779l-.462-.88c-3.9 1.791-9.216 3.66-13.701 3.66-5.203-.002-9.285-2.518-8.73-10.588.576-8.355-1.602-10.69-4.277-10.69-2.135 0-4.586 1.49-6.203 2.593-3.66 2.49-12.147 5.19-4.29 12.866 7.873 7.677 1.094 12.595-5.878 12.954-6.972.361-12.925-.509-14.904 3.63 0 0-1.125 2.05-.11 3.521 0 0 .106.26.76.833 0 0-.822-1.813.252-3.923"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2038.478 1170.424c-3.209-.21-6.418.089-9.477.989l1.29 4.468c10.765-3.15 23.825 2.31 29.104 12.146 5.308 9.866 1.334 21.44-10.87 31.757l2.998 3.569c19.942-16.853 15.01-31.849 11.981-37.515-4.769-8.878-14.86-14.756-25.026-15.414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2038.478 1170.424c-3.209-.21-6.418.089-9.477.989l1.29 4.468c10.765-3.15 23.825 2.31 29.104 12.146 5.308 9.866 1.334 21.44-10.87 31.757l2.998 3.569c19.942-16.853 15.01-31.849 11.981-37.515-4.769-8.878-14.86-14.756-25.026-15.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2037.069 1202.33c2.414-5.277 5.937-11.515 13.719-11.754-5.576-1.92-12.58-5.49-17.032 2.999-4.44 8.517 3.313 8.756 3.313 8.756"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2037.069 1202.33c2.414-5.277 5.937-11.515 13.719-11.754-5.576-1.92-12.58-5.49-17.032 2.999-4.44 8.517 3.313 8.756 3.313 8.756Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M1909.632 1054.966c17.648 26.75 34.562 52.72 40.86 63.247 6.297 10.496 25.054 32.087 40.004 40.754 14.965 8.666 15.67 21.502 18.158 30.798 2.49 9.297 8.442 48.522 23.856 61.957 15.414 13.464 9.326-.15 22.266 15.443 12.941 15.624 240.96 289.548 240.96 289.548l11.394-7.992-212.093-267.999.255-3.87s-41.985-46.273-42.39-51.73c-.42-5.458-4.229-6.477-6.297-10.496-2.07-4.019-13.57-17.993-13.676-39.735-.12-21.74-11.709-22.522-14.348-29.659-2.624-7.168-42-104.69-49.932-125.682-11.56 10.585-59.017 35.416-59.017 35.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272425",
    strokeWidth: 1.549,
    d: "M1909.632 1054.966c17.648 26.75 34.562 52.72 40.86 63.247 6.297 10.496 25.054 32.087 40.004 40.754 14.965 8.666 15.67 21.502 18.158 30.798 2.49 9.297 8.442 48.522 23.856 61.957 15.414 13.464 9.326-.15 22.266 15.443 12.941 15.624 240.96 289.548 240.96 289.548l11.394-7.992-212.093-267.999.255-3.87s-41.985-46.273-42.39-51.73c-.42-5.458-4.229-6.477-6.297-10.496-2.07-4.019-13.57-17.993-13.676-39.735-.12-21.74-11.709-22.522-14.348-29.659-2.624-7.168-42-104.69-49.932-125.682-11.56 10.585-59.017 35.416-59.017 35.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1972.937 1030.616a1560 1560 0 0 1-4.289-11.065c-11.56 10.585-59.016 35.416-59.016 35.416a6149 6149 0 0 1 10.015 15.205c33.56-20.364 53.29-39.556 53.29-39.556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M1972.937 1030.616a1560 1560 0 0 1-4.289-11.065c-11.56 10.585-59.016 35.416-59.016 35.416a6149 6149 0 0 1 10.015 15.205c33.56-20.364 53.29-39.556 53.29-39.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M1919.647 1070.172a6053 6053 0 0 0-10.015-15.206s18.187-9.536 34.802-19.281c-.796 5.966-12.806 15.534-15.28 17.692-2.475 2.159-3.988 5.519-4.199 8.697-.209 3.177-5.308 8.097-5.308 8.097"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272425",
    strokeWidth: 1.549,
    d: "M1919.647 1070.172a6053 6053 0 0 0-10.015-15.206s18.187-9.536 34.802-19.281c-.796 5.966-12.806 15.534-15.28 17.692-2.475 2.159-3.988 5.519-4.199 8.697-.209 3.177-5.308 8.097-5.308 8.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2042.286 1232.98 4.978-4.858 45.898 57.427-4.018 5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2042.286 1232.98 4.978-4.858 45.898 57.427-4.018 5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2049.874 1261.738-4.064 4.078 252.595 305.518 2.938-5.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2049.874 1261.738-4.064 4.078 252.595 305.518 2.938-5.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2136.242 1330.472c1.095-.959 1.274-2.549.403-3.539l-6.476-7.467c-.886-1.019-2.475-1.05-3.583-.119l-21.383 18.562c-1.095.96-1.274 2.55-.405 3.54l6.478 7.466c.869 1.02 2.473 1.05 3.568.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.262,
    d: "M2136.242 1330.472c1.095-.959 1.274-2.549.403-3.539l-6.476-7.467c-.886-1.019-2.475-1.05-3.583-.119l-21.383 18.562c-1.095.96-1.274 2.55-.405 3.54l6.478 7.466c.869 1.02 2.473 1.05 3.568.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2224.557 1441.498a2.417 2.417 0 0 0 .24-3.403l-6.477-7.468a2.406 2.406 0 0 0-3.404-.255l-19.507 16.914a2.404 2.404 0 0 0-.226 3.404l6.463 7.467c.884 1.004 2.4 1.124 3.403.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.205,
    d: "M2224.557 1441.498a2.417 2.417 0 0 0 .24-3.403l-6.477-7.468a2.406 2.406 0 0 0-3.404-.255l-19.507 16.914a2.404 2.404 0 0 0-.226 3.404l6.463 7.467c.884 1.004 2.4 1.124 3.403.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2087.165 1278.382a4.12 4.12 0 0 0 3.854 4.38 4.118 4.118 0 1 0 .539-8.218 4.117 4.117 0 0 0-4.393 3.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2087.165 1278.382a4.12 4.12 0 0 0 3.854 4.38 4.118 4.118 0 1 0 .539-8.218 4.117 4.117 0 0 0-4.393 3.837Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2034.55 1236.608a4.9 4.9 0 0 0 4.573 5.217c2.7.181 5.038-1.889 5.218-4.588a4.91 4.91 0 0 0-4.573-5.217 4.895 4.895 0 0 0-5.219 4.588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2034.55 1236.608a4.9 4.9 0 0 0 4.573 5.217c2.7.181 5.038-1.889 5.218-4.588a4.91 4.91 0 0 0-4.573-5.217 4.895 4.895 0 0 0-5.219 4.588Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2000.153 1243.895c6.117 1.08 23.9-21.832 25.52-3.029-2.43-.18-9.895-2.039-12.116.091-5.818 5.606 5.848 4.167 5.999 6.056.329 4.17-1.154 8.187-6.448 8.548-9.012.6-2.055-6.298-4.558-9.297-.135-.15.404-.42.45-.51-4.215 1.56-6.148-.06-8.818-2.099"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2321.302 1572.054-3.644 2.893 24.95 31.264 3.643-2.894Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2321.302 1572.054-3.644 2.893 24.95 31.264 3.643-2.894Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2017.697 1260.598c2.443-2.488 4.557-4.438 5.517-8.155 3.569 4.946 10.542 2.907 11.8-3.57.72 1.38 2.204 2.85 2.789 4.2-7.631-13.376 13.466-4.11 13.51 4.288.045 12.654-18.787 6.416-12.04-3.63-5.503 1.86-16.268 13.166-21.576 6.867"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2307.866 1565.23 10.062 12.057 5.217-4.32-11.425-15.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2307.866 1565.23 10.062 12.057 5.217-4.32-11.425-15.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2295.677 1577.362c.943-4.56 3.731-9.581-.752-16.09-4.497-6.522 3.75-17.663 6.48-19.791 2.726-2.13 12.04 13.763 12.04 13.763s3.913 3.375-5.759 12.566l36.826 45.912-2.159 44.369 60.727 103.386-79.485-101.526 2.474-41.235-29.687-36.392s-1.396-1.68-.706-4.962"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2295.677 1577.362c.943-4.56 3.731-9.581-.752-16.09-4.497-6.522 3.75-17.663 6.48-19.791 2.726-2.13 12.04 13.763 12.04 13.763s3.913 3.375-5.759 12.566l36.826 45.912-2.159 44.369 60.727 103.386-79.485-101.526 2.474-41.235-29.687-36.392s-1.396-1.68-.706-4.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2316.28 1578.501-5.595 6.583 27.56 33.813M2323.596 1659.95c5.532 2.445 12.909 4.484 18.757-1.858"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2326.068 1618.716c3.001 1.485 8.443 5.474 18.444-4.993"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M1980.66 1149.46c-3.209-.238-6.434.03-9.507.9l1.274 4.468c10.783-3.027 23.797 2.52 29 12.416 5.204 9.927 1.14 21.473-11.157 31.668l2.97 3.569c20.077-16.673 15.294-31.698 12.295-37.396-4.693-8.907-14.724-14.873-24.875-15.624"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M1980.66 1149.46c-3.209-.238-6.434.03-9.507.9l1.274 4.468c10.783-3.027 23.797 2.52 29 12.416 5.204 9.927 1.14 21.473-11.157 31.668l2.97 3.569c20.077-16.673 15.294-31.698 12.295-37.396-4.693-8.907-14.724-14.873-24.875-15.624Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M1978.966 1181.368c2.459-5.246 6.028-11.454 13.81-11.664-5.548-1.95-12.52-5.61-17.035 2.879-4.527 8.457 3.225 8.785 3.225 8.785"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M1978.966 1181.368c2.459-5.246 6.028-11.454 13.81-11.664-5.548-1.95-12.52-5.61-17.035 2.879-4.527 8.457 3.225 8.785 3.225 8.785Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M1852.818 1032.894c17.41 26.93 34.097 53.021 40.305 63.577 6.193 10.585 24.771 32.327 39.645 41.114 14.888 8.817 15.473 21.651 17.89 30.98 2.412 9.325 8.02 48.58 23.314 62.165 15.31 13.555 9.326-.09 22.147 15.624 12.805 15.714 238.456 291.603 238.456 291.603l11.468-7.888-209.785-269.829.286-3.87s-41.58-46.602-41.939-52.09c-.376-5.457-4.184-6.508-6.208-10.557-2.025-4.017-13.406-18.082-13.346-39.824.076-21.773-11.515-22.64-14.079-29.809-2.565-7.198-41.099-105.02-48.836-126.102-11.666 10.496-59.318 34.906-59.318 34.906"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272425",
    strokeWidth: 1.549,
    d: "M1852.818 1032.894c17.41 26.93 34.097 53.021 40.305 63.577 6.193 10.585 24.771 32.327 39.645 41.114 14.888 8.817 15.473 21.651 17.89 30.98 2.412 9.325 8.02 48.58 23.314 62.165 15.31 13.555 9.326-.09 22.147 15.624 12.805 15.714 238.456 291.603 238.456 291.603l11.468-7.888-209.785-269.829.286-3.87s-41.58-46.602-41.939-52.09c-.376-5.457-4.184-6.508-6.208-10.557-2.025-4.017-13.406-18.082-13.346-39.824.076-21.773-11.515-22.64-14.079-29.809-2.565-7.198-41.099-105.02-48.836-126.102-11.666 10.496-59.318 34.906-59.318 34.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1916.319 1009.083a1079 1079 0 0 1-4.182-11.095c-11.667 10.496-59.318 34.907-59.318 34.907a3436 3436 0 0 1 9.866 15.295c33.737-20.093 53.634-39.107 53.634-39.107"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M1916.319 1009.083a1079 1079 0 0 1-4.182-11.095c-11.667 10.496-59.318 34.907-59.318 34.907a3436 3436 0 0 1 9.866 15.295c33.737-20.093 53.634-39.107 53.634-39.107Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M1862.685 1048.19a3349 3349 0 0 0-9.867-15.296s18.263-9.355 34.95-18.982c-.837 5.968-12.938 15.414-15.427 17.573-2.49 2.13-4.033 5.49-4.274 8.667-.24 3.18-5.382 8.037-5.382 8.037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272425",
    strokeWidth: 1.549,
    d: "M1862.685 1048.19a3349 3349 0 0 0-9.867-15.296s18.263-9.355 34.95-18.982c-.837 5.968-12.938 15.414-15.427 17.573-2.49 2.13-4.033 5.49-4.274 8.667-.24 3.18-5.382 8.037-5.382 8.037Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m1983.914 1212.048 5.022-4.83 45.403 57.85-4.063 5.847Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m1983.914 1212.048 5.022-4.83 45.403 57.85-4.063 5.847Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m1991.261 1240.866-4.093 4.049 249.94 307.676 2.998-5.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m1991.261 1240.866-4.093 4.049 249.94 307.676 2.998-5.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2077.028 1310.35c1.11-.93 1.305-2.519.435-3.538l-6.417-7.528c-.87-1.02-2.46-1.08-3.57-.12l-21.547 18.352c-1.108.931-1.303 2.521-.434 3.54l6.418 7.526c.854 1.02 2.458 1.081 3.57.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.262,
    d: "M2077.028 1310.35c1.11-.93 1.305-2.519.435-3.538l-6.417-7.528c-.87-1.02-2.46-1.08-3.57-.12l-21.547 18.352c-1.108.931-1.303 2.521-.434 3.54l6.418 7.526c.854 1.02 2.458 1.081 3.57.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2164.386 1422.125c1.02-.869 1.123-2.383.27-3.404l-6.417-7.512c-.873-1.019-2.386-1.154-3.39-.299l-19.658 16.748a2.423 2.423 0 0 0-.27 3.405l6.417 7.526a2.403 2.403 0 0 0 3.39.284z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.205,
    d: "M2164.386 1422.125c1.02-.869 1.123-2.383.27-3.404l-6.417-7.512c-.873-1.019-2.386-1.154-3.39-.299l-19.658 16.748a2.423 2.423 0 0 0-.27 3.405l6.417 7.526a2.403 2.403 0 0 0 3.39.284z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2028.401 1257.84c-.164 2.28 1.545 4.26 3.81 4.408a4.12 4.12 0 0 0 4.437-3.807c.166-2.282-1.543-4.26-3.808-4.41-2.278-.178-4.259 1.53-4.439 3.809"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2028.401 1257.84c-.164 2.28 1.545 4.26 3.81 4.408a4.12 4.12 0 0 0 4.437-3.807c.166-2.282-1.543-4.26-3.808-4.41-2.278-.178-4.259 1.53-4.439 3.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M1976.146 1215.587a4.91 4.91 0 0 0 4.528 5.276c2.7.18 5.053-1.829 5.264-4.528.194-2.699-1.829-5.068-4.528-5.248-2.7-.21-5.069 1.8-5.264 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M1976.146 1215.587a4.91 4.91 0 0 0 4.528 5.276c2.7.18 5.053-1.829 5.264-4.528.194-2.699-1.829-5.068-4.528-5.248-2.7-.21-5.069 1.8-5.264 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M1941.704 1222.603c6.088 1.11 24.082-21.622 25.536-2.788-2.43-.21-9.881-2.16-12.115-.03-5.864 5.547 5.802 4.227 5.937 6.087.3 4.168-1.214 8.187-6.506 8.517-9.027.51-2.011-6.328-4.499-9.357-.12-.15.419-.419.465-.48-4.229 1.5-6.134-.12-8.803-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2259.989 1553.507-3.657 2.877 24.679 31.474 3.66-2.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2259.989 1553.507-3.657 2.877 24.679 31.474 3.66-2.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M1959.083 1239.458c2.474-2.49 4.603-4.41 5.592-8.127 3.524 4.978 10.527 2.998 11.845-3.45.706 1.38 2.175 2.879 2.745 4.228-7.527-13.463 13.494-4.018 13.465 4.409-.06 12.656-18.834 6.238-12.01-3.748-5.503 1.829-16.374 13.015-21.637 6.688"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2246.614 1546.578 9.973 12.13 5.248-4.273-11.292-15.279Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2246.614 1546.578 9.973 12.13 5.248-4.273-11.292-15.279Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2234.334 1558.604c.99-4.543 3.809-9.552-.614-16.104-4.44-6.553 3.913-17.619 6.657-19.717 2.744-2.115 11.905 13.853 11.905 13.853s3.884 3.405-5.863 12.507l36.437 46.242-2.534 44.338 59.813 103.926-78.586-102.217 2.819-41.218-29.374-36.648s-1.38-1.693-.66-4.962"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2234.334 1558.604c.99-4.543 3.809-9.552-.614-16.104-4.44-6.553 3.913-17.619 6.657-19.717 2.744-2.115 11.905 13.853 11.905 13.853s3.884 3.405-5.863 12.507l36.437 46.242-2.534 44.338 59.813 103.926-78.586-102.217 2.819-41.218-29.374-36.648s-1.38-1.693-.66-4.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2254.922 1559.923-5.638 6.538 27.244 34.037M2261.549 1641.432c5.503 2.49 12.85 4.59 18.773-1.709"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2264.368 1600.214c2.983 1.514 8.382 5.547 18.488-4.829"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2213.492 1170.424c3.209-.21 6.418.089 9.49.989l-1.303 4.468c-10.767-3.15-23.826 2.31-29.104 12.146-5.31 9.866-1.335 21.44 10.87 31.757l-2.998 3.569c-19.942-16.853-15.01-31.849-11.981-37.515 4.769-8.878 14.86-14.756 25.026-15.414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2213.492 1170.424c3.209-.21 6.418.089 9.49.989l-1.303 4.468c-10.767-3.15-23.826 2.31-29.104 12.146-5.31 9.866-1.335 21.44 10.87 31.757l-2.998 3.569c-19.942-16.853-15.01-31.849-11.981-37.515 4.769-8.878 14.86-14.756 25.026-15.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2214.901 1202.33c-2.414-5.277-5.937-11.515-13.719-11.754 5.576-1.92 12.58-5.49 17.032 2.999 4.44 8.517-3.313 8.756-3.313 8.756"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2214.901 1202.33c-2.414-5.277-5.937-11.515-13.719-11.754 5.576-1.92 12.58-5.49 17.032 2.999 4.44 8.517-3.313 8.756-3.313 8.756Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M2342.338 1054.966c-17.647 26.75-34.563 52.72-40.858 63.247-6.3 10.496-25.057 32.087-40.006 40.754s-15.654 21.502-18.158 30.798c-2.49 9.297-8.426 48.522-23.856 61.957-15.414 13.464-9.326-.15-22.267 15.443-12.94 15.624-240.96 289.548-240.96 289.548l-11.395-7.992 212.095-267.999-.255-3.87s41.985-46.273 42.39-51.73c.419-5.458 4.229-6.477 6.297-10.496 2.07-4.019 13.57-17.993 13.674-39.735.12-21.74 11.727-22.522 14.35-29.659 2.639-7.168 42-104.69 49.932-125.682 11.56 10.585 59.017 35.416 59.017 35.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272425",
    strokeWidth: 1.549,
    d: "M2342.338 1054.966c-17.647 26.75-34.563 52.72-40.858 63.247-6.3 10.496-25.057 32.087-40.006 40.754s-15.654 21.502-18.158 30.798c-2.49 9.297-8.426 48.522-23.856 61.957-15.414 13.464-9.326-.15-22.267 15.443-12.94 15.624-240.96 289.548-240.96 289.548l-11.395-7.992 212.095-267.999-.255-3.87s41.985-46.273 42.39-51.73c.419-5.458 4.229-6.477 6.297-10.496 2.07-4.019 13.57-17.993 13.674-39.735.12-21.74 11.727-22.522 14.35-29.659 2.639-7.168 42-104.69 49.932-125.682 11.56 10.585 59.017 35.416 59.017 35.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2279.033 1030.616c1.812-4.647 3.298-8.457 4.288-11.065 11.561 10.585 59.017 35.416 59.017 35.416a6152 6152 0 0 0-10.016 15.205c-33.558-20.364-53.289-39.556-53.289-39.556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2279.033 1030.616c1.812-4.647 3.298-8.457 4.288-11.065 11.561 10.585 59.017 35.416 59.017 35.416a6152 6152 0 0 0-10.016 15.205c-33.558-20.364-53.289-39.556-53.289-39.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2332.322 1070.172a6346 6346 0 0 1 10.016-15.206s-18.189-9.536-34.802-19.281c.796 5.966 12.806 15.534 15.279 17.692 2.475 2.159 3.989 5.519 4.199 8.697s5.308 8.097 5.308 8.097"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272425",
    strokeWidth: 1.549,
    d: "M2332.322 1070.172a6346 6346 0 0 1 10.016-15.206s-18.189-9.536-34.802-19.281c.796 5.966 12.806 15.534 15.279 17.692 2.475 2.159 3.989 5.519 4.199 8.697s5.308 8.097 5.308 8.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2209.683 1232.98-4.979-4.858-45.897 57.427 4.02 5.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2209.683 1232.98-4.979-4.858-45.897 57.427 4.02 5.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2202.096 1261.738 4.063 4.078-252.579 305.518-2.954-5.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2202.096 1261.738 4.063 4.078-252.579 305.518-2.954-5.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2115.728 1330.472c-1.095-.959-1.274-2.549-.39-3.539l6.463-7.467c.885-1.019 2.475-1.05 3.583-.119l21.382 18.562c1.095.96 1.275 2.55.406 3.54l-6.478 7.466c-.869 1.02-2.474 1.05-3.569.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.262,
    d: "M2115.728 1330.472c-1.095-.959-1.274-2.549-.39-3.539l6.463-7.467c.885-1.019 2.475-1.05 3.583-.119l21.382 18.562c1.095.96 1.275 2.55.406 3.54l-6.478 7.466c-.869 1.02-2.474 1.05-3.569.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2027.413 1441.498a2.42 2.42 0 0 1-.242-3.403l6.478-7.468a2.407 2.407 0 0 1 3.405-.255l19.506 16.914a2.416 2.416 0 0 1 .24 3.404l-6.477 7.467c-.884 1.004-2.398 1.124-3.402.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.205,
    d: "M2027.413 1441.498a2.42 2.42 0 0 1-.242-3.403l6.478-7.468a2.407 2.407 0 0 1 3.405-.255l19.506 16.914a2.416 2.416 0 0 1 .24 3.404l-6.477 7.467c-.884 1.004-2.398 1.124-3.402.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2164.805 1278.382a4.12 4.12 0 0 1-3.854 4.38 4.12 4.12 0 0 1-4.393-3.84 4.115 4.115 0 0 1 3.853-4.379 4.12 4.12 0 0 1 4.394 3.839"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2164.805 1278.382a4.12 4.12 0 0 1-3.854 4.38 4.12 4.12 0 0 1-4.393-3.84 4.115 4.115 0 0 1 3.853-4.379 4.12 4.12 0 0 1 4.394 3.839Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2217.42 1236.608a4.9 4.9 0 0 1-4.573 5.217c-2.7.181-5.037-1.889-5.217-4.588a4.91 4.91 0 0 1 4.572-5.217 4.887 4.887 0 0 1 5.219 4.588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2217.42 1236.608a4.9 4.9 0 0 1-4.573 5.217c-2.7.181-5.037-1.889-5.217-4.588a4.91 4.91 0 0 1 4.572-5.217 4.887 4.887 0 0 1 5.219 4.588Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2251.817 1243.895c-6.117 1.08-23.9-21.832-25.52-3.029 2.43-.18 9.896-2.039 12.116.091 5.817 5.606-5.849 4.167-5.999 6.056-.328 4.17 1.155 8.187 6.45 8.548 9.01.6 2.052-6.298 4.556-9.297.15-.15-.404-.42-.45-.51 4.215 1.56 6.148-.06 8.818-2.099"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m1930.684 1572.054 3.628 2.893-24.95 31.264-3.629-2.894z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m1930.684 1572.054 3.628 2.893-24.95 31.264-3.629-2.894z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2234.273 1260.598c-2.442-2.488-4.557-4.438-5.517-8.155-3.569 4.946-10.542 2.907-11.8-3.57-.72 1.38-2.205 2.85-2.789 4.2 7.631-13.376-13.465-4.11-13.51 4.288-.046 12.654 18.787 6.416 12.041-3.63 5.503 1.86 16.267 13.166 21.575 6.867"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m1944.104 1565.23-10.062 12.057-5.202-4.32 11.41-15.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m1944.104 1565.23-10.062 12.057-5.202-4.32 11.41-15.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M1956.293 1577.362c-.944-4.56-3.732-9.581.751-16.09 4.497-6.522-3.75-17.663-6.478-19.791-2.729-2.13-12.04 13.763-12.04 13.763s-3.915 3.375 5.757 12.566l-36.825 45.912 2.158 44.369-60.712 103.386 79.471-101.526-2.476-41.235 29.69-36.392s1.395-1.68.704-4.962"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M1956.293 1577.362c-.944-4.56-3.732-9.581.751-16.09 4.497-6.522-3.75-17.663-6.478-19.791-2.729-2.13-12.04 13.763-12.04 13.763s-3.915 3.375 5.757 12.566l-36.825 45.912 2.158 44.369-60.712 103.386 79.471-101.526-2.476-41.235 29.69-36.392s1.395-1.68.704-4.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m1935.691 1578.501 5.593 6.583-27.559 33.813M1928.375 1659.95c-5.534 2.445-12.91 4.484-18.758-1.858"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M1925.9 1618.716c-3 1.485-8.426 5.474-18.442-4.993"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2271.31 1149.46c3.208-.238 6.433.03 9.507.9l-1.26 4.468c-10.797-3.027-23.81 2.52-29.015 12.416-5.203 9.927-1.139 21.473 11.157 31.668l-2.97 3.569c-20.077-16.673-15.294-31.698-12.295-37.396 4.693-8.907 14.725-14.873 24.875-15.624"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2271.31 1149.46c3.208-.238 6.433.03 9.507.9l-1.26 4.468c-10.797-3.027-23.81 2.52-29.015 12.416-5.203 9.927-1.139 21.473 11.157 31.668l-2.97 3.569c-20.077-16.673-15.294-31.698-12.295-37.396 4.693-8.907 14.725-14.873 24.875-15.624Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2273.005 1181.368c-2.46-5.246-6.028-11.454-13.81-11.664 5.547-1.95 12.52-5.61 17.035 2.879 4.527 8.457-3.225 8.785-3.225 8.785"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2273.005 1181.368c-2.46-5.246-6.028-11.454-13.81-11.664 5.547-1.95 12.52-5.61 17.035 2.879 4.527 8.457-3.225 8.785-3.225 8.785Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M2399.151 1032.894c-17.408 26.93-34.097 53.021-40.289 63.577-6.208 10.585-24.786 32.327-39.66 41.114-14.889 8.817-15.474 21.651-17.889 30.98-2.414 9.325-8.02 48.58-23.315 62.165-15.31 13.555-9.326-.09-22.148 15.624-12.804 15.714-238.455 291.603-238.455 291.603l-11.469-7.888 209.785-269.829-.285-3.87s41.58-46.602 41.94-52.09c.375-5.457 4.182-6.508 6.206-10.557 2.025-4.017 13.406-18.082 13.347-39.824-.077-21.773 11.515-22.64 14.08-29.809 2.563-7.198 41.097-105.02 48.835-126.102 11.666 10.496 59.317 34.906 59.317 34.906"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272425",
    strokeWidth: 1.549,
    d: "M2399.151 1032.894c-17.408 26.93-34.097 53.021-40.289 63.577-6.208 10.585-24.786 32.327-39.66 41.114-14.889 8.817-15.474 21.651-17.889 30.98-2.414 9.325-8.02 48.58-23.315 62.165-15.31 13.555-9.326-.09-22.148 15.624-12.804 15.714-238.455 291.603-238.455 291.603l-11.469-7.888 209.785-269.829-.285-3.87s41.58-46.602 41.94-52.09c.375-5.457 4.182-6.508 6.206-10.557 2.025-4.017 13.406-18.082 13.347-39.824-.077-21.773 11.515-22.64 14.08-29.809 2.563-7.198 41.097-105.02 48.835-126.102 11.666 10.496 59.317 34.906 59.317 34.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2335.651 1009.083c1.784-4.677 3.223-8.486 4.183-11.095 11.666 10.496 59.317 34.907 59.317 34.907-3.328 5.159-6.657 10.286-9.866 15.295-33.737-20.093-53.634-39.107-53.634-39.107"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2335.651 1009.083c1.784-4.677 3.223-8.486 4.183-11.095 11.666 10.496 59.317 34.907 59.317 34.907-3.328 5.159-6.657 10.286-9.866 15.295-33.737-20.093-53.634-39.107-53.634-39.107Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2389.285 1048.19c3.209-5.01 6.538-10.137 9.866-15.296 0 0-18.262-9.355-34.952-18.982.84 5.968 12.94 15.414 15.43 17.573 2.489 2.13 4.033 5.49 4.273 8.667.24 3.18 5.383 8.037 5.383 8.037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272425",
    strokeWidth: 1.549,
    d: "M2389.285 1048.19c3.209-5.01 6.538-10.137 9.866-15.296 0 0-18.262-9.355-34.952-18.982.84 5.968 12.94 15.414 15.43 17.573 2.489 2.13 4.033 5.49 4.273 8.667.24 3.18 5.383 8.037 5.383 8.037Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2268.055 1212.048-5.022-4.83-45.404 57.85 4.065 5.847z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2268.055 1212.048-5.022-4.83-45.404 57.85 4.065 5.847z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2260.709 1240.866 4.094 4.049-249.941 307.676-3-5.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2260.709 1240.866 4.094 4.049-249.941 307.676-3-5.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2174.942 1310.35c-1.11-.93-1.29-2.519-.435-3.538l6.416-7.528c.872-1.02 2.46-1.08 3.57-.12l21.547 18.352c1.11.931 1.303 2.521.434 3.54l-6.418 7.526c-.853 1.02-2.458 1.081-3.568.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.262,
    d: "M2174.942 1310.35c-1.11-.93-1.29-2.519-.435-3.538l6.416-7.528c.872-1.02 2.46-1.08 3.57-.12l21.547 18.352c1.11.931 1.303 2.521.434 3.54l-6.418 7.526c-.853 1.02-2.458 1.081-3.568.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2087.584 1422.125c-1.02-.869-1.124-2.383-.27-3.404l6.417-7.512c.871-1.019 2.385-1.154 3.39-.299l19.657 16.748a2.42 2.42 0 0 1 .27 3.405l-6.418 7.526a2.4 2.4 0 0 1-3.388.284z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.205,
    d: "M2087.584 1422.125c-1.02-.869-1.124-2.383-.27-3.404l6.417-7.512c.871-1.019 2.385-1.154 3.39-.299l19.657 16.748a2.42 2.42 0 0 1 .27 3.405l-6.418 7.526a2.4 2.4 0 0 1-3.388.284z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2223.568 1257.84c.165 2.28-1.544 4.26-3.809 4.408-2.279.18-4.257-1.53-4.437-3.807-.166-2.282 1.543-4.26 3.808-4.41 2.278-.178 4.257 1.53 4.438 3.809"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2223.568 1257.84c.165 2.28-1.544 4.26-3.809 4.408-2.279.18-4.257-1.53-4.437-3.807-.166-2.282 1.543-4.26 3.808-4.41 2.278-.178 4.257 1.53 4.438 3.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2275.824 1215.587a4.91 4.91 0 0 1-4.528 5.276c-2.7.18-5.053-1.829-5.264-4.528-.195-2.699 1.829-5.068 4.528-5.248 2.715-.21 5.069 1.8 5.264 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2275.824 1215.587a4.91 4.91 0 0 1-4.528 5.276c-2.7.18-5.053-1.829-5.264-4.528-.195-2.699 1.829-5.068 4.528-5.248 2.715-.21 5.069 1.8 5.264 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2310.264 1222.603c-6.086 1.11-24.08-21.622-25.534-2.788 2.43-.21 9.881-2.16 12.114-.03 5.864 5.547-5.802 4.227-5.937 6.087-.299 4.168 1.214 8.187 6.522 8.517 9.012.51 1.995-6.328 4.484-9.357.135-.15-.42-.419-.465-.48 4.228 1.5 6.132-.12 8.802-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m1991.981 1553.507 3.657 2.877-24.68 31.474-3.659-2.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m1991.981 1553.507 3.657 2.877-24.68 31.474-3.659-2.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2292.887 1239.458c-2.475-2.49-4.604-4.41-5.593-8.127-3.522 4.978-10.525 2.998-11.844-3.45-.706 1.38-2.174 2.879-2.745 4.228 7.527-13.463-13.494-4.018-13.465 4.409.06 12.656 18.847 6.238 12.01-3.748 5.519 1.829 16.374 13.015 21.637 6.688"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2005.356 1546.578-9.973 12.13-5.248-4.273 11.292-15.279Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m2005.356 1546.578-9.973 12.13-5.248-4.273 11.292-15.279Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2017.637 1558.604c-.99-4.543-3.81-9.552.614-16.104 4.439-6.553-3.914-17.619-6.657-19.717-2.744-2.115-11.906 13.853-11.906 13.853s-3.883 3.405 5.862 12.507l-36.435 46.242 2.533 44.338-59.812 103.926 78.6-102.217-2.833-41.218 29.374-36.648s1.379-1.693.66-4.962"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M2017.637 1558.604c-.99-4.543-3.81-9.552.614-16.104 4.439-6.553-3.914-17.619-6.657-19.717-2.744-2.115-11.906 13.853-11.906 13.853s-3.883 3.405 5.862 12.507l-36.435 46.242 2.533 44.338-59.812 103.926 78.6-102.217-2.833-41.218 29.374-36.648s1.379-1.693.66-4.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "m1997.048 1559.923 5.638 6.538-27.244 34.037M1990.436 1641.432c-5.518 2.49-12.865 4.59-18.789-1.709"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.549,
    d: "M1987.602 1600.214c-2.983 1.514-8.382 5.547-18.488-4.829"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M2297.76 1614.533c-6.658-7.362-72.393-82.364-93.385-125.803-4.964-10.241 8.966-15.698 12.91-6.463 6.703 15.745 48.521 79.112 89.531 125.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.025,
    d: "M2297.76 1614.533c-6.658-7.362-72.393-82.364-93.385-125.803-4.964-10.241 8.966-15.698 12.91-6.463 6.703 15.745 48.521 79.112 89.531 125.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2285.555 1619.87c-1.936 3.448-4.244 15.115 2.684 25.371 6.912 10.255 14.44 13.15 22.207 11.771.478-7.797-.302-11.38 10.735-19.328 11.021-7.947 18.967-9.357 21.786-9.237 2.82.135 11.036 1.89 17.424 6.673 3.464-3.464 8.202-22.94-2.684-39.6-10.9-16.66-31.668-22.686-45.882-17.5 3.583 3.524 10.885 15.055-.78 28.776-5.353 6.192-10.378 11.02-10.378 11.02s-8.71 7.302-15.112 2.054"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.025,
    d: "M2285.555 1619.87c-1.936 3.448-4.244 15.115 2.684 25.371 6.912 10.255 14.44 13.15 22.207 11.771.478-7.797-.302-11.38 10.735-19.328 11.021-7.947 18.967-9.357 21.786-9.237 2.82.135 11.036 1.89 17.424 6.673 3.464-3.464 8.202-22.94-2.684-39.6-10.9-16.66-31.668-22.686-45.882-17.5 3.583 3.524 10.885 15.055-.78 28.776-5.353 6.192-10.378 11.02-10.378 11.02s-8.71 7.302-15.112 2.054z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2310.415 1657.416c-.135-5.381-4.363-11.53 11.276-22.296 15.624-10.766 27.424-10.256 38.7 0-6.912-4.363-17.423-9.492-31.533-.135-14.094 9.357-11.395 8.338-11.395 8.338-2.954 2.309-6.028 3.328-7.048 14.093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.025,
    d: "M2310.415 1657.416c-.135-5.381-4.363-11.53 11.276-22.296 15.624-10.766 27.424-10.256 38.7 0-6.912-4.363-17.423-9.492-31.533-.135-14.094 9.357-11.395 8.338-11.395 8.338-2.954 2.309-6.028 3.328-7.048 14.093Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "m2316.743 1644.792-21.262-27.995c-1.604-2.115.225-6.208 4.094-9.147 3.853-2.923 8.29-3.584 9.896-1.47l21.262 27.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.025,
    d: "m2316.743 1644.792-21.262-27.995c-1.604-2.115.225-6.208 4.094-9.147 3.853-2.923 8.29-3.584 9.896-1.47l21.262 27.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M2330.733 1634.16c-1.604-2.114-6.043-1.44-9.897 1.485-3.868 2.94-5.698 7.032-4.093 9.146 1.604 2.115 6.043 1.44 9.896-1.485 3.868-2.938 5.697-7.032 4.094-9.146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.025,
    d: "M2330.733 1634.16c-1.604-2.114-6.043-1.44-9.897 1.485-3.868 2.94-5.698 7.032-4.093 9.146 1.604 2.115 6.043 1.44 9.896-1.485 3.868-2.938 5.697-7.032 4.094-9.146Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M2329.457 1638.314c-1.048-1.77-3.776-2.083-6.072-.72-2.324 1.365-3.343 3.898-2.294 5.669 1.05 1.768 4.018 2.533 6.328 1.168 2.309-1.363 3.073-4.348 2.038-6.117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.025,
    d: "M2329.457 1638.314c-1.048-1.77-3.776-2.083-6.072-.72-2.324 1.365-3.343 3.898-2.294 5.669 1.05 1.768 4.018 2.533 6.328 1.168 2.309-1.363 3.073-4.348 2.038-6.117Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1958.693 1599.268c6.252 2.25 19.388 11.2 26.72 21.232 7.333 10.032 2.954 14.185-5.218 12.475-8.17-1.708-17.094-10.944-18.503-14.018-1.41-3.06-2.999-19.69-2.999-19.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.595,
    d: "M1958.693 1599.268c6.252 2.25 19.388 11.2 26.72 21.232 7.333 10.032 2.954 14.185-5.218 12.475-8.17-1.708-17.094-10.944-18.503-14.018-1.41-3.06-2.999-19.69-2.999-19.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#473125",
    strokeWidth: 19.521,
    d: "m1953.82 1605.16 41.865-48.821"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M1929.53 1559.264c-1.53 2.323-7.333 7.376-9.252 9.911-1.92 2.533-10.106 13-9.446 25.94.644 12.94.868 17.574.764 22.971-.104 5.398-4.393 23.796 7.003 33.423 11.395 9.641 17.768 13.705 36.33 11.86 18.579-1.86 32.869-11.202 21.743-23.105 1.589-2.775 3.838-6.06 9.07-7.063-4.347-.81-16.628-5.639-18.892-12.82-2.263-7.198-3.103-22.508-3.84-26.796-.733-4.303-2.967-18.428-14.482-25.91-11.5-7.467-15.64-5.623-18.998-8.41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.595,
    d: "M1929.53 1559.264c-1.53 2.323-7.333 7.376-9.252 9.911-1.92 2.533-10.106 13-9.446 25.94.644 12.94.868 17.574.764 22.971-.104 5.398-4.393 23.796 7.003 33.423 11.395 9.641 17.768 13.705 36.33 11.86 18.579-1.86 32.869-11.202 21.743-23.105 1.589-2.775 3.838-6.06 9.07-7.063-4.347-.81-16.628-5.639-18.892-12.82-2.263-7.198-3.103-22.508-3.84-26.796-.733-4.303-2.967-18.428-14.482-25.91-11.5-7.467-15.64-5.623-18.998-8.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#T)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1976.672 1640.264c1.425 1.514 2.414 2.999 3.058 4.422-6.163-4.29-18.982-11.365-25.37-9.131-7.437 2.579-15.714 9.252-21.457 4.647 3.225-.3 17.438-1.98 4.258-17.422 4.634 4.933 21.562 18.967 31.144.42 1.244 1.739 3.028 3.283 5.007 4.618-3.987.959-8.471 2.803-7.841 5.203.764 2.894 8.187 4.768 13.9 3.509-1.155 1.184-1.994 2.504-2.7 3.734"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#U)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1913.2 1606.12c.42-5.157 7.153-30.167 21.412-31.562 14.246-1.396 18.488 7.782 21.398 12.476-1.664-7.978-7.573-17.919-23.887-15.1s-19.417 22.611-19.642 23.931c-.24 1.32.72 10.255.72 10.255"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2386.856 1113.564c-4.843 5.338-4.453 13.585.884 18.443 5.34 4.83 13.586 4.44 18.428-.9 4.844-5.308 4.455-13.585-.884-18.412-5.337-4.859-13.584-4.44-18.428.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 2.097,
    d: "M2386.856 1113.564c-4.843 5.338-4.453 13.585.884 18.443 5.34 4.83 13.586 4.44 18.428-.9 4.844-5.308 4.455-13.585-.884-18.412-5.337-4.859-13.584-4.44-18.428.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2006.556 1606.646s371.05-381.853 391.861-403.266c20.798-21.381 8.818-63.725-5.668-76.891-14.483-13.165-57.788-21.021-77.086 1.74s-363.838 428.695-363.838 428.695Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 2.097,
    d: "M2006.556 1606.646s371.05-381.853 391.861-403.266c20.798-21.381 8.818-63.725-5.668-76.891-14.483-13.165-57.788-21.021-77.086 1.74s-363.838 428.695-363.838 428.695Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2334.196 1272.655a4.18 4.18 0 0 1-2.323-5.458c2.444-6.09-16.57-32.118-28.175-42.675-11.62-10.526-39.361-26.96-45.163-23.93-2.07 1.049-4.604.27-5.668-1.8a4.213 4.213 0 0 1 1.8-5.667c13.734-7.108 49.99 20.962 54.669 25.19 4.678 4.258 36.091 37.665 30.302 52.03a4.18 4.18 0 0 1-5.442 2.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M2334.196 1272.655a4.18 4.18 0 0 1-2.323-5.458c2.444-6.09-16.57-32.118-28.175-42.675-11.62-10.526-39.361-26.96-45.163-23.93-2.07 1.049-4.604.27-5.668-1.8a4.213 4.213 0 0 1 1.8-5.667c13.734-7.108 49.99 20.962 54.669 25.19 4.678 4.258 36.091 37.665 30.302 52.03a4.18 4.18 0 0 1-5.442 2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2344.811 1263.688a5.617 5.617 0 0 1-1.889-7.198c-.075-5.638-15.653-27.529-30.767-41.265-15.115-13.734-38.402-27.14-44.039-26.659a5.573 5.573 0 0 1-7.332-1.23c-1.95-2.398-1.574-5.907.824-7.857 13.39-10.855 57.64 27.08 58.06 27.471.434.39 42.416 40.783 32.896 55.15a5.59 5.59 0 0 1-7.753 1.588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M2344.811 1263.688a5.617 5.617 0 0 1-1.889-7.198c-.075-5.638-15.653-27.529-30.767-41.265-15.115-13.734-38.402-27.14-44.039-26.659a5.573 5.573 0 0 1-7.332-1.23c-1.95-2.398-1.574-5.907.824-7.857 13.39-10.855 57.64 27.08 58.06 27.471.434.39 42.416 40.783 32.896 55.15a5.59 5.59 0 0 1-7.753 1.588Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2393.243 1213.306c-2.383-1.919-2.833-5.428-.93-7.826 6.583-8.368-1.647-31.789-24.005-52.09-22.341-20.304-46.453-26.24-54.13-18.895a5.603 5.603 0 0 1-7.901-.179c-2.145-2.218-2.07-5.758.164-7.916 13.54-12.956 43.379-4.918 69.395 18.712 26.014 23.631 36.886 52.57 25.265 67.295-1.905 2.4-5.428 2.818-7.858.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M2393.243 1213.306c-2.383-1.919-2.833-5.428-.93-7.826 6.583-8.368-1.647-31.789-24.005-52.09-22.341-20.304-46.453-26.24-54.13-18.895a5.603 5.603 0 0 1-7.901-.179c-2.145-2.218-2.07-5.758.164-7.916 13.54-12.956 43.379-4.918 69.395 18.712 26.014 23.631 36.886 52.57 25.265 67.295-1.905 2.4-5.428 2.818-7.858.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2383.392 1221.553c-1.725-1.559-1.92-4.139-.359-5.848 1.978-3.689-1.32-27.949-25.76-50.17-24.306-22.073-48.658-23.123-52.346-20.842-1.574 1.59-4.138 1.65-5.803.148-1.71-1.558-1.845-4.226-.285-5.937 6.598-7.256 37.471-3.719 64.072 20.422 26.6 24.171 33.078 54.55 26.464 61.836-1.545 1.711-4.273 1.92-5.983.391"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M2383.392 1221.553c-1.725-1.559-1.92-4.139-.359-5.848 1.978-3.689-1.32-27.949-25.76-50.17-24.306-22.073-48.658-23.123-52.346-20.842-1.574 1.59-4.138 1.65-5.803.148-1.71-1.558-1.845-4.226-.285-5.937 6.598-7.256 37.471-3.719 64.072 20.422 26.6 24.171 33.078 54.55 26.464 61.836-1.545 1.711-4.273 1.92-5.983.391Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.796,
    d: "m2321.915 1281.62 7.214-13.703-13.136 1.29 6.447-14.906-14.558.63 4.424-14.874-14.215 2.758 3.253-15.683-15.325 4.738 1.41-14.424-14.395 5.847-.778-14.574-14.216 7.856.029-13.195-12.97 8.488"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.844,
    d: "m2366.48 1235.23 7.106-13.797-13.359 1.08 6.327-15.024-14.845.39 4.274-15.055-14.485 2.55 3.09-15.864-15.505 4.588 1.154-14.635-14.559 5.668-1.05-14.785-14.348 7.708-.21-13.375-13.046 8.366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2017.98 1598.414a4.19 4.19 0 0 1-2.325-5.458c2.835-7.033-6.866-24.41-16.493-33.153-9.64-8.757-27.859-16.748-34.59-13.256-2.056 1.081-4.605.271-5.655-1.784a4.194 4.194 0 0 1 1.784-5.652c12.506-6.493 35.252 6.448 44.1 14.47 8.846 8.037 23.901 29.448 18.637 42.508a4.187 4.187 0 0 1-5.458 2.325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M2017.98 1598.414a4.19 4.19 0 0 1-2.325-5.458c2.835-7.033-6.866-24.41-16.493-33.153-9.64-8.757-27.859-16.748-34.59-13.256-2.056 1.081-4.605.271-5.655-1.784a4.194 4.194 0 0 1 1.784-5.652c12.506-6.493 35.252 6.448 44.1 14.47 8.846 8.037 23.901 29.448 18.637 42.508a4.187 4.187 0 0 1-5.458 2.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2034.354 1581.966c-2.159-.855-3.194-3.313-2.323-5.458 2.653-6.615-7.753-24.112-17.829-33.274-10.076-9.146-28.489-17.827-34.818-14.543-2.052 1.064-4.603.268-5.652-1.8-1.079-2.054-.27-4.574 1.785-5.654 12.116-6.283 34.846 7.183 44.322 15.79s25.056 29.943 19.958 42.613c-.854 2.145-3.298 3.18-5.443 2.325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M2034.354 1581.966c-2.159-.855-3.194-3.313-2.323-5.458 2.653-6.615-7.753-24.112-17.829-33.274-10.076-9.146-28.489-17.827-34.818-14.543-2.052 1.064-4.603.268-5.652-1.8-1.079-2.054-.27-4.574 1.785-5.654 12.116-6.283 34.846 7.183 44.322 15.79s25.056 29.943 19.958 42.613c-.854 2.145-3.298 3.18-5.443 2.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.844,
    d: "m2026.303 1585.549 3.628-11.816-7.241.675 3.852-9.417-8.71.585 3.134-10.376-9.913.286 1.665-10.603-10.406 2.67-.66-9.897-10.031 4.109-.255-8.726-8.996 4.739-.031-7.274-11.41 4.754"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M1987.933 1568.005s329.53-381.478 350.431-404.509c20.917-23.032 33.197-19.793 50.98-18.714-9.52-9.267-37.41-23.271-66.079 8.308-28.654 31.547-349.967 407.103-349.967 407.103z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#W)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2362.685 1185.567-328.916 350.695c-3.704 3.944-3.493 10.137.45 13.825.031.044.075.075.106.104 3.958 3.584 10.06 3.36 13.718-.554l324.343-346.258c3.704-3.927 3.778-10.075-.165-13.793-.044-.03-5.877-7.917-9.536-4.019"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2006.42 1607.425c6.822-7.513-.044-24.86-15.325-38.746-15.294-13.885-33.21-19.058-40.05-11.545-6.822 7.527.046 24.875 15.325 38.76 15.295 13.885 33.213 19.058 40.05 11.531"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 2.097,
    d: "M2006.42 1607.425c6.822-7.513-.044-24.86-15.325-38.746-15.294-13.885-33.21-19.058-40.05-11.545-6.822 7.527.046 24.875 15.325 38.76 15.295 13.885 33.213 19.058 40.05 11.531Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1998.894 1600.602c4.723-5.187-.481-17.602-11.622-27.724-11.141-10.106-23.975-14.095-28.698-8.906-4.723 5.203.494 17.603 11.62 27.71 11.14 10.121 23.99 14.108 28.7 8.92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 2.097,
    d: "M1998.894 1600.602c4.723-5.187-.481-17.602-11.622-27.724-11.141-10.106-23.975-14.095-28.698-8.906-4.723 5.203.494 17.603 11.62 27.71 11.14 10.121 23.99 14.108 28.7 8.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "m1978.006 1597.634 6.268 3.27 13.525-14.89-3.854-5.924Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Y)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1973.567 1565.007s-6.462 8.605-8.621 11.665c-2.16 3.073.9 11.844 6.207 5.652 5.309-6.193 9.493-13.255 9.493-13.255Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1865.114 1113.564c4.843 5.338 4.453 13.585-.886 18.443-5.337 4.83-13.584 4.44-18.428-.9-4.843-5.308-4.453-13.585.886-18.412 5.337-4.859 13.584-4.44 18.428.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 2.097,
    d: "M1865.114 1113.564c4.843 5.338 4.453 13.585-.886 18.443-5.337 4.83-13.584 4.44-18.428-.9-4.843-5.308-4.453-13.585.886-18.412 5.337-4.859 13.584-4.44 18.428.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2245.415 1606.646s-371.05-381.853-391.863-403.266c-20.797-21.381-8.816-63.725 5.669-76.891 14.484-13.165 57.787-21.021 77.086 1.74 19.298 22.76 363.837 428.695 363.837 428.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 2.097,
    d: "M2245.415 1606.646s-371.05-381.853-391.863-403.266c-20.797-21.381-8.816-63.725 5.669-76.891 14.484-13.165 57.787-21.021 77.086 1.74 19.298 22.76 363.837 428.695 363.837 428.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1917.773 1272.655a4.18 4.18 0 0 0 2.325-5.458c-2.445-6.09 16.569-32.118 28.175-42.675 11.62-10.526 39.36-26.96 45.163-23.93 2.067 1.049 4.603.27 5.667-1.8a4.215 4.215 0 0 0-1.8-5.667c-13.734-7.108-49.99 20.962-54.67 25.19-4.677 4.258-36.09 37.665-30.301 52.03a4.18 4.18 0 0 0 5.44 2.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M1917.773 1272.655a4.18 4.18 0 0 0 2.325-5.458c-2.445-6.09 16.569-32.118 28.175-42.675 11.62-10.526 39.36-26.96 45.163-23.93 2.067 1.049 4.603.27 5.667-1.8a4.215 4.215 0 0 0-1.8-5.667c-13.734-7.108-49.99 20.962-54.67 25.19-4.677 4.258-36.09 37.665-30.301 52.03a4.18 4.18 0 0 0 5.44 2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1907.157 1263.688a5.635 5.635 0 0 0 1.905-7.198c.06-5.638 15.638-27.529 30.753-41.265 15.115-13.734 38.401-27.14 44.04-26.659a5.573 5.573 0 0 0 7.331-1.23c1.95-2.398 1.574-5.907-.809-7.857-13.39-10.855-57.638 27.08-58.074 27.471-.435.39-42.419 40.783-32.897 55.15a5.59 5.59 0 0 0 7.751 1.588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M1907.157 1263.688a5.635 5.635 0 0 0 1.905-7.198c.06-5.638 15.638-27.529 30.753-41.265 15.115-13.734 38.401-27.14 44.04-26.659a5.573 5.573 0 0 0 7.331-1.23c1.95-2.398 1.574-5.907-.809-7.857-13.39-10.855-57.638 27.08-58.074 27.471-.435.39-42.419 40.783-32.897 55.15a5.59 5.59 0 0 0 7.751 1.588Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1858.725 1213.306c2.385-1.919 2.834-5.428.931-7.826-6.583-8.368 1.649-31.789 24.006-52.09 22.34-20.304 46.453-26.24 54.13-18.895 2.234 2.13 5.787 2.04 7.901-.179 2.145-2.218 2.07-5.758-.164-7.916-13.541-12.956-43.379-4.918-69.395 18.712-26.015 23.631-36.87 52.57-25.265 67.295 1.905 2.4 5.427 2.818 7.856.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M1858.725 1213.306c2.385-1.919 2.834-5.428.931-7.826-6.583-8.368 1.649-31.789 24.006-52.09 22.34-20.304 46.453-26.24 54.13-18.895 2.234 2.13 5.787 2.04 7.901-.179 2.145-2.218 2.07-5.758-.164-7.916-13.541-12.956-43.379-4.918-69.395 18.712-26.015 23.631-36.87 52.57-25.265 67.295 1.905 2.4 5.427 2.818 7.856.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1868.577 1221.553c1.725-1.559 1.918-4.139.36-5.848-1.98-3.689 1.32-27.949 25.76-50.17 24.32-22.073 48.658-23.123 52.346-20.842 1.574 1.59 4.124 1.65 5.803.148 1.71-1.558 1.843-4.226.285-5.937-6.598-7.256-37.471-3.719-64.072 20.422-26.6 24.171-33.078 54.55-26.465 61.836 1.545 1.711 4.273 1.92 5.982.391"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M1868.577 1221.553c1.725-1.559 1.918-4.139.36-5.848-1.98-3.689 1.32-27.949 25.76-50.17 24.32-22.073 48.658-23.123 52.346-20.842 1.574 1.59 4.124 1.65 5.803.148 1.71-1.558 1.843-4.226.285-5.937-6.598-7.256-37.471-3.719-64.072 20.422-26.6 24.171-33.078 54.55-26.465 61.836 1.545 1.711 4.273 1.92 5.982.391Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.796,
    d: "m1930.055 1281.62-7.198-13.703 13.12 1.29-6.447-14.906 14.559.63-4.424-14.874 14.215 2.758-3.253-15.683 15.323 4.738-1.41-14.424 14.395 5.847.78-14.574 14.215 7.856-.03-13.195 12.97 8.488"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.844,
    d: "m1885.49 1235.23-7.106-13.797 13.359 1.08-6.327-15.024 14.844.39-4.273-15.055 14.485 2.55-3.09-15.864 15.505 4.588-1.154-14.635 14.559 5.668 1.05-14.785 14.349 7.708.21-13.375 13.06 8.366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2233.989 1598.414a4.187 4.187 0 0 0 2.323-5.458c-2.833-7.033 6.868-24.41 16.495-33.153 9.641-8.757 27.859-16.748 34.592-13.256 2.055 1.081 4.604.271 5.653-1.784 1.08-2.054.269-4.587-1.786-5.652-12.504-6.493-35.251 6.448-44.096 14.47-8.848 8.037-23.903 29.448-18.639 42.508a4.186 4.186 0 0 0 5.458 2.325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M2233.989 1598.414a4.187 4.187 0 0 0 2.323-5.458c-2.833-7.033 6.868-24.41 16.495-33.153 9.641-8.757 27.859-16.748 34.592-13.256 2.055 1.081 4.604.271 5.653-1.784 1.08-2.054.269-4.587-1.786-5.652-12.504-6.493-35.251 6.448-44.096 14.47-8.848 8.037-23.903 29.448-18.639 42.508a4.186 4.186 0 0 0 5.458 2.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2217.63 1581.966c2.145-.855 3.18-3.313 2.324-5.458-2.668-6.615 7.738-24.112 17.815-33.274 10.075-9.146 28.488-17.827 34.815-14.543 2.069 1.064 4.605.268 5.653-1.8 1.08-2.054.27-4.574-1.784-5.654-12.116-6.283-34.845 7.183-44.323 15.79-9.477 8.606-25.056 29.944-19.957 42.613.853 2.145 3.298 3.18 5.457 2.325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.398,
    d: "M2217.63 1581.966c2.145-.855 3.18-3.313 2.324-5.458-2.668-6.615 7.738-24.112 17.815-33.274 10.075-9.146 28.488-17.827 34.815-14.543 2.069 1.064 4.605.268 5.653-1.8 1.08-2.054.27-4.574-1.784-5.654-12.116-6.283-34.845 7.183-44.323 15.79-9.477 8.606-25.056 29.944-19.957 42.613.853 2.145 3.298 3.18 5.457 2.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.844,
    d: "m2225.668 1585.549-3.63-11.816 7.242.675-3.852-9.417 8.71.585-3.133-10.376 9.91.286-1.663-10.603 10.406 2.67.66-9.897 10.032 4.109.255-8.726 8.996 4.739.03-7.274 11.41 4.754"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Z)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M2264.038 1568.005s-329.53-381.478-350.432-404.509c-20.917-23.032-33.197-19.793-50.98-18.714 9.52-9.267 37.41-23.271 66.079 8.308 28.654 31.547 349.967 407.103 349.967 407.103z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1889.285 1185.567 328.915 350.695c3.705 3.944 3.495 10.137-.45 13.825-.03.044-.074.075-.104.104-3.96 3.584-10.063 3.36-13.72-.554l-324.343-346.258c-3.705-3.927-3.778-10.075.164-13.793.045-.03 5.878-7.917 9.537-4.019"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2245.55 1607.425c-6.822-7.513.045-24.86 15.325-38.746 15.293-13.885 33.21-19.058 40.05-11.545 6.822 7.527-.046 24.875-15.325 38.76-15.294 13.885-33.213 19.058-40.05 11.531"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 2.097,
    d: "M2245.55 1607.425c-6.822-7.513.045-24.86 15.325-38.746 15.293-13.885 33.21-19.058 40.05-11.545 6.822 7.527-.046 24.875-15.325 38.76-15.294 13.885-33.213 19.058-40.05 11.531Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2253.076 1600.602c-4.707-5.187.48-17.602 11.622-27.724 11.14-10.106 23.99-14.095 28.698-8.906 4.723 5.203-.478 17.603-11.62 27.71-11.14 10.121-23.975 14.108-28.7 8.92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 2.097,
    d: "M2253.076 1600.602c-4.707-5.187.48-17.602 11.622-27.724 11.14-10.106 23.99-14.095 28.698-8.906 4.723 5.203-.478 17.603-11.62 27.71-11.14 10.121-23.975 14.108-28.7 8.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "m2273.964 1597.634-6.268 3.27-13.525-14.89 3.855-5.924z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2278.403 1565.007s6.463 8.605 8.621 11.665c2.16 3.073-.899 11.844-6.207 5.652-5.309-6.193-9.492-13.255-9.492-13.255Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 2.068,
    d: "M2267.231 1772.767s-4.483-1.095-5.232-6.267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2272.165 1772.648c0-1.184-1.215-2.144-2.73-2.144s-2.73.96-2.73 2.144 1.216 2.145 2.73 2.145 2.73-.96 2.73-2.145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 0.689,
    d: "M2272.165 1772.648c0-1.184-1.215-2.144-2.73-2.144s-2.73.96-2.73 2.144 1.216 2.145 2.73 2.145 2.73-.96 2.73-2.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2259.195 1770.744c-.45-1.095-1.95-1.514-3.345-.96-1.393.57-2.174 1.935-1.723 3.03s1.934 1.513 3.343.959c1.395-.57 2.174-1.92 1.725-3.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 0.689,
    d: "M2259.195 1770.744c-.45-1.095-1.95-1.514-3.345-.96-1.393.57-2.174 1.935-1.723 3.03s1.934 1.513 3.343.959c1.395-.57 2.174-1.92 1.725-3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2256.376 1822.384c-.45-1.095-1.935-1.529-3.344-.959-1.394.57-2.175 1.918-1.724 3.013.45 1.11 1.95 1.53 3.343.96 1.395-.57 2.175-1.919 1.725-3.014"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 0.689,
    d: "M2256.376 1822.384c-.45-1.095-1.935-1.529-3.344-.959-1.394.57-2.175 1.918-1.724 3.013.45 1.11 1.95 1.53 3.343.96 1.395-.57 2.175-1.919 1.725-3.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2258.685 1822.054c.36-1.124 1.813-1.665 3.253-1.214 1.44.45 2.325 1.74 1.964 2.88-.36 1.122-1.813 1.663-3.253 1.213-1.439-.465-2.325-1.74-1.964-2.879"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 0.689,
    d: "M2258.685 1822.054c.36-1.124 1.813-1.665 3.253-1.214 1.44.45 2.325 1.74 1.964 2.88-.36 1.122-1.813 1.663-3.253 1.213-1.439-.465-2.325-1.74-1.964-2.879Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2262.209 1725.146c-.45-1.095-1.95-1.529-3.344-.959s-2.175 1.92-1.724 3.027c.45 1.095 1.934 1.516 3.344.946 1.394-.57 2.174-1.919 1.724-3.014"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 0.689,
    d: "M2262.209 1725.146c-.45-1.095-1.95-1.529-3.344-.959s-2.175 1.92-1.724 3.027c.45 1.095 1.934 1.516 3.344.946 1.394-.57 2.174-1.919 1.724-3.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2272.554 1725.206c.346-1.125-.525-2.414-1.964-2.864s-2.909.09-3.253 1.215c-.36 1.14.524 2.414 1.964 2.88 1.44.45 2.894-.092 3.253-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 0.689,
    d: "M2272.554 1725.206c.346-1.125-.525-2.414-1.964-2.864s-2.909.09-3.253 1.215c-.36 1.14.524 2.414 1.964 2.88 1.44.45 2.894-.092 3.253-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 2.068,
    d: "M2267.681 1723.766c-1.948-.224-3.493-1.784-3.673-3.732"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2238.892 1655.363c.06-1.186-1.11-2.205-2.624-2.28s-2.774.84-2.835 2.01c-.06 1.184 1.126 2.203 2.624 2.278 1.516.075 2.79-.824 2.835-2.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 0.689,
    d: "M2238.892 1655.363c.06-1.186-1.11-2.205-2.624-2.28s-2.774.84-2.835 2.01c-.06 1.184 1.126 2.203 2.624 2.278 1.516.075 2.79-.824 2.835-2.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32011",
    d: "M2232.175 1670.34c-1.17-.103-2.25 1.036-2.385 2.536-.12 1.514.72 2.819 1.906 2.923 1.184.105 2.248-1.035 2.383-2.533.119-1.515-.718-2.82-1.904-2.925"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 0.689,
    d: "M2232.175 1670.34c-1.17-.103-2.25 1.036-2.385 2.536-.12 1.514.72 2.819 1.906 2.923 1.184.105 2.248-1.035 2.383-2.533.119-1.515-.718-2.82-1.904-2.925Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2224.482 1661.376c23.197 5.862 38.58 38.069 38.042 62.15-.825 36.152-2.52 66.186-5.188 91.81-.15 1.426-.27 2.835-.39 4.23-.406 4.559-.78 8.876-1.98 13.24l1.995.554c1.26-4.557 1.633-8.967 2.04-13.63.12-1.378.253-2.773.388-4.183 2.67-25.67 4.364-55.764 5.202-91.976.571-25.341-14.768-59.661-39.285-65.854Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2224.482 1661.376c23.197 5.862 38.58 38.069 38.042 62.15-.825 36.152-2.52 66.186-5.188 91.81-.15 1.426-.27 2.835-.39 4.23-.406 4.559-.78 8.876-1.98 13.24l1.995.554c1.26-4.557 1.633-8.967 2.04-13.63.12-1.378.253-2.773.388-4.183 2.67-25.67 4.364-55.764 5.202-91.976.571-25.341-14.768-59.661-39.285-65.854Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "m2018.49 1651.314 10.106-1.604-9.596 24.65-3.269-22.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "m2018.49 1651.314 10.106-1.604-9.596 24.65-3.269-22.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2002.402 1813.673c5.053 12.4 31.322 53.213 42.973 59.272-12.595 1.89-44.863-41.009-49-51.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2004.35 1835.67c5.384 19.972 25.087 37.154 37.458 42.283-10.361-13.12-23.618-27.874-30.215-43.319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M1997.108 1824.348c3.089 14.561 17.125 45.583 25.117 52.421-3.99-11.412-6.18-19.029-6.733-31.278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M1995.745 1814.122c3.178 17.768 13.719 32.493 31.442 37.262-14.14-10.572-27.02-32.539-28.698-50.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M1988.786 1793.97c5.503 12.04 27.291 45.657 40.726 52.9-8.622-11.035-25.162-35.852-29.299-52.045"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M1992.52 1787.583c-1.155 6.897-6.897 10.795 5.518 51.475.915-23.435.224-41.82-2.294-49.631M1997.108 1789.877c3 10.346 5.294 20.917 28.955 42.749-5.053-10.795-23.436-50.786-29.87-52.855"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M1986.088 1759.782c-2.294 5.744-8.967 43.888 2.518 76.981.465-18.158 8.113-51.13 9.027-66.064"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M1984.469 1738.176c-2.294 5.068-9.417 34.937-9.641 52.166 3.898-6.208 15.849-22.521 17.918-38.835 2.758 11.035-1.141 15.624 21.607 47.336-3.45-13.09-11.726-52.39-19.313-65.031"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M1992.985 1728.296c-3.688 3.222-6.897 13.328-5.292 22.984 1.604 9.656 8.501 59.978 8.501 59.978 3.223-25.97 4.603-72.617 0-81.345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M1988.562 1696.597c-1.56 9.19-15.58 68.704-20.167 77.895 6.207-6.897 37.216-47.801 25.28-71.014"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2001.022 1685.786c-3.223 7.362-17.228 22.746-1.38 61.13-.464-20.451 1.38-61.13 1.38-61.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2001.022 1685.786c-3.223 7.362-17.228 22.746-1.38 61.13-.464-20.451 1.38-61.13 1.38-61.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M1995.745 1679.818c-6.673 4.589-23.902 25.506-30.8 50.096 5.053-6.897 30.65-29.193 33.484-43.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2007.23 1664.884c-2.76 8.952-8.742 26.884-7.587 38.835 1.154 11.95 10.72 54.144 10.03 63.65 1.005-13.568 1.064-38.145 0-54.46-1.064-16.312.765-39.763 7.2-56.992l1.617-4.603-9.49 5.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2007.23 1664.884c-2.76 8.952-8.742 26.884-7.587 38.835 1.154 11.95 10.72 54.144 10.03 63.65 1.005-13.568 1.064-38.145 0-54.46-1.064-16.312.765-39.763 7.2-56.992l1.617-4.603-9.49 5.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M1995.04 1682.577c-4.813 5.518-20.212 31.249-23.437 57.669 5.053-11.95 14.485-23.887 19.312-30.094 4.83-6.208 17.229-31.49 14.696-42.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M1995.04 1682.577c-4.813 5.518-20.212 31.249-23.437 57.669 5.053-11.95 14.485-23.887 19.312-30.094 4.83-6.208 17.229-31.49 14.696-42.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2019.855 1652.243c.24 8.967-3.209 42.044-3.674 51.927-.45 9.88.06 27.574-2.864 36.076-.12-5.968-4.379-29.614-3.899-39.511.466-9.911 2.864-40.214 6.54-45.972M2004.68 1679.818c.016 6.658 4.56 25.266 4.95 32.388M2004.68 1658.45c-4.813 7.813-29.389 39.286-36.286 47.788 5.518-3.21 28.954-13.09 44.923-48.476"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2037.098 1635.466c-8.037 2.533-48.25 22.52-66.634 52.165 14.933-12.64 46.647-33.783 61.581-37.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2037.098 1635.466c-8.037 2.533-48.25 22.52-66.634 52.165 14.933-12.64 46.647-33.783 61.581-37.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2040.247 1625.584c-7.572.689-30.41 5.683-48.011 31.249 8.726-7.123 18.832-15.625 35.835-20.454"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2041.238 1631.102c-8.052 8.726-24.815 17.228-25.506 68.478 6.433-25.055 17.004-51.01 34.457-64.114Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2041.238 1631.102c-8.052 8.726-24.815 17.228-25.506 68.478 6.433-25.055 17.004-51.01 34.457-64.114Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2043.997 1624.668c-11.038 4.59-35.988 21.533-46.484 34.083 11.547-7.437 33.619-18.458 45.553-23.286Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2043.997 1624.668c-11.038 4.59-35.988 21.533-46.484 34.083 11.547-7.437 33.619-18.458 45.553-23.286Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2047.67 1629.258c-3.45 7.586-19.987 53.079-22.057 65.495 5.742-8.967 34.456-58.598 36.526-74.447 2.07-15.865 0-.93 0-.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2047.67 1629.258c-3.45 7.586-19.987 53.079-22.057 65.495 5.742-8.967 34.456-58.598 36.526-74.447 2.07-15.865 0-.93 0-.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2023.543 1628.567c-5.982.93-28.144 8.053-34.98 23.212-1.336-4.364 4.646-25.972 43.018-31.473Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2023.543 1628.567c-5.982.93-28.144 8.053-34.98 23.212-1.336-4.364 4.646-25.972 43.018-31.473Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2048.808 1615.477c-6.192-1.604-27.799-7.812-47.786 8.728 8.501-2.76 24.125-4.364 34.697-1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2048.808 1615.477c-6.192-1.604-27.799-7.812-47.786 8.728 8.501-2.76 24.125-4.364 34.697-1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2060.759 1603.062c-5.743-1.14-22.97-3.449-32.163 8.501 6.897-3.209 16.09-3.898 25.97-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2060.759 1603.062c-5.743-1.14-22.97-3.449-32.163 8.501 6.897-3.209 16.09-3.898 25.97-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2075.244 1595.715c-4.603-2.983-17.918-8.967-34.247-1.155 6.207-.225 15.639-.225 21.382 6.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2075.244 1595.715c-4.603-2.983-17.918-8.967-34.247-1.155 6.207-.225 15.639-.225 21.382 6.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2097.076 1602.103c-2.07-5.01-17.244-18.338-45.958 3.269 10.106-.466 30.333-5.07 37.906-3.914M2051.807 1614.098c-5.293-1.154-20.002-5.308-34.007 20.212 12.177-8.037 19.298-8.037 25.266-8.037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2079.832 1604.682c-5.322-2.37-20.212-6.897-36.99 14.934 10.106-2.76 30.332-14.484 33.092-14.245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2075.244 1607.89c-4.468-.674-33.857 8.982-40.44 23.212 10.796-5.294 27.335-12.641 36.076-16.553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2097.076 1602.103c-5.292-2.715-25.746-1.634-35.732 9.432 11.83-2.954 17.349-3.644 25.61-2.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2097.076 1602.103c-5.292-2.715-25.746-1.634-35.732 9.432 11.83-2.954 17.349-3.644 25.61-2.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2032.495 1642.362c2.684-5.354 10.347-22.056 31.338-25.64.571 4.692-9.805 12.684-15.938 15.984-6.134 3.298-10.602 5.218-15.4 9.656"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2032.495 1642.362c2.684-5.354 10.347-22.056 31.338-25.64.571 4.692-9.805 12.684-15.938 15.984-6.134 3.298-10.602 5.218-15.4 9.656Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2058.12 1624.205c5.398-8.503 18.263-23.047 32.283-16.344-2.07 2.564-7.347 4.498-12.865 5.143-5.518.63-19.417 11.2-19.417 11.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2058.12 1624.205c5.398-8.503 18.263-23.047 32.283-16.344-2.07 2.564-7.347 4.498-12.865 5.143-5.518.63-19.417 11.2-19.417 11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2060.759 1633.17c.464 4.14-1.604 12.401-6.657 28.37-5.052 15.984-5.983 16.899-7.347 24.246-.93-6.432-1.619-34.922 3.433-45.493"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2071.33 1620.306c-.225 3.673-22.147 32.402-23.66 44.113.45-13.33-2.339-36.932 22.101-48.747"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2067.657 1622.375c-.69 10.106-2.07 19.522-5.519 28.024-3.447 8.502-6.88 13.105-7.121 25.28 4.603-11.26 26.03-54.07 33.602-63.486"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2075.933 1632.015c-.689 6.208-4.362 26.196-7.812 34.008 5.744-6.883 22.911-36.242 25.67-43.363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2082.367 1626.962c-.227 5.744-1.035 17.005-3.165 24.817 4.32-8.277 7.302-11.486 11.201-16.314 3.914-4.829 12.642-17.814 9.882-22.461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2056.636 1629.032c4.229-3.33 13.646-5.968 18.608-7.812 4.574-1.694 14.244-5.743 12.641-8.726-1.62-3-10.691-.96-15.174 1.14-4.484 2.098-16.075 15.398-16.075 15.398"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2056.636 1629.032c4.229-3.33 13.646-5.968 18.608-7.812 4.574-1.694 14.244-5.743 12.641-8.726-1.62-3-10.691-.96-15.174 1.14-4.484 2.098-16.075 15.398-16.075 15.398Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2097.526 1615.178c.48-2.805-10.707-5.008-15.16 0-4.454 5.007-8.097 13.165-10.017 21.667-1.933 8.5-4.228 16.089-5.833 18.847 4.125-4.378 7.693-12.19 12.686-20.226 5.01-8.038 17.635-16.225 18.324-20.288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2097.526 1615.178c.48-2.805-10.707-5.008-15.16 0-4.454 5.007-8.097 13.165-10.017 21.667-1.933 8.5-4.228 16.089-5.833 18.847 4.125-4.378 7.693-12.19 12.686-20.226 5.01-8.038 17.635-16.225 18.324-20.288Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2261.835 1777.417c3.898 3.448 9.43 3.524 13.419 6.687-.57.12-1.305-.135-1.844.06 2.008 1.545 4.529 4.018 5.472 6.672-.224.24-1.11 0-1.35.225 1.515 1.635 2.699 3.973 3.75 5.968-.496.21-1.185-.164-1.68.06.765 2.744.975 5.968.12 8.743-2.803.059-5.292-1.036-7.047-3.194-.075.674.119 1.394.164 1.979-3.283-.571-6.072-2.834-6.866-6.103a10 10 0 0 0-.555 2.114c-1.89-2.37-2.7-5.503-2.595-8.546-.39.614-.57 1.303-.808 1.993-2.026-5.592 2.308-11.935-.526-16.658"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2269.405 1802.066c0-3.389-.135-6.972.106-10.255 2.294 1.678 5.233 2.19 7.602 3.704"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2277.233 1801.946c-2.985-2.039-5.639-5.067-7.139-8.382M2264.937 1794.36c1.8-2.923 1.71-6.583 1.306-9.822 2.502 2.73 6.267 2.849 9.026 4.888"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2269.512 1791.811c-.646-1.17-1.8-3.929-2.28-5.144M2266.243 1784.538c-.676-1.378-2.551-4.198-3.615-5.217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2257.861 1821.98c-5.489 3.553-17.71 6.852-19.733 14.02.18.225 1.05.21 1.334.48-2.82 2.052-5.233 4.917-5.218 8.53.495.27 1.005-.255 1.514.015-1.274 2.984-1.514 6.36-1.454 9.672 2.788-.884 5.503-2.519 7.407-4.694.015.705-.09 1.441-.15 2.16 1.56-1.575 3.51-2.55 5.038-4.123.061.645-.194 1.334-.15 1.98 2.175-1.455 4.14-3.66 5.368-6.074.21.39-.045 1.004.031 1.514 6.701-4.962 4.587-13.84 5.053-21.156"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2237.347 1849.629c3.33-2.789 4.56-7.722 8.007-10.046"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2244.32 1847.679c1.125-3.043 1.784-6.341 1.47-9.641-2.7 1.605-5.429 3.959-8.532 4.543M2241.396 1834.634c2.46-2.1 5.532-1.693 8.022-3.402-.195 3.238.974 6.22.451 9.534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2245.58 1838.338c1.244-1.95 1.949-4.198 3.389-6.057M2249.539 1831.066c1.29-2.144 3.763-3.253 5.802-4.588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.736,
    d: "M2256.45 1822.744c-.18 6.972-4.558 15.834.524 21.982.3-.03.81-.795 1.23-.87.106 3.719 1.185 7.573 4.364 9.776.54-.27.39-1.034.93-1.32 1.874 2.94 4.693 5.219 7.647 7.199.9-2.985 1.11-6.358.346-9.341.629.419 1.214.959 1.798 1.454-.435-2.34-.12-4.634-.584-6.928.599.345 1.064.99 1.649 1.349.03-2.803-.72-5.862-2.114-8.412.479.06.856.645 1.365.9-.345-8.892-9.448-12.476-15.61-17.363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.736,
    d: "M2268.58 1853.647c-.45-4.603-4.061-8.697-4.018-13.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.736,
    d: "M2271.07 1846.375c-1.995-2.834-4.499-5.443-7.603-7.183-.225 3.33.211 7.168-1.154 10.226M2257.814 1840.948c-.374-3.435 1.846-5.864 1.846-9.087 2.728 2.159 6.073 2.954 8.681 5.443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.736,
    d: "M2263.588 1839.568c-.96-2.28-2.504-4.273-3.284-6.671M2259.57 1831.65c-1.096-2.444-.586-5.279-.525-7.872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2258.55 1820.33c-2.684 7.513-9.882 10.766-13.03 17.393.615.075 1.14-.435 1.799-.299-.825 4.093-3.78 7.331-3.39 11.845.526-.15 1.11-.735 1.666-.826-.404 2.535-.3 5.43.6 7.53.45-.152.795-.812 1.29-.976-.69 3.3.915 6.327 1.934 9.221.735-2.309 2.235-4.364 3.764-5.952.164.63.015 1.378.209 1.903 1.275-2.309 2.34-4.993 3.614-7.287.435.481.164 1.035.554 1.56 1.755-2.324 2.369-5.443 2.416-8.412.419.465.749 1.185 1.123 1.68 1.035-3.015 1.035-6.224.585-9.433.539.645 1.064 1.245 1.529 1.995 1.335-7.12-4.798-12.34-4.138-19.762"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2247.874 1852.043c3.119-1.02 5.113-3.823 6.208-6.837.614 2.278 1.904 3.614 3.088 5.458M2248.384 1846.014c3.523-1.558 6.191-4.752 7.376-8.276.194 2.43 1.095 4.214 1.935 6.372M2251.487 1836.179c3.27-1.2 5.698-4.003 6.043-7.452-.239 3.358.586 6.793 2.234 9.52M2252.867 1851.353c-.42 2.25-1.334 4.258-2.76 6.028"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2256.196 1836.764c.479-1.05.674-2.25.585-3.45M2254.022 1845.61c-.166-1.574.224-3.073 1.14-4.138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2259.764 1778.106c-5.173 4.003-14.244 6.117-15.653 13.42.195.21 1.063.12 1.38.36-2.64 2.294-4.815 5.353-4.485 8.952.51.224.975-.346 1.5-.12-1.006 3.088-.96 6.476-.63 9.776 2.713-1.125 5.278-2.985 6.987-5.308.075.705.03 1.44.03 2.16 1.426-1.71 3.283-2.85 4.663-4.529.136.63-.075 1.35.03 1.98 2.04-1.65 3.824-3.99 4.828-6.509.24.376.06 1.005.164 1.515 6.254-5.518 3.405-14.184 3.256-21.517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2244.59 1805.171c3.074-3.059 3.884-8.083 7.137-10.691"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2251.383 1802.637c.855-3.12 1.244-6.478.63-9.73-2.534 1.812-5.068 4.391-8.112 5.247M2247.35 1789.892c2.277-2.31 5.382-2.174 7.705-4.08.091 3.256 1.5 6.119 1.261 9.477"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2251.833 1793.22c1.079-2.038 1.589-4.348 2.879-6.327M2255.16 1785.632c1.11-2.249 3.48-3.553 5.398-5.053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2262.584 1775.752c.479 7.961 4.873 13.48 6.057 20.707-.614-.09-.975-.72-1.65-.78-.345 4.168 1.59 8.097-.044 12.311-.45-.286-.855-1.005-1.365-1.245-.314 2.55-1.214 5.294-2.668 7.078-.39-.286-.541-1.006-.976-1.32-.24 3.36-2.624 5.832-4.408 8.321-.075-2.413-.93-4.798-1.965-6.76-.328.568-.404 1.317-.718 1.767-.601-2.564-.87-5.443-1.455-7.992-.555.33-.45.931-.974 1.334-1.035-2.728-.765-5.892.029-8.756-.54.33-1.05.944-1.558 1.305-.151-3.193.733-6.267 2.068-9.22-.705.464-1.38.898-2.024 1.483.705-7.198 8.112-10.917 9.552-18.233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2262.404 1809.564c-2.715-1.844-3.854-5.098-4.064-8.291-1.23 2.008-2.834 2.938-4.499 4.377M2263.572 1803.627c-2.938-2.474-4.616-6.268-4.768-9.987-.87 2.265-2.233 3.735-3.628 5.578M2263.333 1793.325c-2.804-2.054-4.35-5.443-3.72-8.832-.704 3.285-2.457 6.343-4.797 8.518M2257.785 1807.51c-.226 2.28.104 4.467.976 6.567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2258.654 1792.576a7 7 0 0 1 .405-3.48M2258.28 1801.678c.601-1.471.629-3.03.044-4.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2264.562 1725.355c4.14 4.093 10.002 4.168 14.244 7.932-.613.135-1.378-.164-1.978.075 2.13 1.815 4.813 4.754 5.817 7.903-.239.284-1.17 0-1.425.27 1.605 1.933 2.85 4.708 3.974 7.077-.524.24-1.275-.195-1.784.075.81 3.254 1.035 7.062.12 10.346-2.968.075-5.608-1.23-7.467-3.779-.089.795.135 1.65.18 2.34-3.493-.66-6.448-3.344-7.303-7.227a14 14 0 0 0-.569 2.503c-2.009-2.804-2.879-6.523-2.745-10.136-.418.734-.614 1.56-.869 2.37-2.144-6.629 2.445-14.14-.555-19.749"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2272.6 1754.58c0-4.02-.15-8.262.104-12.145 2.444 1.98 5.548 2.593 8.068 4.377"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2280.892 1754.445c-3.165-2.43-5.969-6.013-7.558-9.957M2267.847 1745.447c1.92-3.462 1.828-7.81 1.394-11.635 2.653 3.224 6.658 3.375 9.581 5.773"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2272.705 1742.435c-.676-1.396-1.905-4.665-2.415-6.104M2269.241 1733.812c-.72-1.634-2.699-4.978-3.823-6.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2262.373 1726.181c-5.487 4.738-15.1 7.241-16.598 15.908.209.24 1.14.135 1.454.435-2.79 2.715-5.084 6.327-4.738 10.587.539.268 1.035-.39 1.589-.136-1.063 3.673-1.02 7.678-.674 11.591 2.879-1.336 5.592-3.539 7.423-6.298.06.84.028 1.71.028 2.564 1.515-2.009 3.48-3.373 4.95-5.368.119.75-.091 1.59.015 2.354 2.174-1.948 4.047-4.738 5.126-7.72.255.45.047 1.182.182 1.798 6.627-6.553 3.597-16.823 3.432-25.507"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2246.299 1758.253c3.254-3.613 4.109-9.58 7.542-12.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2253.481 1755.255c.9-3.705 1.32-7.678.676-11.532-2.699 2.146-5.369 5.22-8.592 6.224M2249.209 1740.14c2.413-2.73 5.697-2.564 8.17-4.828.092 3.854 1.59 7.257 1.336 11.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2253.963 1744.084c1.139-2.415 1.693-5.144 3.043-7.482M2257.5 1735.102c1.17-2.668 3.689-4.213 5.729-5.997"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.745,
    d: "M2264.009 1722.866c-1.83 8.998-8.638 13.465-11.038 21.473.615.044 1.08-.6 1.77-.525-.36 4.858-2.94 8.906-2.055 14.11.511-.225 1.021-.96 1.56-1.11-.12 2.983.3 6.343 1.44 8.712.434-.226.705-1.035 1.183-1.29-.33 3.914 1.605 7.287 2.94 10.556.494-2.743 1.74-5.279 3.104-7.287.224.718.164 1.605.404 2.204 1.02-2.82 1.77-6.043 2.79-8.817.494.51.284 1.17.734 1.74 1.47-2.864 1.74-6.554 1.455-10.002.464.494.885 1.305 1.304 1.844.69-3.613.345-7.347-.479-11.035.63.705 1.214 1.35 1.753 2.174.526-8.413-6.16-13.885-6.342-22.597"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.745,
    d: "M2256.915 1760.773c2.984-1.485 4.665-4.933 5.414-8.548.869 2.595 2.31 4.034 3.703 6.059M2256.75 1753.71c3.329-2.144 5.623-6.102 6.419-10.315.464 2.789 1.559 4.798 2.638 7.212M2258.745 1741.985c3.118-1.71 5.218-5.219 5.173-9.252.135 3.929 1.349 7.827 3.284 10.871M2261.82 1759.498c-.167 2.653-.856 5.083-2.07 7.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.745,
    d: "M2263.499 1742.21c.359-1.26.419-2.684.18-4.078M2262.313 1752.706c-.346-1.815-.104-3.6.69-4.918"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2240.226 1667.163c-.749 10.256-7.932 15.58-9.49 24.815.733-.06 1.168-.84 1.978-.84.33 5.428-2.053 10.302-.21 15.955.555-.33 1.035-1.215 1.65-1.47.314 3.33 1.334 7.002 3.013 9.447.481-.315.676-1.23 1.186-1.59.224 4.393 3.013 7.843 5.066 11.277.136-3.12 1.215-6.12 2.49-8.533.376.765.435 1.755.81 2.369.75-3.268 1.14-6.957 1.89-10.195.66.51.51 1.275 1.124 1.845 1.29-3.405 1.034-7.543.15-11.322.63.48 1.23 1.32 1.814 1.86.255-4.124-.736-8.202-2.265-12.191.84.689 1.62 1.334 2.385 2.158-.69-9.401-9.342-14.5-10.886-24.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2237.873 1709.626c3.269-2.083 4.678-6.162 4.993-10.27 1.425 2.728 3.314 4.122 5.248 6.163M2236.598 1701.814c3.553-2.864 5.622-7.616 5.893-12.4.974 3.045 2.564 5.1 4.182 7.632M2237.108 1688.514c3.373-2.369 5.278-6.552 4.603-11.02.764 4.318 2.79 8.486 5.518 11.561M2243.39 1707.483c.225 2.968-.21 5.773-1.289 8.397"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2242.686 1688.05c.224-1.44.075-3.029-.405-4.529M2242.926 1699.881c-.675-1.965-.69-3.989.03-5.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.757,
    d: "M2246.299 1667.178c11.606.869 6.463 7.347 7.273 13.84.464-.496.66-1.424 1.2-1.845.345 3.224 1.334 7.692 3.464 10.675.39-.028.689-1.123 1.064-1.183.749 2.788 2.413 5.788 3.823 8.382.525-.346.556-1.35 1.095-1.665 2.34 2.879 5.518 5.563 8.892 6.793 1.784-2.804 2.205-6.18 1.049-9.627.749.434 1.366 1.2 1.949 1.695 1.44-3.794.839-8.367-2.04-11.682.826.242 1.725.616 2.505 1.05-1.258-3.747-3.973-6.956-7.168-9.177.872.076 1.696.42 2.549.69-4.497-6.326-18.967-8.981-27.468-8.981"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.757,
    d: "M2274.864 1689.715c-3.464-2.595-7.062-5.489-10.571-7.737.299 3.613-.976 7.002-.885 10.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.757,
    d: "M2269.946 1697.587c-.271-4.589-1.755-9.612-4.229-13.676M2269.72 1679.248c-4.108-.39-7.811-3.283-10.886-6.177 1.26 4.633-.929 8.577-.54 12.939"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.757,
    d: "M2264.293 1681.978c-.81-1.56-2.924-4.844-3.884-6.27M2258.834 1673.07c-.988-1.74-2.398-4.048-5.428-5.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2239.191 1668.093c8.907 2.953 2.385 15.084 4.274 21.59.345-.433.96-.9 1.335-1.364.076 4.92-.825 10.497 1.664 14.92.285-.944.915-1.904 1.124-2.834-.239 4.064 1.23 8.472 3.464 11.8.57-.868 1.844-1.453 2.414-2.338 1.664 6.567 11.006 6.973 11.562 12.684 1.56-6.312 6.671-11.17 3.282-17.677.63.12 1.365-.015 1.995.089 2.054-7.077-.27-12.7-4.633-18.127.644-.031 1.304-.301 1.873-.376-1.138-6.327-6.64-10.106-12.04-12.595.691-.12 1.29-.524 1.965-.69-2.384-3.66-6.896-3.553-10.346-5.143-2.669-1.215-5.398-3.658-7.933.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2240.226 1667.643c9.567 4.018 10.571 14.528 21.832 16.073M2254.592 1683.027c4.978 7.736.63 14.708.689 22.76M2267.111 1695.787c-2.369-3.404-5.518-5.549-9.07-7.347M2258.73 1695.907c5.292 5.802 1.994 14.665 6.207 21.021M2250.347 1680.972c.3 4.964-2.413 9.027-1.964 13.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2196.954 1636.904c4.153 9.4-5.204 6.837 3.523 26.975.615-.39.63-1.29 1.349-1.68 2.85 4.649 3.029 10.06 7.302 14.185.33-.54.346-1.544.764-2.07 1.86 2.79 4.47 5.549 7.108 6.928.286-.494.016-1.41.302-1.95 2.247 3.765 6.34 5.504 9.759 7.573-1.334-2.834-1.798-5.968-1.814-8.696.69.494 1.215 1.334 1.846 1.694-.871-3.224-2.281-6.657-3.12-9.881.81.135 1.049.884 1.843 1.094-.464-3.6-2.622-7.138-5.173-10.061.78.119 1.71.585 2.476.78-1.711-3.748-4.5-6.882-7.708-9.687 1.05.226 2.039.42 3.105.795-5.024-7.992-15.055-8.426-20.948-16.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2215.067 1676.114c1.903-3.39 1.243-7.632-.405-11.425 2.517 1.754 4.857 2.084 7.526 2.984M2210.27 1669.802c1.797-4.184 1.393-9.341-.617-13.705 2.28 2.219 4.647 3.298 7.271 4.769M2204.48 1657.82c1.86-3.658 1.574-8.261-1.11-11.89 2.714 3.465 6.433 6.178 10.301 7.618M2218.934 1671.63q2.385 3.78 2.79 8.007"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2209.188 1654.792c-.495-1.38-1.364-2.698-2.503-3.808M2214.946 1665.124c-1.515-1.41-2.474-3.194-2.578-4.918"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2205.56 1634.236c6.896 4.602 13.3 14.92 22.416 13.374.15-.344-.33-1.393-.18-1.89 3.81 2.25 8.307 3.54 12.355 1.515.03-.75-.824-1.064-.794-1.83 4.033-.134 7.947-1.723 11.65-3.642-2.488-2.848-5.772-5.204-9.22-6.283.78-.404 1.664-.69 2.503-1.02-2.608-1.004-4.738-2.788-7.302-3.748.69-.434 1.604-.51 2.294-.93-2.804-1.798-6.313-2.923-9.672-3.044.33-.465 1.14-.525 1.695-.9-9.146-5.263-17.978 2.235-26.45 5.743"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2243.63 1640.802c-4.888-2.444-11.096-1.154-15.533-4.002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2237.737 1633.515c-4.003.36-8.066 1.395-11.604 3.628 3.222 2.34 7.332 4.304 9.64 7.693M2224.648 1644.311c-3.659-1.769-4.845-5.698-8.083-7.737 3.734-1.574 6.463-4.633 10.467-5.863"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2226.583 1637.234c-2.85-.42-5.758-.015-8.607-.705M2216.31 1636.53c-3.089-.36-5.653-2.715-8.23-4.424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2195.619 1630.172c3.704 8.531 5.143 26.374 15.204 31.022.375-.195.599-1.423 1.095-1.738 2.249 4.437 5.817 8.531 11.185 9.415.539-.614-.09-1.454.45-2.099 4.079 2.535 9.01 3.72 13.96 4.5-.525-4.125-2.19-8.323-4.873-11.517 1.064.165 2.114.495 3.163.765-1.888-2.579-2.788-5.534-4.677-8.052.96.06 1.919.6 2.892.705-1.558-3.404-4.257-6.702-7.51-9.01.644-.197 1.484.298 2.278.327-5.487-10.585-19.268-9.88-30.004-12.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2231.17 1665.724c-3.193-5.323-10.181-8.277-12.641-13.676"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2230.256 1655.543c-4.198-2.34-8.907-4.11-13.9-4.5 1.604 4.155 4.334 8.562 4.319 13.03M2210.043 1656.292c-2.413-3.943-.944-8.126-2.774-12.025 4.753 1.094 9.522.224 14.305 1.799"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2216.731 1651.419c-2.535-2.22-5.669-3.794-8.022-6.268M2207.06 1644.056c-2.819-2.339-3.75-6.058-5.159-9.236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2156.634 1617.472c5.352 7.84-4.26 6.897 7.047 23.706.57-.451.464-1.26 1.124-1.71 3.432 3.764 4.332 8.607 9.101 11.667.255-.525.135-1.441.48-1.966 2.204 2.234 5.158 4.335 7.962 5.188.195-.494-.18-1.274.03-1.8 2.73 3.046 7.002 4.02 10.661 5.369-1.695-2.34-2.564-5.098-2.938-7.542.75.345 1.363 1.019 2.04 1.26-1.29-2.774-3.135-5.653-4.395-8.412.81 0 1.156.629 1.964.704-.93-3.178-3.539-6.027-6.447-8.276.778 0 1.77.27 2.55.345-2.19-3.12-5.368-5.533-8.923-7.573 1.08.03 2.085.06 3.193.24-6.026-6.432-16.013-5.353-22.88-11.486"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2179.754 1650.024c1.425-3.313.195-7.032-1.933-10.196 2.744 1.214 5.082 1.17 7.84 1.59M2174.162 1645.062c1.215-4.02.135-8.592-2.43-12.207 2.565 1.65 5.038 2.265 7.842 3.209M2166.844 1635.149c1.364-3.553.465-7.646-2.685-10.51 3.15 2.713 7.2 4.603 11.217 5.337M2182.978 1645.437c1.904 2.023 3.178 4.302 3.823 6.777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2171.103 1631.747c-.66-1.17-1.71-2.234-2.97-3.06M2178.165 1640.189c-1.693-1.05-2.863-2.52-3.194-4.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2152.42 1620.816c7.902-12.491 12.64-3.659 20.902-1.425-.314-.764-1.32-1.425-1.5-2.22 4.065 1.17 10.017 2.22 14.875 1.276.18-.45-.944-1.305-.81-1.755 3.794.525 9.507 2.218 13.45 1.904-.104-.75-2.414-3.389-2.474-4.138 4.843-1.215 9.927-3.464 13.407-6.613-2.31-3.358-6.12-5.428-10.917-5.818.959-.614 2.218-.944 3.164-1.335-3.69-3.433-9.536-4.961-15.205-3.373a19 19 0 0 1 2.743-2.279c-5.246-.389-10.704 1.08-15.248 3.569.598-.946 1.499-1.68 2.339-2.52-10.255 1.964-21.997 16.78-27.035 26.256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2195.723 1598.849c-5.157 2.609-10.735 5.204-15.533 8.036 4.543 1.395 7.841 4.455 12.16 6.073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2202.262 1608.115c-5.67-1.92-12.566-2.684-18.909-1.89M2180.144 1599.523c-2.908 4.394-8.563 7.107-13.854 9.132 6.311.84 9.747 5.173 15.204 6.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2180.19 1606.885c-2.325.15-7.542.916-9.807 1.305M2166.29 1608.655c-2.67.284-6.283.734-9.281 3.613"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2159.633 1619.3c6.387 6.583 10.84 19.193 21.097 19.673.24-.33-.03-1.56.269-2.054 3.584 3.314 8.158 5.758 13.016 4.528.224-.795-.615-1.335-.405-2.144 4.408.794 9.027.015 13.495-1.17-2.01-3.674-4.993-6.972-8.473-8.936.946-.254 1.966-.36 2.954-.51-2.578-1.695-4.468-4.123-7.016-5.759.855-.315 1.859-.164 2.714-.448-2.594-2.61-6.133-4.649-9.762-5.578.48-.42 1.38-.286 2.054-.556-8.652-7.826-20.032-1.859-30.063-.074"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2199.337 1635.344c-4.708-3.764-11.74-3.853-15.878-7.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2194.704 1626.124c-4.423-.57-9.086-.406-13.45 1.154 2.939 3.283 6.913 6.372 8.593 10.556M2177.926 1634.655c-3.555-2.773-3.899-7.287-6.914-10.241 4.424-.81 8.127-3.465 12.761-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2181.72 1627.487c-2.985-1.124-6.24-1.379-9.162-2.789M2170.742 1624.31c-3.27-1.125-5.472-4.26-7.856-6.703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2118.713 1598.594c11.441 8.92-2.684 12.385 7.046 26.99.54-.495 1.56-.435 2.204-.945 3.63 4.063 4.86 7.316 9.808 10.6.224-.6.06-1.588.374-2.173 2.325 2.413 5.4 4.663 8.247 5.547.164-.54-.255-1.38-.059-1.98 2.893 3.3 7.211 4.29 10.961 5.699-1.83-2.533-2.85-5.548-3.344-8.231.764.359 1.425 1.094 2.114 1.349-1.44-3.03-3.434-6.148-4.843-9.162.825-.015 1.184.674 2.024.736-1.11-3.451-3.883-6.538-6.912-8.967.793-.015 1.783.268 2.58.33-2.357-3.375-5.67-5.968-9.329-8.142 1.081.015 2.1.029 3.21.208-6.373-6.957-16.33-5.591-23.51-12.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2143.557 1634.236c1.261-3.675-.148-7.738-2.458-11.173 2.804 1.275 5.158 1.186 7.946 1.591M2137.71 1628.897c1.005-4.453-.313-9.46-3.072-13.389 2.653 1.784 5.173 2.413 8.02 3.39M2129.852 1618.146c1.186-3.943.075-8.426-3.207-11.516 3.282 2.926 7.436 4.934 11.5 5.654M2146.556 1629.136c2.01 2.19 3.42 4.65 4.185 7.362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2133.948 1614.323c-.721-1.274-1.815-2.43-3.136-3.313M2141.474 1623.454c-1.755-1.124-3.015-2.7-3.42-4.393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2123.406 1601.458c7.181 1.544 15.624 8.322 22.866 3.583.03-.374-.69-1.11-.703-1.604 3.881.57 8.065.06 10.87-3.223-.18-.675-.992-.645-1.2-1.336 3.374-1.603 6.208-4.468 8.756-7.526-2.937-1.62-6.401-2.49-9.626-2.16.54-.66 1.2-1.23 1.814-1.83-2.503.06-4.827-.734-7.271-.63.45-.644 1.2-1.047 1.664-1.677-2.893-.556-6.193-.27-9.072.869.15-.541.824-.87 1.17-1.41-9.282-1.29-14.53 8.607-20.647 14.86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2157.489 1593.226c-4.845-.36-9.703 3.06-14.29 2.174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2150.366 1588.938c-3.284 1.799-6.403 4.213-8.728 7.498 3.42.884 7.454 1.108 10.408 3.268M2142.494 1603.347c-3.614-.226-5.773-3.269-9.103-3.869 2.7-2.788 4.094-6.507 7.109-9.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2142.028 1596.344c-2.518.69-4.843 2.114-7.467 2.564M2133.152 1599.523c-2.715.824-5.562-.315-8.247-.885"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2117.184 1595.985c8.726 3.358 17.454-2.234 25.58 1.874-1.066.39-1.995.885-2.985 1.409 4.049.436 7.932 1.485 11.2 3.869-.733.344-1.723.539-2.443.96 3.569 1.019 7.122 2.864 9.297 5.968-.78.359-1.35-.195-2.084.239 2.294 2.474 5.158 4.768 7.482 7.228-.69.075-1.545-.361-2.37-.346 1.365 2.565 3.315 5.248 5.834 6.988-3.87.419-8.113 1.574-11.861-.45.045.736.72 1.41.735 2.07-2.88.509-6.402-.301-9.327-1.664-.09.779.39 1.739.39 2.488-5.578-.959-8.427-5.967-13.074-8.426-.406.869.013 1.724-.301 2.533-6.853-6.387-5.953-15.324-14.544-20.646-4.38-2.699-9.747-5.55-11.816-9.672-2.068-4.109-6.552-8.202-8.442-9.957v-8.456c2.759 4.303 10.166 17.228 13.27 19.807 3.104 2.595 1.095 2.504 5.459 4.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2117.184 1595.985c8.726 3.358 17.454-2.234 25.58 1.874-1.066.39-1.995.885-2.985 1.409 4.049.436 7.932 1.485 11.2 3.869-.733.344-1.723.539-2.443.96 3.569 1.019 7.122 2.864 9.297 5.968-.78.359-1.35-.195-2.084.239 2.294 2.474 5.158 4.768 7.482 7.228-.69.075-1.545-.361-2.37-.346 1.365 2.565 3.315 5.248 5.834 6.988-3.87.419-8.113 1.574-11.861-.45.045.736.72 1.41.735 2.07-2.88.509-6.402-.301-9.327-1.664-.09.779.39 1.739.39 2.488-5.578-.959-8.427-5.967-13.074-8.426-.406.869.013 1.724-.301 2.533-6.853-6.387-5.953-15.324-14.544-20.646-4.38-2.699-9.747-5.55-11.816-9.672-2.068-4.109-6.552-8.202-8.442-9.957v-8.456c2.759 4.303 10.166 17.228 13.27 19.807 3.104 2.595 1.095 2.504 5.459 4.184Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2151.415 1622.255c-.104-4.514-2.758-8.084-6.013-10.542 2.969-.074 5.069-1.363 7.723-2.368M2144.323 1619.586c-.6-5.219-3.494-9.822-7.332-12.566 3.014.525 5.503-.089 8.411-.51M2133.571 1612.224c-.269-4.77-2.788-8.936-6.821-10.527 3.973 1.425 8.412 1.425 12.31.135M2152.39 1615.342q3.844 1.934 6.298 5.667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.689,
    d: "M2135.971 1606.105c-1.079-.974-2.46-1.634-3.958-1.904M2145.867 1611.924c-1.964-.3-3.628-1.32-4.572-2.895"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2105.892 1623.724c2.895-8.937 4.962-16.299 10.707-22.956 5.757-6.658 13.448-16.779 13.913-22.522.421-5.398.33-7.692.33-9.986-2.294 1.604-7.226 6.088-5.968 11.365.751 3.134-.809 5.053-2.128 7.123-1.32 2.07-9.596 14.155-19.238 19.432z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2105.892 1623.724c2.895-8.937 4.962-16.299 10.707-22.956 5.757-6.658 13.448-16.779 13.913-22.522.421-5.398.33-7.692.33-9.986-2.294 1.604-7.226 6.088-5.968 11.365.751 3.134-.809 5.053-2.128 7.123-1.32 2.07-9.596 14.155-19.238 19.432z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2130.154 1569.864c-.227 2.76-.106 6.897-.689 8.728-.572 1.844-4.125 3.328-3.675-.69.465-4.019 1.62-4.934 4.364-8.038"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2111.096 1600.843c-4.034 1.77-10.376-1.186-14.02-2.145-3.66-.944-2.76-4.349-8.277.705-1.38 1.26-5.743 1.71-5.218 1.83 3.494.87 9.116 1.738 2.458 6.627-1.604 1.185-5.846 3.48-5.846 3.48s3.328-2.295 7.692 1.153c4.362 3.434 8.187-1.739 9.64 2.684 1.47 4.424 7.483-1.694 8.802-5.068 1.32-3.373 4.769-9.266 4.769-9.266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2111.096 1600.843c-4.034 1.77-10.376-1.186-14.02-2.145-3.66-.944-2.76-4.349-8.277.705-1.38 1.26-5.743 1.71-5.218 1.83 3.494.87 9.116 1.738 2.458 6.627-1.604 1.185-5.846 3.48-5.846 3.48s3.328-2.295 7.692 1.153c4.362 3.434 8.187-1.739 9.64 2.684 1.47 4.424 7.483-1.694 8.802-5.068 1.32-3.373 4.769-9.266 4.769-9.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M2095.636 1613.139c-3.613.974 10.857-8.922 12.011-.135.495 3.883-3 17.633-7.588 24.756-4.603 7.12-8.276 14.02-9.656 19.072.24-5.967 5.518-19.522 6.673-23.662 1.139-4.138 1.919-13.284 1.995-14.574.073-1.29-2.356-5.758-3.435-5.457"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeWidth: 0.689,
    d: "M2095.636 1613.139c-3.613.974 10.857-8.922 12.011-.135.495 3.883-3 17.633-7.588 24.756-4.603 7.12-8.276 14.02-9.656 19.072.24-5.967 5.518-19.522 6.673-23.662 1.139-4.138 1.919-13.284 1.995-14.574.073-1.29-2.356-5.758-3.435-5.457Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m2218.68 1490.545-195.197-18.233c-9.28-19.252-16.569-41.025-21.336-64.475l248.125-2.146c-6.268 32.074-17.274 61.087-31.593 84.854"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a0e1",
    d: "M2125.985 1555.02c-26.66 0-51.76-13.81-72.678-37.14l134.26 11.155c-18.458 16.508-39.48 25.985-61.582 25.985"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2187.566 1529.035-134.259-11.155c-11.32-12.61-21.382-28.04-29.824-45.568l195.196 18.233c-9.146 15.159-19.627 28.204-31.113 38.49M2256.18 1344.177c0 21.292-2.085 41.954-5.908 61.514l-248.125 2.145c-4.094-20.176-6.343-41.587-6.343-63.659Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2038.208 1433.476c0 12.236 9.927 22.176 22.162 22.176 12.25 0 22.176-9.94 22.176-22.176 0-12.25-9.926-22.178-22.176-22.178-12.235 0-22.162 9.927-22.162 22.178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.761,
    d: "M2038.208 1433.476c0 12.236 9.927 22.176 22.162 22.176 12.25 0 22.176-9.94 22.176-22.176 0-12.25-9.926-22.178-22.176-22.178-12.235 0-22.162 9.927-22.162 22.178Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9c753",
    d: "M1974.976 1371.239c12.505 5.607 28.338 19.222 38.34 20.332s14.995 9.506 20.002 12.288c4.993 2.804 24.157 18.638 32.492 19.583 8.339.928 6.674 2.788 15.836 7.45 9.175 4.664 14.168 4.664 24.994 10.242 10.843 5.609 17.514 13.06 20.843 12.116 3.328-.93 10.841-5.578 17.5-8.382 6.672-2.79 20.841-8.381 30.841-13.975 10.002-5.592 12.506-2.804 24.997-8.396 12.505-5.593 32.507-19.808 43.335-24.36 10.839-4.527 35.4-13.853 47.696-16.643v-95.065h-316.876Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2aa00",
    d: "M1958.587 1342.13c8.382 2.938-1.365 4.23 12.054 9.865 13.406 5.67 21.802 5.67 21.802 5.67s6.704 7.137 13.406 7.737c6.702.629 15.924 3.989 19.28 6.507 0 0 2.52-3.987 11.743 4.709h10.06l8.383 4.739h22.626l20.348 1.438s3.328 5.878 9.102 5.878c5.757 0 30.917-11.217 30.917-11.217h9.22s14.247-6.387 19.284-6.387c5.023 0 14.245-1.678 14.245-1.678l21.8-9.208 10.887-.838s8.382-8.668 19.284-11.036c10.9-2.4 20.96-7.678 25.16-10.497v-37.995h-300.576Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00702d",
    d: "M1996.606 1319.125c8.112-102.711 63.966-185.74 129.177-185.74 65.36 0 121.32 82.799 129.236 185.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8d700",
    d: "m1987.933 1319.136 169.314.06c-11.093-15.057-98.376-59.527-163.241-42.253-64.867 17.302-6.074 42.193-6.074 42.193"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292723",
    d: "M2029.961 1183.799s128.636 31.097 202.588 13.165l-36.196-44.564s-85.918 8.786-132.58-3.149c-46.662-11.965-33.812 34.548-33.812 34.548"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0079c7",
    d: "M2125.985 1133.326c-71.898 0-130.18 94.405-130.18 210.852 0 116.439 58.282 210.842 130.18 210.842 71.897 0 130.181-94.403 130.181-210.842 0-116.447-58.284-210.852-130.18-210.852m129.714 390.596c-33.856 51.536-79.918 79.92-129.715 79.92-49.782 0-95.859-28.384-129.716-79.92-31.789-48.357-49.286-112.202-49.286-179.744 0-67.565 17.497-131.411 49.286-179.783 33.857-51.52 79.934-79.89 129.716-79.89 49.797 0 95.86 28.37 129.715 79.89 31.79 48.372 49.287 112.218 49.287 179.783 0 67.542-17.497 131.387-49.287 179.744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1982.909 1281.56 4.049-12.475h13.104l-10.6-7.707 4.049-12.475-10.602 7.707-10.601-7.707 4.049 12.475-10.602 7.707h13.107zM1998.278 1230.55l5.383-11.937 13.03 1.441-9.686-8.816 5.383-11.966-11.38 6.507-9.703-8.816 2.67 12.834-11.382 6.508 13.016 1.41zM2020.8 1186.707l7.573-10.707 12.504 3.898-7.841-10.494 7.57-10.706-12.413 4.197-7.843-10.496.166 13.105-12.402 4.228 12.52 3.87zM2049.573 1145.562l10.317-8.067 10.87 7.318-4.483-12.296 10.317-8.097-13.09.48-4.499-12.325-3.599 12.595-13.104.48 10.87 7.316zM2088.965 1118.003l12.819-2.76 6.569 11.337 1.348-13.045 12.82-2.73-11.994-5.337 1.349-13.016-8.758 9.747-11.98-5.308 6.583 11.336zM2274.339 1281.56l-4.05-12.475h-13.103l10.6-7.707-4.048-12.475 10.6 7.707 10.617-7.707-4.062 12.475 10.6 7.707h-13.105ZM2258.97 1230.55l-5.384-11.937-13.03 1.441 9.702-8.816-5.397-11.966 11.38 6.507 9.7-8.816-2.653 12.834 11.38 6.508-13.028 1.41zM2236.448 1186.707 2228.89 1176l-12.519 3.898 7.843-10.494-7.558-10.706 12.4 4.197 7.857-10.496-.18 13.105 12.415 4.228-12.519 3.87zM2207.69 1145.562l-10.333-8.067-10.855 7.318 4.468-12.296-10.317-8.097 13.106.48 4.484-12.325 3.613 12.595 13.09.48-10.87 7.316zM2168.284 1118.003l-12.805-2.76-6.583 11.337-1.35-13.045-12.804-2.73 11.98-5.337-1.35-13.016 8.758 9.747 11.98-5.308-6.568 11.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m1981.47 1283 4.049-12.475h13.105l-10.602-7.708 4.049-12.474-10.601 7.707-10.601-7.707 4.048 12.474-10.601 7.708h13.105zM1996.84 1231.989l5.381-11.935 13.031 1.439-9.687-8.816 5.383-11.965-11.38 6.506-9.7-8.816 2.667 12.836-11.38 6.507 13.03 1.41zM2019.36 1188.147l7.572-10.707 12.506 3.898-7.843-10.496 7.558-10.706-12.4 4.2-7.842-10.497.164 13.105-12.4 4.228 12.52 3.87zM2048.135 1147.003l10.315-8.067 10.872 7.316-4.484-12.294 10.315-8.1-13.09.483-4.498-12.327-3.598 12.595-13.105.48 10.871 7.318zM2087.524 1119.441l12.821-2.757 6.567 11.334 1.35-13.045 12.82-2.728-11.996-5.308 1.35-13.045-8.757 9.745-11.98-5.307 6.581 11.336zM2272.9 1283l-4.049-12.475h-13.105l10.6-7.708-4.049-12.474 10.603 7.707 10.616-7.707-4.064 12.474 10.6 7.708h-13.105ZM2257.53 1231.989l-5.383-11.935-13.029 1.439 9.7-8.816-5.398-11.965 11.381 6.506 9.702-8.816-2.668 12.836 11.393 6.507-13.029 1.41zM2235.009 1188.147l-7.558-10.707-12.52 3.898 7.843-10.496-7.558-10.706 12.4 4.2 7.843-10.497-.166 13.105 12.402 4.228-12.507 3.87zM2206.249 1147.003l-10.33-8.067-10.871 7.316 4.483-12.294-10.316-8.1 13.105.483 4.484-12.327 3.598 12.595 13.105.48-10.87 7.318zM2166.844 1119.441l-12.806-2.757-6.582 11.334-1.35-13.045-12.804-2.728 11.98-5.308-1.35-13.045 8.758 9.745 11.98-5.307-6.567 11.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b402f",
    d: "M2255.221 1319.136c.63 8.247.96 16.584.96 25.041"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2125.985 1553.22c-69.588 0-128.38-95.737-128.38-209.042 0-113.328 58.792-209.052 128.38-209.052s128.396 95.724 128.396 209.052c0 113.305-58.808 209.043-128.396 209.043m0-421.693c-71.539 0-131.98 97.373-131.98 212.65 0 115.253 60.441 212.642 131.98 212.642 71.554 0 131.995-97.39 131.995-212.642 0-115.277-60.44-212.65-131.995-212.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.44,
    d: "M2125.985 1553.22c-69.588 0-128.38-95.737-128.38-209.042 0-113.328 58.792-209.052 128.38-209.052s128.396 95.724 128.396 209.052c0 113.305-58.808 209.043-128.396 209.043Zm0-421.692c-71.539 0-131.98 97.373-131.98 212.65 0 115.253 60.441 212.642 131.98 212.642 71.554 0 131.995-97.39 131.995-212.642 0-115.277-60.44-212.65-131.995-212.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1992.58 1408.835q.042 2.358-2.173 3.75a12.9 12.9 0 0 1-4.808 1.83c-1.566.26-3.173-.016-4.835-.808-1.65-.79-2.662-1.927-3.024-3.391a61 61 0 0 1-.765-3.422c-.151-.805-.265-1.411-.327-1.823l-.38-2.294 15.313-2.525.139.824c.276 1.656.485 3.06.627 4.18.14 1.12.216 2.338.233 3.679m-16.353.056c.09 1.984-.408 3.409-1.482 4.238-1.072.848-2.525 1.44-4.35 1.733-1.484.247-2.965.05-4.496-.577-1.505-.642-2.48-1.567-2.884-2.802a30 30 0 0 1-.947-3.507 275 275 0 0 0-.558-2.868l14.015-2.328.427 2.682c.129.906.23 2.065.275 3.429m17.605-.333-5.701-34.022-.687.129.357 2.165.232 2.87c.09.946-.006 1.698-.288 2.302-.268.604-.857 1.043-1.756 1.319l-1.976.488-20.54 3.38-2.018.184c-.938.015-1.645-.195-2.122-.72-.46-.477-.826-1.201-1.083-2.207a51 51 0 0 1-.602-2.66 47 47 0 0 0-.429-2.217l-.688.132 5.29 32.15c.72 4.35 1.385 7.739 2.003 10.168.617 2.428 1.402 4.409 2.367 5.947.965 1.514 2.047 2.66 3.217 3.437 1.183.755 2.491 1.016 3.91.78 2.104-.365 3.457-1.585 4.053-3.72.612-2.113.897-4.202.874-6.22q-.037-3.027-.752-7.346l.337-.044c.572 3.377 1.072 5.898 1.513 7.562a33.6 33.6 0 0 0 1.73 4.938 10.54 10.54 0 0 0 3.183 4.09c1.42 1.103 3.06 1.489 4.937 1.179 1.823-.292 3.217-1.23 4.213-2.768.982-1.538 1.607-3.417 1.847-5.594.254-2.178.158-4.8-.246-7.817a321 321 0 0 0-1.176-7.885M1995.506 1500.584c-2.815-.067-5.02-1.634-6.606-4.662-.815-1.559-1.194-3.04-1.162-4.512.02-1.457.467-2.8 1.323-4.055.86-1.237 2.142-2.48 3.84-3.765 1.7-1.267 3.525-2.412 5.449-3.478 2.67-1.423 4.924-2.437 6.769-3.02a18.3 18.3 0 0 1 5.887-.77q3.12.065 5.506 4.638c.81 1.537 1.194 3.04 1.174 4.495-.034 1.451-.478 2.815-1.338 4.052s-2.138 2.497-3.84 3.764-3.526 2.411-5.45 3.476c-2.305 1.233-4.35 2.196-6.181 2.86-1.816.665-3.601.991-5.371.977m20.499 13.271c4.126-2.224 6.268-6.622 6.414-13.177.15-6.533-1.571-13.259-5.174-20.137-3.737-7.159-8.247-12.389-13.521-15.729-5.255-3.317-9.986-3.833-14.192-1.569q-6.509 3.528-6.664 13.086c-.105 6.371 1.65 13.025 5.295 19.991 3.643 6.946 8.127 12.188 13.46 15.715 5.336 3.526 10.14 4.134 14.382 1.82M2064.037 1541.78c2.137 1.84 3.747 4.292 4.83 7.338 1.061 3.039 1.713 6.069 1.967 9.06.237 3 .252 5.945.053 8.865l.844.736 10.251-11.906-38.87-33.101-.445.543q.412.35 1.181 1.05c.511.454 1.264 1.175 2.24 2.159.996.975 1.581 1.813 1.794 2.497s.094 1.429-.399 2.209l-1.207 1.627-13.62 15.847-1.426 1.429c-.723.625-1.39.905-2.002.86-.613-.031-1.343-.367-2.193-.98a41 41 0 0 1-2.132-1.618 38 38 0 0 0-1.579-1.277l-.467.519 25.883 22.259.463-.538-3.45-3.14c-1.014-.981-1.594-1.771-1.765-2.377-.15-.6.027-1.311.55-2.144l1.208-1.626 16.75-19.476zM2142.89 1565.235l-33.227-.261v.706c.348.005.786.005 1.348.029.56.026 1.486.084 2.792.204 1.287.106 2.214.356 2.743.744.548.39.89 1.033 1.042 1.945l.132 2.023.054 20.892-.153 2.025q-.206 1.408-.943 1.951c-.495.362-1.462.598-2.924.694l-3.807.15v.707l33.01.255-.002-.693-3.806-.162c-1.46-.107-2.442-.32-2.935-.665q-.74-.518-.942-2.003l-.153-2.026-.035-21.081.128-2.013c.144-.965.478-1.613 1.011-1.959.552-.329 1.538-.551 3-.647l3.67-.108ZM2228.077 1547.866c-.365.251-.762.537-1.211.878-.445.325-1.194.83-2.203 1.474-1.013.662-1.983 1.11-2.874 1.337-.91.23-1.916.16-3.054-.17l-3.788-1.325-26.874-10.757-5.712 4.518 4.528 28.551.437 4.028c.038 1.181-.078 2.12-.353 2.831-.262.727-.848 1.49-1.75 2.317l-2.164 1.942.445.535 25.595-20.259-.444-.535-2.538 1.786c-.888.551-1.62.956-2.205 1.246-.6.276-1.128.123-1.62-.472-.311-.422-.62-1.329-.895-2.76-.273-1.432-.61-3.457-.978-6.095-.371-2.639-.9-6.558-1.571-11.745a622 622 0 0 1 9.275 3.568c3.18 1.244 5.427 2.168 6.728 2.804 1.296.655 2.143 1.213 2.544 1.721q.7.85.309 1.72-.393.87-1.18 1.687a20 20 0 0 1-1.634 1.525c-.56.451-1.082.897-1.531 1.287l.436.554 14.719-11.639ZM2240.962 1468.585l-16.011 29.11.616.335c.16-.288.389-.68.668-1.153.287-.495.775-1.279 1.499-2.359.709-1.077 1.368-1.78 1.966-2.069.58-.287 1.324-.277 2.179.034l1.842.845 18.345 10.012 1.708 1.091c.76.572 1.182 1.156 1.275 1.772.082.597-.18 1.575-.775 2.896l-1.68 3.425.616.335 15.902-28.906-.627-.352-1.948 3.276c-.778 1.241-1.431 1.981-1.97 2.266-.533.262-1.27.232-2.212-.129l-1.844-.845-18.503-10.076-1.71-1.09c-.783-.59-1.18-1.217-1.23-1.835-.026-.642.25-1.62.85-2.962l1.655-3.268ZM2270.005 1412.214l9.46 8.069-11.783 3.9zm-3.32 12.295-4.91 1.298c-1.141.274-2.007.354-2.613.24-.658-.13-1.067-.47-1.224-1.05-.16-.575-.21-1.29-.141-2.142.056-.852.15-1.683.269-2.456.118-.793.25-1.567.365-2.318l-.7-.126-3.788 19.59.699.127.958-4.064c.41-1.517.87-2.64 1.392-3.363.508-.703 1.082-1.221 1.707-1.51a68 68 0 0 1 2.194-.965 27 27 0 0 1 2.279-.845l27.293-8.63 1.465-7.62-21.907-19.174-2.952-2.815c-.784-.772-1.293-1.572-1.547-2.308-.267-.737-.334-1.747-.225-2.941l.384-2.868-.7-.147-6.357 32.905.699.126c.1-.558.209-1.056.313-1.488.09-.441.304-1.223.655-2.355.324-1.127.647-1.92.933-2.412.282-.449.722-.659 1.327-.546.647.11 1.478.624 2.54 1.5l4.11 3.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1991.996 1409.852q.041 2.36-2.174 3.754a12.8 12.8 0 0 1-4.807 1.826c-1.566.26-3.175-.016-4.837-.806-1.648-.79-2.661-1.927-3.024-3.393a64 64 0 0 1-.763-3.4c-.152-.825-.265-1.433-.328-1.842l-.378-2.294 15.311-2.535.138.822c.279 1.667.488 3.072.628 4.19.141 1.12.218 2.34.234 3.678m-16.354.056c.089 1.984-.408 3.411-1.48 4.26s-2.527 1.418-4.35 1.711c-1.486.25-2.981.051-4.497-.574-1.504-.624-2.479-1.567-2.884-2.804-.42-1.26-.727-2.42-.946-3.506a333 333 0 0 0-.559-2.868l14.015-2.328c.142.887.284 1.794.427 2.683.128.905.231 2.063.274 3.426m17.592-.333-5.674-34.02-.702.13.359 2.163c.078.986.155 1.928.232 2.871.076.944-.021 1.696-.288 2.3-.269.605-.859 1.044-1.757 1.32l-1.977.487-20.537 3.38-2.019.184c-.94.017-1.646-.195-2.122-.717-.461-.48-.825-1.2-1.083-2.21a50 50 0 0 1-.602-2.659c-.152-.824-.285-1.56-.428-2.215l-.688.132 5.29 32.148q1.076 6.525 2.002 10.17c.618 2.428 1.402 4.41 2.368 5.944.966 1.538 2.045 2.661 3.229 3.438 1.171.756 2.479 1.015 3.896.782q3.16-.516 4.055-3.722c.61-2.114.898-4.179.873-6.22q-.036-3.029-.751-7.347l.337-.044c.572 3.38 1.072 5.9 1.513 7.565a33 33 0 0 0 1.728 4.935 10.4 10.4 0 0 0 3.183 4.091c1.42 1.102 3.061 1.488 4.937 1.181 1.825-.292 3.219-1.23 4.214-2.769.982-1.54 1.606-3.417 1.845-5.596.241-2.177.158-4.799-.244-7.817a265 265 0 0 0-1.189-7.885M1994.683 1500.566c-2.816-.067-5.019-1.635-6.606-4.664-.812-1.537-1.194-3.04-1.177-4.515.034-1.451.481-2.795 1.337-4.052.86-1.237 2.142-2.477 3.841-3.765 1.701-1.266 3.525-2.41 5.45-3.475 2.667-1.425 4.922-2.437 6.766-3.023a18.3 18.3 0 0 1 5.903-.767c2.067.04 3.903 1.586 5.493 4.635.81 1.537 1.193 3.041 1.173 4.495a7.3 7.3 0 0 1-1.339 4.052c-.86 1.237-2.137 2.497-3.838 3.765a45.6 45.6 0 0 1-5.45 3.477c-2.307 1.233-4.352 2.194-6.182 2.859-1.816.666-3.602.992-5.372.978m20.5 13.27c4.141-2.221 6.268-6.623 6.415-13.176.15-6.534-1.574-13.259-5.172-20.118-3.755-7.18-8.249-12.408-13.523-15.748-5.258-3.319-9.987-3.834-14.194-1.568q-6.508 3.528-6.664 13.083c-.104 6.371 1.651 13.028 5.297 19.991 3.643 6.946 8.126 12.191 13.46 15.717 5.336 3.526 10.139 4.134 14.382 1.819M2063.166 1541.885c2.138 1.84 3.749 4.293 4.81 7.333a36.2 36.2 0 0 1 1.987 9.065c.237 3.002.254 5.946.052 8.864l.863.742 10.235-11.91-38.852-33.096-.465.538q.412.348 1.18 1.05c.512.454 1.265 1.175 2.243 2.159.993.973 1.58 1.814 1.794 2.496.213.684.092 1.43-.4 2.21l-1.21 1.625-13.617 15.849-1.426 1.428c-.723.624-1.391.906-2.001.876-.613-.046-1.345-.384-2.195-.995a41 41 0 0 1-2.132-1.62c-.568-.486-1.111-.901-1.58-1.277l-.464.522L2047.87 1570l.463-.538-3.451-3.141c-1.012-.98-1.595-1.77-1.763-2.375-.152-.601.026-1.311.549-2.144l1.209-1.626 16.749-19.477zM2141.629 1565.392l-33.23-.263.003.707c.326.004.784.005 1.346.03s1.488.084 2.794.204c1.287.106 2.215.354 2.74.742.552.39.89 1.035 1.024 1.943l.153 2.027.055 20.89-.134 2.027c-.157.938-.471 1.588-.965 1.949-.492.363-1.461.598-2.924.708l-3.805.138v.707l33.01.255-.004-.693-3.804-.162c-1.461-.108-2.441-.322-2.934-.667-.494-.343-.807-1.011-.965-2.005l-.131-2.023-.058-21.082.149-2.011c.144-.966.48-1.614 1.013-1.96.53-.331 1.538-.55 2.998-.646l3.669-.108ZM2226.989 1548.713c-.365.25-.761.537-1.212.879-.443.323-1.195.828-2.208 1.49-1.008.646-1.978 1.091-2.869 1.319-.907.228-1.915.16-3.052-.171l-3.789-1.323-26.875-10.758-5.711 4.519 4.527 28.552.438 4.026c.019 1.183-.097 2.12-.353 2.83-.263.727-.847 1.49-1.768 2.321l-2.145 1.938.437.552 25.595-20.258-.436-.554-2.539 1.788a27 27 0 0 1-2.205 1.246c-.601.277-1.13.124-1.619-.473-.314-.42-.621-1.327-.895-2.759-.275-1.43-.609-3.458-.98-6.096s-.898-6.559-1.588-11.743a529 529 0 0 1 9.292 3.565q4.773 1.867 6.724 2.824c1.3.637 2.149 1.195 2.55 1.703q.7.849.307 1.72-.392.87-1.177 1.686a20 20 0 0 1-1.636 1.526c-.558.45-1.082.899-1.533 1.288l.437.553 14.72-11.637zM2240.127 1469.37l-16.013 29.112.617.333c.16-.288.388-.678.669-1.153.285-.493.775-1.277 1.498-2.357.709-1.079 1.363-1.76 1.965-2.069.583-.289 1.325-.277 2.179.034l1.843.845 18.346 10.01 1.708 1.09c.758.573 1.18 1.16 1.273 1.773.083.597-.178 1.576-.772 2.896l-1.697 3.43.632.33 15.9-28.904-.625-.354-1.948 3.276c-.78 1.241-1.437 2.003-1.971 2.266-.533.264-1.268.233-2.213-.129l-1.843-.845-18.504-10.074-1.71-1.09c-.783-.59-1.193-1.215-1.226-1.837-.03-.64.247-1.62.847-2.96l1.656-3.27zM2269.456 1413.174l9.46 8.071-11.771 3.9Zm-3.305 12.293-4.911 1.3q-1.71.41-2.613.241c-.658-.13-1.067-.473-1.226-1.049-.157-.579-.208-1.293-.138-2.144.054-.852.15-1.685.267-2.456.119-.795.249-1.567.353-2.317l-.687-.127-3.79 19.591.7.126.957-4.063c.413-1.52.87-2.64 1.392-3.344.51-.723 1.084-1.24 1.708-1.533.625-.289 1.36-.61 2.194-.962a28 28 0 0 1 2.267-.844l27.305-8.63 1.464-7.6-21.905-19.195-2.967-2.813c-.768-.776-1.277-1.574-1.532-2.312-.266-.738-.34-1.703-.224-2.939l.382-2.869-.697-.146-6.36 32.903.7.126c.1-.559.21-1.054.299-1.487a50 50 0 0 1 .656-2.353c.336-1.13.66-1.923.946-2.413.283-.45.722-.66 1.328-.546.645.11 1.477.625 2.54 1.5l4.11 3.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2196.904 1317.706c7.107 31.757 29.836 42.062 34.886 41.623-1.215.746-1.848 1.053-3.265 1.206 0 0 2.213 1.08 4.425 2.375l-5.574-1.073 2.524 3.216c-2.754-1.09-4.915-2.806-4.915-2.806l.912 3.085-4.709-3.916.996 3.198c-5.305-3.85-8.193-8.231-8.193-8.231l.217 3.287c-3.908-4.992-16.56-30.9-17.99-40.465"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    d: "M2136.746 1304.693c5.436 8.296 15.252 16.386 24.27 19.873-1.017.703-2.256 1.228-4.355 1.849 8.235.726 36.584 8.02 40.862-5.299.135-.42.15-.869.196-1.259-6.404 11.575-22.613 10.465-34.113-8.277-.286.449.044 1.439-.12 1.919-2.67-2.369-5.398-5.098-7.752-7.677.27 1.233.51 3.148.51 5.383-.911-2.06-3.001-5.466-4.55-7.221.487 1.829.514 2.794.528 4.443-.93-2.838-2.87-5.549-4.038-7.282.196 1.98.349 3.306.262 5.207-1.05-2.488-2.655-4.342-4.38-6.078.48 1.515.999 3.389 1.075 4.438-1.121-1.831-2.886-3.359-4.012-4.618.225 1.079 1.163 3.255 1.343 4.184-1.71-1.482-3.527-3.194-5.301-4.184.363 1.363 1.857 4.019 3.958 5.878-1.79-.24-2.796-.482-4.383-1.279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2136.746 1304.693c5.436 8.296 15.252 16.386 24.27 19.873-1.017.703-2.256 1.228-4.355 1.849 8.235.726 36.584 8.02 40.862-5.299.135-.42.15-.869.196-1.259-6.404 11.575-22.613 10.465-34.113-8.277-.286.449.044 1.439-.12 1.919-2.67-2.369-5.398-5.098-7.752-7.677.27 1.233.51 3.148.51 5.383-.911-2.06-3.001-5.466-4.55-7.221.487 1.829.514 2.794.528 4.443-.93-2.838-2.87-5.549-4.038-7.282.196 1.98.349 3.306.262 5.207-1.05-2.488-2.655-4.342-4.38-6.078.48 1.515.999 3.389 1.075 4.438-1.121-1.831-2.886-3.359-4.012-4.618.225 1.079 1.163 3.255 1.343 4.184-1.71-1.482-3.527-3.194-5.301-4.184.363 1.363 1.857 4.019 3.958 5.878-1.79-.24-2.796-.482-4.383-1.279Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2196.191 1320.267c8.548 34.638 9.97 47.651 17.521 54.69l-2.203-5.426 5.52 4.557-3.628-5.479 5.365 2.716c-2.516-2.804-5.86-5.298-7.914-8.464l4.873 2.968c-6.448-7.12-16.587-37.925-18.82-45.483"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2196.13 1312.978c-.12.21-1.9 11.396-3.564 16.08-2.072 5.824-6.437 10.56-6.81 15.186 0 0 2.395-3.264 4.885-4.72 0 0-3.237 4.233-4.076 9.241 0 0 3.31-4.673 5.238-5.86 0 0-3.901 6.015-4.71 10.403l5.29-5.787c-1.587 3.255-4.17 8.712-4.17 8.712 1.45-1.676 5.125-5.072 5.125-5.072-2.105 3.64-3.724 8.214-3.724 8.214 1.229-1.64 3.547-3.827 3.547-3.827-1.69 3.33-2.395 7.147-2.395 7.147 1.078-1.95 3.443-3.735 3.443-3.735-1.211 2.015-1.95 6.307-1.95 6.307 1.328-2.863 3.303-4.729 3.303-4.729-1.631 3.415-1.394 8.41-1.394 8.41.887-2.403 1.165-3 2.808-4.872-.691 4.164 1.656 9.447 1.656 9.447-.064-2.463.615-5.105.615-5.105.194 3.224 2.762 6.851 2.762 6.851-.273-2.299-.181-4.033-.181-4.033.855 2.64 3.033 5.295 3.033 5.295.045-2.328-.933-6.607-.933-6.607 1.029.627 1.81 3.33 1.81 3.33.06-4.746-2.997-9-2.997-9 .687-.045 1.964.661 1.964.661-.44-4.836-3.61-8.62-3.61-8.62 1.12 0 2.708.964 2.708.964-.671-1.79-3.392-5.445-3.392-5.445.807.08 2.128.62 2.128.62-.36-3.74-1.604-7.523-1.604-7.523 1.074.18 1.582.736 1.582.736-.33-4.108-5.217-21.185-5.778-32.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.553,
    d: "M2203.146 1371.325c-2.518-7.281-5.545-15.547-6.524-24.936-.586-5.61.26-15.106.13-20.993"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2196.333 1319.886s2.7 14.281 17.784 17.614c0 0-1.514-1.055-2.945-2.536 0 0 4.728 2.127 9.083 2.316 0 0-1.95-1.088-3.165-2.612 0 0 5.476 2.18 9.148 1.775 0 0-2.07-1.059-3.236-2.428 0 0 5.104 1.382 9.21.653 0 0-2.426-.467-3.858-2.053 0 0 5.073.83 9.242-.25 0 0-2.178-.186-3.578-1.586 0 0 7.685.236 11.637-4.667 0 0-1.96.653-4.294-.187 0 0 4.232-1.059 6.69-4.076 0 0-1.617.346-3.33-.125 0 0 3.258-1.224 5.249-3.216 0 0-1.327.384-3.257-.052 0 0 2.365-.75 3.61-2.738 0 0-1.494.63-3.112.094 0 0 3.382-1.908 3.589-5.643 0 0-1.401 2.2-3.06 2.905 0 0 2.272-2.849 2.479-5.843 0 0-2.681 2.41-4.175 4.567 0 0 .493-2.603 1.323-4.139 0 0-2.82 1.597-4.216 5.664 0 0-.67-2.458-.358-3.61 0 0-2.116 2.24-2.832 5.29 0 0-.6-1.76-.622-3.018 0 0-2.315 1.836-2.956 5.57 0 0-.654-2.863-.34-4.575 0 0-3.488 3.368-4.234 8.464 0 0-1.401-2.83-.997-6.535 0 0-3.142 4.488-4.201 9.325 0 0-1.43-3.444-1.168-6.237 0 0-2.662 3.737-4.148 8.081 0 0-.246-3.358.065-6.75 0 0-3.086 4.333-5.078 7.466 0 0 .196-2.734 1.483-5.799 0 0-5.654 3.654-8.392 6.403-.953.957-8.298 1.285-11.981-7.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M2200.657 1277.609c-.385 14.535-1.077 25.035-1.672 34.823-.321-1.556-.891-2.669-2.081-2.696-2.601-.061-2.58 3.019-2.581 3.031.08-12.231.561-31.263 1.077-51.275 0 .016.344 11.13 5.257 16.117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292723",
    d: "M2196.988 1309.496c1.189.027 1.676.784 1.997 2.34-.178 2.929-.154 2.222-.353 4.239-.149 5.218-4.16 5.896-4.32-.591-.04-1.608-.011-.027.009-3.051.001-.014.065-2.998 2.667-2.937"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbc9",
    d: "M2206.355 1211.836c-.677 1.174-1.647 1.976-3.05 3.345-1.366 1.332-1.174 3.91-1.346 5.415-.194 1.7-.583 29.968-1.303 57.23-5.284-4.235-5.257-16.098-5.257-16.116.55-21.248 1.1-39.928 1.134-41.266.06-2.34.218-3.823-.899-5.232-.674-.85-1.883-2.07-2.758-3.178-.767-.971-.163-1.85 2.322-2.566 2.154-.62 1.891-1.017 4.336-1.017 2.444 0 2.747.459 3.926.88.85.302 3.766.995 2.895 2.505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.553,
    d: "M2199.742 1326.874c5.698 5.607 22.242 4.909 29.048 2.008 8.028-3.423 12.57-7.818 17.083-14.625"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.888,
    d: "M2196.533 1220.382c.06-2.34.219-3.824-.898-5.233-.674-.85-1.883-2.07-2.758-3.177-.768-.973-.164-1.852 2.322-2.568 2.154-.62 1.891-1.016 4.335-1.016s2.747.46 3.927.88c.848.301 3.764.995 2.894 2.505-.676 1.174-1.647 1.976-3.05 3.345-1.366 1.332-1.173 3.91-1.346 5.416-.328 2.878-1.213 74.067-3.327 95.478-.149 5.218-4.16 5.896-4.32-.59-.37-15.018 2.146-92.133 2.221-95.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2195.934 1313.237c-3.539 17.21-1.74-7.116-5.489-13.443.05 1.362-.32 3.659-1.404 6.407.31-5.07.128-10.005-1.326-12.615.091 1.26-.45 4.35-1.69 7.338.176-2.403.663-8.263-.498-10.545-.255 1.438-1.03 4.747-1.864 6.557.407-3.751.318-7.916-.79-10.637-.28 2.663-.929 5.899-1.552 7.58.214-3.911-.667-9.7-2.287-12.668.372 2.022.855 7.444.043 10.533-.31-4.288-2.424-8.3-3.55-10.304-.107-.24 1.422 7.176 1.11 10.226-1.244-1.867-2.67-5.757-3.315-7.495-.418 3.23-.294 5.596 1.324 9.415-1.307-1.23-2.508-2.788-3.498-4.198.49 2.319 2.982 6.882 3.958 8.472-1.353-.741-3.748-3.255-4.859-4.454 1.395 3.18 4.167 6.827 6.266 9.316-1.564-.74-3.537-2.298-4.932-3.108 2.25 2.79 5.344 6.193 8 8.742-1.813-.644-2.878-.96-4.4-1.905 5.177 6.178 10.086 10 17.214 14.348 0 0 4.23 2.485 4.057-7.821"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.553,
    d: "M2175.957 1295.755c4.64 9.596 8.985 15.736 17.247 24.131M2142.471 1306.767c5.251 4.813 34.271 29.043 50.732 18.907"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2196.904 1317.706c-1.156 6.528-16.34 16.369-40-3.068 0 0 2.06.552 4.145.459 0 0-2.687-5.3-6.96-9.823l3.754.768c-1.929-3.112-5.602-6.248-5.602-6.248l2.88.165c-1.058-2.335-4.216-4.933-4.216-4.933 2.961.857 5.927 3.112 5.927 3.112-.434-2.7-2.326-6.491-2.326-6.491 4.066 2.278 5.271 6.923 5.271 6.923.137-3.044-.43-9.301-.43-9.301s2.82 6.242 3.72 12.874c0 0 1.095-2.892 1.498-6.666 0 0 1.682 4.61 1.788 10.92 0 0 1.564-2.928 1.891-5.058 0 0 .931 4.34 1.012 8.546 0 0 1.251-2.423 1.652-4.447 0 0 1.084 4.425.633 7.7 0 0 1.263-2.235 1.921-4.451 0 0 .905 4.302.507 7.655l2.262-3.822c-.613 2.698.067 4.972 1.171 6.72.971 1.538 1.033 4.862 1.033 4.862 2.22 1.23 17.78.958 16.651-10.284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.553,
    d: "M2156.244 1300.573c2.998 2.79 6.928 8.817 9.76 13.436 2.85 4.618 7.542 9.304 11.65 10.474"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2197.719 1312.432c-.824 15.142-8.282 26.836-17.61 35.405l.395-3.232c-4.032 5.85-11.954 9.68-11.954 9.68 3.392-2.986 5.42-7.94 5.42-7.94-3.932 4.19-10.08 7.122-10.08 7.122 1.7-1.632 4.367-5.875 4.367-5.875-4.023 3.184-8.692 4.523-8.692 4.523 2.545-1.635 5.456-5.228 5.456-5.228-4.082 2.67-9.543 3.112-9.543 3.112 2.925-1.056 6.866-4.253 6.866-4.253-4.546 1.901-10.219 1.743-10.219 1.743 2.5-.793 7.073-3.316 7.073-3.316-5.185 1.262-9.75.287-9.75.287 4.655-.786 7.51-2.382 7.51-2.382-3.899.57-7.969-.337-7.969-.337 2.867-.205 5.708-1.534 5.708-1.534-2.572.021-5.954-1.182-5.954-1.182 2.532.125 4.565-.685 4.565-.685-3.112-.207-5.332-1.762-5.332-1.762 2.262.227 3.983-.624 3.983-.624-2.24-.269-4.25-1.99-4.25-1.99 1.935.323 4.706.518 4.706.518-1.195-.668-3.65-2.988-3.65-2.988 2.15.167 4.898 1.68 4.898 1.68-1.395-3.252-3.326-4.982-3.326-4.982 2.873 1.254 6.402 4.258 6.402 4.258-.332-2.365-2.83-5.436-2.83-5.436 4.721 1.54 6.993 5.357 6.993 5.357-.316-4.106-2.904-5.804-2.904-5.804 5.878 1.194 7.685 6.397 7.685 6.397.367-3.922-1.278-6.158-1.278-6.158 4.886 2.021 6.387 6.996 6.387 6.996.499-4.318-1.531-6.124-1.531-6.124 3.601 1.376 6.142 6.561 6.142 6.561.35-4.464-1.838-6.11-1.838-6.11 6.816 1.258 8.787 5.23 8.787 5.23.046-2.344-1.433-3.972-1.433-3.972 4.97 1.628 5.07 6.422 7.356 4.804 2.52-1.783 4.427-5.396 5.67-10.218.616-2.395 2.4-11.54 2.4-11.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.553,
    d: "M2154.275 1335.25c9.947 6.607 24.501 8.42 34.54.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2199.598 1323.027s4.636 19.217 25.173 17.616c0 0-3.637 2.614-6.717 3.081 0 0 6.542 1.559 10.94-2.56 0 0-.117 2.324-2.188 4.096 0 0 5.063-.89 8.238-4.227 0 0-.156 2.286-1.245 4.184 0 0 5.01-2.146 7.52-5.465 0 0-.414 1.867-1.41 3.858 0 0 4.17-2.098 7.737-6.109 0 0-.634 2.933-2.646 4.634 0 0 1.922-.455 3.393-1.367 0 0-4.076 6.534-12.903 8.983 0 0 2.157 1.991 4.813 1.991 0 0-6.556 2.945-13.733.456 0 0 1.162 2.086 4.99 4.128 0 0-5.913.498-9.507-4.294 0 0 .14 1.681 1.446 3.983 0 0-3.485-2.396-5.227-5.239 0 0 .186 1.816 1.535 3.911 0 0-2.967-2.312-4.57-5.207 0 0 .141 2.272 1.494 4.004 0 0-14.615-7.44-18.424-31.289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.553,
    d: "M2200.252 1326.627c2.427 12.49 20.597 30.889 42.899 16.444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2210.628 1314.637c4.109-3.417 14.568-14.762 17.79-24.329 0 0 .355 4.75-1.308 9.433 0 0 3.507-3.516 4.616-12.096 0 0 .922 3.024.573 5.715 0 0 1.137-2.264 4.3-5.202l-1.782 5.52c1.66-1.609 2.645-2.739 4.829-4.402 0 0-.164 2.917-4.617 7.917l4.617-2.074s-1.438 2.961-5.164 5.711c0 0 2.308.313 4.42-.743 0 0-1.408 2.23-5.515 4.49l5.136-.208c-3.223 3.988-17.58 14.198-25.795 16.626"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.666,
    d: "M2197.586 1313.712c3.35 8.893 5.886-14.22 7.27-26.124l1.86 2.764s-.415-6.8 2.128-12.49l.769 8.2s1.359-1.432 1.795-2.199c0 0 .008 4.513-2.186 9.157l2.186-1.238c-.45 3.33-3.224 8.312-3.224 8.312l2.998-1.614c-1.111 3.21-12.693 33.263-14.43 15.041"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.553,
    d: "M2214.566 1316.555c10.57-6.764 14.433-12.809 19.193-21.196M2198.307 1316.604c4.033 4.892 9.001-19.623 10.676-28.833"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74b500",
    stroke: "#1b402f",
    strokeMiterlimit: 8,
    strokeWidth: 0.666,
    d: "M2196.217 1312.767c-.056 3.354 2.107 18.163 10.407 16.896 10.212-1.56 13.329-20.26 13.54-22.432 0 0-1.236 2.042-2.834 3.452 0 0 1.76-5.688 1.3-9.294 0 0-1.183 5.421-2.691 8.044 0 0 .89-3.609.093-5.88 0 0-.673 4.72-2.468 6.886 0 0 .622-3.132-.041-4.689 0 0-.498 3.755-2.366 6.183 0 0 .477-2.345-.145-4.398 0 0-.384 2.91-2.212 6.297 0 0 .14-2.21-.391-3.663 0 0-.42 3.361-1.94 5.601 0 0-.083-2.115-.436-3.67 0 0-.355 2.823-1.9 5.348 0 0-.008-2.445-.506-3.814 0 0-.622 2.966-1.93 5.062 0 0 .099-2.075-.442-3.803 0 0-1.098 3.293-2.288 4.992-.75-1.355-2.396-5.027-2.072-7.118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b402f",
    strokeLinecap: "round",
    strokeWidth: 0.553,
    d: "M2201.553 1327.138c6.639 4.52 12.113-5.477 15.034-14.706"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.751,
    d: "M2126.27 1302.313c3.478 2.52 6.237 6.566 9.911 6.657-1.229-1.739-.899-2.039-2.114-3.328-1.23-1.26-4.14-3.568-4.844-3.629-.705-.03-2.953.15-2.953.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2115.279 1215.616c-1.035-3.48-6.208-15.024-7.228-16.645-1.034-1.588-.104-3.357-1.034-4.587-.945-1.23-2.818-2.07-3.3-3.57-.463-1.5 1.41-24.23.482-24.71-.945-.45-6.478.749-6.958 2.729-.464 1.979.855 1.89 0 3.388-.84 1.5-.66 2.34-.555 3.75.09 1.41 3.194 14.844 3.374 19.732.195 4.889 1.649 25.34 1.649 25.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.751,
    d: "M2115.279 1215.616c-1.035-3.48-6.208-15.024-7.228-16.645-1.034-1.588-.104-3.357-1.034-4.587-.945-1.23-2.818-2.07-3.3-3.57-.463-1.5 1.41-24.23.482-24.71-.945-.45-6.478.749-6.958 2.729-.464 1.979.855 1.89 0 3.388-.84 1.5-.66 2.34-.555 3.75.09 1.41 3.194 14.844 3.374 19.732.195 4.889 1.649 25.34 1.649 25.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2091.797 1215.316c.286-2.249 4.32-11.815 5.73-14.365 1.408-2.519.748-4.798.943-6.177.18-1.41 1.5-1.529 1.5-2.939s1.59-15.235 1.32-18.023c-.286-2.819.374-4.798 1.68-5.728-.376-.929-.932-2.339.748-4.229 1.695-1.889 4.201-4.057 5.805-4.057 1.59 0 1.152 1.238 1.152 1.238s1.604.57.661 2.549c-.945 1.95-3.569 3.75-3.764 4.499-.18.749.75 2.998-.18 5.068-.946 2.069-3.029 17.183-2.909 20.303.09 2.428.09 4.317-.765 6.657-.84 2.339 1.784 11.455 1.784 15.864l-6.387 3.777Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.751,
    d: "M2091.797 1215.316c.286-2.249 4.32-11.815 5.73-14.365 1.408-2.519.748-4.798.943-6.177.18-1.41 1.5-1.529 1.5-2.939s1.59-15.235 1.32-18.023c-.286-2.819.374-4.798 1.68-5.728-.376-.929-.932-2.339.748-4.229 1.695-1.889 4.201-4.057 5.805-4.057 1.59 0 1.152 1.238 1.152 1.238s1.604.57.661 2.549c-.945 1.95-3.569 3.75-3.764 4.499-.18.749.75 2.998-.18 5.068-.946 2.069-3.029 17.183-2.909 20.303.09 2.428.09 4.317-.765 6.657-.84 2.339 1.784 11.455 1.784 15.864l-6.387 3.777Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2071.6 1220.294c0-1.68 3.943-10.405 3.39-11.726-.57-1.32-2.446-3.21-2.355-4.408.09-1.23 5.443-14.274 5.352-21.231.091-1.68 1.784-2.071 2.624-3.3.856-1.2-1.303-1.108 0-2.61 1.321-1.53 5.173-3.388 9.492-3.206.285.479.195.837 0 1.228 0 0 .945 1.11-.465 2.16-1.41 1.02-2.819 2.519-4.513 2.999 0 0-1.125.929-.75 1.68.374.749-.135 2.638-1.514 4.317-1.394 1.709-3.613 9.417-4.003 14.486-.405 5.066 4.107 12.865 6.267 14.093l-6.267 6.268Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.751,
    d: "M2071.6 1220.294c0-1.68 3.943-10.405 3.39-11.726-.57-1.32-2.446-3.21-2.355-4.408.09-1.23 5.443-14.274 5.352-21.231.091-1.68 1.784-2.071 2.624-3.3.856-1.2-1.303-1.108 0-2.61 1.321-1.53 5.173-3.388 9.492-3.206.285.479.195.837 0 1.228 0 0 .945 1.11-.465 2.16-1.41 1.02-2.819 2.519-4.513 2.999 0 0-1.125.929-.75 1.68.374.749-.135 2.638-1.514 4.317-1.394 1.709-3.613 9.417-4.003 14.486-.405 5.066 4.107 12.865 6.267 14.093l-6.267 6.268Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2054.507 1225.511c.286-2.669 4.14-11.695 4.319-16.673-.09-1.768-.66-3.09-.556-4.408.09-1.319 1.786-3.299 1.786-5.818 0-2.549 1.033-16.614.268-17.484.57-1.589 1.633-2.927 2.579-3.226-1.035-.93-1.17-2.022-.883-3.04.284-1.05 2.53-4.984 4.258-5.19 1.332-.158 1.503.837 1.503.837s1.466-1.017 1.286 1.323c-.195 2.37-.788 4.518-2.79 6.028-1.217.917-.148 1.86 0 2.16.166.268 1.17 2.247 0 4.226-1.154 1.951-1.53 4.02-1.724 6.088-.18 2.071-.375 8.457-.09 9.957s1.59 2.73 1.125 5.82c-.465 3.117.749 12.263 5.068 14.632l-9.296 6.388Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.751,
    d: "M2054.507 1225.511c.286-2.669 4.14-11.695 4.319-16.673-.09-1.768-.66-3.09-.556-4.408.09-1.319 1.786-3.299 1.786-5.818 0-2.549 1.033-16.614.268-17.484.57-1.589 1.633-2.927 2.579-3.226-1.035-.93-1.17-2.022-.883-3.04.284-1.05 2.53-4.984 4.258-5.19 1.332-.158 1.503.837 1.503.837s1.466-1.017 1.286 1.323c-.195 2.37-.788 4.518-2.79 6.028-1.217.917-.148 1.86 0 2.16.166.268 1.17 2.247 0 4.226-1.154 1.951-1.53 4.02-1.724 6.088-.18 2.071-.375 8.457-.09 9.957s1.59 2.73 1.125 5.82c-.465 3.117.749 12.263 5.068 14.632l-9.296 6.388Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2060.954 1261.948c-6.192 10.676-18.848-1.08-14.62-9.656 1.185-2.368 3.644-1.793 6.103-1.313-1.124.03-2.22 1.213-2.49 1.882.676-.046 1.405.15 2.179.364-.762.592-1.188 1.059-1.453 2.066a5.1 5.1 0 0 1 2.029-.073c-.656 1.003-1.04 1.835-1.1 2.638.725-.222 1.3-.218 2.137 0-.248.252-.837.923-.897 2.202 1.8-.21 3.014-1.677 3.989-3.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.751,
    d: "M2060.954 1261.948c-6.192 10.676-18.848-1.08-14.62-9.656 1.185-2.368 3.644-1.793 6.103-1.313-1.124.03-2.22 1.213-2.49 1.882.676-.046 1.405.15 2.179.364-.762.592-1.188 1.059-1.453 2.066a5.1 5.1 0 0 1 2.029-.073c-.656 1.003-1.04 1.835-1.1 2.638.725-.222 1.3-.218 2.137 0-.248.252-.837.923-.897 2.202 1.8-.21 3.014-1.677 3.989-3.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2124.32 1237.539c1.635 1.618 2.385 6.866 3.015 9.266.629 2.369.869 6.627.749 10.496 1.5 1.768 1.004 4.767 1.5 8.786 1.259 2.01 1.124 9.146.885 12.025-.255 2.879.374 4.259 1.875 5.367 1.498 1.142 6.642 3.15 8.515 2.13 1.875-.988 4.004-.24 4.004.75 2.263-.12 3.134 2.759 2.64 4.379 0 0 .929 2.309-2.894 3.899-3.69 1.529-8.008 4.498-9.508 5.637-1.514 1.11-3.134 1.68-6.642 2.008-7.002.632-9.761-3.628-11.771-5.906-2.82-3.18-4.767-10.496-5.516-13.765-.751-3.27-3.255-13.525-4.754-16.524-1.5-3-2.01-4.528-2.76-7.527-3.253 1.019-6.506.75-10.766.509-4.258-.24-11.515 4.259-18.277 5.998-6.777 1.77-17.544-2.49-19.043-7.257-1.5-4.768-5.502-6.748-5.757-9.777-.255-3-1.006-3.987-1.5-5.997-.51-2.01.99-9.776 1.245-12.266.255-2.52 2.395-3.95 3.904-5.037l.354-.241 1.248-.87s.584-2.266 2.32-3.604l.647 3.396c1.209-2.701 2.548-3.374 2.548-3.374l.529 2.814c.962-2.35 2.15-2.95 2.15-2.95l1.31 2.674s.442-1.534 1.47-3.228l1.348 1.792s-.088-1.927.604-3.22l1.854 2.073c.135-2.88 1.635-.51 2.384-2.88.75-2.368.714-2.03 1.487-3.421 0 0 1.26 1.103 2.142 2.67l.71-2.818s1.138 1.095 1.648 1.95l.655-2.52s1.156.48 1.74 1.737l.63-2.366s1.064.347 2.016 2.117l1.143-2.817 1.43 2.559s.845-2.13 2.187-4.018l1.837 3.565c.787-1.846 1.21-2.684 3.133-4.418l.664 3.162s.767-2.31 2.198-3.54l1.266 3.24c.363-1.332.807-2.47 1.66-3.568l1.33 2.958c.353-2.386 1.618-3.378 1.618-3.378l.954 3.089s.576-1.801 1.74-3.336l.638 3.28s.673-1.907 1.872-2.794l1.21 3.17s.449-1.74 1.414-2.554l1.245 3.003 1.71-2.567c.995 1.245 1.198 1.534 1.737 3.327l1.143-1.438s1.44 1.344 1.758 3.53l1.048-1.041s.887 1.85 1.332 3.957l.94-.645c.75 1.685 1.132 4.303 1.132 4.303l.838-.558c.585 2.164.84 4.155.84 4.155l1.115-.447c.366 1.49.612 3.118.527 4.583l.972-.044s.228 4.34-1.568 8.357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 8,
    strokeWidth: 0.751,
    d: "M2124.32 1237.539c1.635 1.618 2.385 6.866 3.015 9.266.629 2.369.869 6.627.749 10.496 1.5 1.768 1.004 4.767 1.5 8.786 1.259 2.01 1.124 9.146.885 12.025-.255 2.879.374 4.259 1.875 5.367 1.498 1.142 6.642 3.15 8.515 2.13 1.875-.988 4.004-.24 4.004.75 2.263-.12 3.134 2.759 2.64 4.379 0 0 .929 2.309-2.894 3.899-3.69 1.529-8.008 4.498-9.508 5.637-1.514 1.11-3.134 1.68-6.642 2.008-7.002.632-9.761-3.628-11.771-5.906-2.82-3.18-4.767-10.496-5.516-13.765-.751-3.27-3.255-13.525-4.754-16.524-1.5-3-2.01-4.528-2.76-7.527-3.253 1.019-6.506.75-10.766.509-4.258-.24-11.515 4.259-18.277 5.998-6.777 1.77-17.544-2.49-19.043-7.257-1.5-4.768-5.502-6.748-5.757-9.777-.255-3-1.006-3.987-1.5-5.997-.51-2.01.99-9.776 1.245-12.266.255-2.52 2.395-3.95 3.904-5.037l.354-.241 1.248-.87s.584-2.266 2.32-3.604l.647 3.396c1.209-2.701 2.548-3.374 2.548-3.374l.529 2.814c.962-2.35 2.15-2.95 2.15-2.95l1.31 2.674s.442-1.534 1.47-3.228l1.348 1.792s-.088-1.927.604-3.22l1.854 2.073c.135-2.88 1.635-.51 2.384-2.88.75-2.368.714-2.03 1.487-3.421 0 0 1.26 1.103 2.142 2.67l.71-2.818s1.138 1.095 1.648 1.95l.655-2.52s1.156.48 1.74 1.737l.63-2.366s1.064.347 2.016 2.117l1.143-2.817 1.43 2.559s.845-2.13 2.187-4.018l1.837 3.565c.787-1.846 1.21-2.684 3.133-4.418l.664 3.162s.767-2.31 2.198-3.54l1.266 3.24c.363-1.332.807-2.47 1.66-3.568l1.33 2.958c.353-2.386 1.618-3.378 1.618-3.378l.954 3.089s.576-1.801 1.74-3.336l.638 3.28s.673-1.907 1.872-2.794l1.21 3.17s.449-1.74 1.414-2.554l1.245 3.003 1.71-2.567c.995 1.245 1.198 1.534 1.737 3.327l1.143-1.438s1.44 1.344 1.758 3.53l1.048-1.041s.887 1.85 1.332 3.957l.94-.645c.75 1.685 1.132 4.303 1.132 4.303l.838-.558c.585 2.164.84 4.155.84 4.155l1.115-.447c.366 1.49.612 3.118.527 4.583l.972-.044s.228 4.34-1.568 8.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.751,
    d: "M2120.586 1297.095c-.419 1.738-1.693 9.956 4.32 11.875.24-1.769-.63-3.328-1.32-5.338-.69-2.04-1.035-3.569-.706-4.708"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.751,
    d: "M2124.006 1307.62c-.75-.66-2.054-1.078-1.59-4.467"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.127,
    d: "M2128.143 1294.127c1.188.119 1.831-.991 2.685-.93.84.03 1.75 1.248 2.321 1.327.58.08.872.082 1.382-.428"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.751,
    d: "M2147.396 1290.467c-.51-.18-1.454 1.5-2.533.75M2139.555 1287.5c.704.148 3.808.06 5.547-1.141M2103.658 1258.56c.135-.99-2.624-3.629-3.748-5.639M2124.32 1237.539c-1.73-1.8-6.012-6.51-6.251-9.778M2089.384 1257.943c-4.082-1.384-7.287-4.182-7.633-8.26M2094.262 1257.07c-1.805-.75-1.805-1.917-3.874-2.423M2087.885 1247.434c-.496-1.32-1.347-3.229-1.826-4.577M2084.87 1240.027a27 27 0 0 1-.99-2.879M2053.635 1252.38c.614-3.72-2.247-5.997-3.446-9.084M2051.687 1239.157c-.419-3.18-1.813-6.07-1.064-9.711M2056.831 1243.026c-.9-1.11-1.365-2.4-1.38-3.869M2065.962 1248.543c-.794-1.798-1.217-3.676-.75-5.686M2067.717 1247.553c.089-3.988-3.599-6.867-4.153-10.915-.616-4.379 1.373-7.888 1.149-12.267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.751,
    d: "M2066.337 1238.017c-.09-2.788-.24-5.788 1.14-8.127M2067.343 1226.74c-.195-1.617.284-3.087 1.379-4.228M2071.226 1225.123c.884-2.49 2.954-3.75 4.512-5.88M2073.61 1228.75c-.314 2.22.48 4.319.614 6.659M2075.603 1227.76c.21-2.908-.344-6.057 1.515-8.517M2083.131 1215.976c-.616 3.598-4.543 5.758-4.259 9.535M2082.996 1227.132c0-2.909-.143-5.215 1.33-7.889M2086.115 1215.976c.735 3.018.835 5.067 0 8.127 2.608-2.399 2.205-6.969 1.89-9.356M2086.88 1228.122c-.45.39-.675.929-.63 1.529M2113.434 1238.647c-.397-1.765-.646-3.88.12-5.758M2110.42 1226.502c1.17-1.98 1.155-4.23 3.015-5.878M2111.633 1218.975c1.514-1.685 2.193-2.85 2.315-4.499M2115.998 1216.336c-.044.929-.845 2.369-1.754 3.277M2118.096 1217.432c.207 1.35.157 3.252-.142 4.541M2120.063 1219.875c-.645 2.849-3.435 4.167-3.75 7.257M2114.935 1224.642c.539-1.079-.498-2.669.042-3.929M2123.2 1247.354c.689-1.519 1.555-3.022 2.32-4.372M2121.502 1243.137c.255-2.12 1.514-2.12 2.444-4.792M2124.166 1256.943c.782-1.685 1.668-3.15 2.853-5.436M2123.946 1251.692c.729-1.532 1.62-3.329 2.504-4.768M2127.641 1258.68c-1.047 1.186-1.829 2.308-2.747 3.511M2128.336 1262.565c-1.316 1.95-2.195 3.267-3.09 5M2128.98 1267.44c-1.526 2.49-2.189 3.604-3.486 6.907M2129.56 1272.585c-.954 1.41-1.97 4.128-2.53 5.704M2096.732 1253.431c.479.784 1.538 1.878 2.27 2.06M2089.638 1246.924c.39.63.915 1.2 1.5 1.618M2055.66 1231.09c-.584-1.35.586-2.55.017-3.72-.541-1.078-3.044-2.127-1.454-3.146M2052.633 1231.24c-.3-1.2.39-1.83.24-2.91M2120.318 1294.246c-.09-.72.209-1.26.869-1.498M2121.442 1291.997c-.135-.81.164-1.41.884-1.74M2122.82 1288.608c.422-.84.557-2.039.377-3.118M2126.075 1283.12c1.334-.688 2.923-1.318 4.257-1.77M2129.839 1283.36c.045-.51.255-.84.63-1.14M2052.062 1258.71a76 76 0 0 0-1.215 1.889M2050.938 1256.28c-.809.54-1.319 1.47-1.5 2.55M2048.651 1255.14c.208-.81.146-.937.464-1.507M2049.438 1251.692c-.875.858-1.312 1.667-1.574 3.067M2049.191 1256.622c-.543.654-.726 1.207-.846 1.787M2050.743 1258.62c-.33.569-.75 1.318-1.02 1.889M2051.778 1260.779c.015.899.554 1.71 1.32 2.069M2052.902 1261.169c.842-.062 1.482-.232 2.55-1.104M2065.962 1174.74c.106-.928 2.205-2.937 1.755-4.376M2085.215 1177.95c1.784-.39 4.23-2.07 4.89-2.91M2107.482 1165.085c.84-.84 2.624-2.55 3.193-4.05M2062.02 1201.042a3.07 3.07 0 0 1 2.353 1.619M2101.934 1192.585c.84.72 1.47 1.77 1.694 2.818M2109.645 1216.936c-.078-1.695.25-2.97.281-4.439M2111.245 1214.567a2.84 2.84 0 0 1 .375-1.859M2106.822 1216.936c.1-2.303-.96-2.613-.923-4.604M2107.149 1212.24c-.417-.856-.394-.877-.511-1.495M2104.199 1217.774c.255-1.589-.21-3.207-.106-4.707"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a4a5a8",
    strokeLinecap: "round",
    strokeWidth: 0.564,
    d: "M2065.903 1225.482c-.195-1.859-.131-2.504.582-4.16M2068.916 1224.223c.48-1.26 1.844-1.39 1.833-4.61M2071.714 1222.04c-.077-2.25 1.12-3.407 1.702-5.601M2072.974 1220.9c.97-1.038 1.948-3.48 1.902-4.593M2074.164 1223.472c.63-1.108.272-1.144 1.16-2.288M2077.414 1220.407c1.09-1.48 1.265-2.474 2.001-5.75M2080.177 1219.724c.895-1.355 1.265-3.688 1.79-5.519M2084.482 1222.598c.853-2.539.883-3.773.704-6.143M2081.677 1223.982c.09-1.859.44-3.238 1.176-5.007M2088.943 1220.9c.414-2.094.497-4.057.198-6.38M2090.413 1219.244c.521-3.538-.464-5.418 1.62-7.337M2092.345 1214.396c.913 1.94-.487 4.548-1.146 6.587M2096.205 1217.715c.122-1.83.026-3.526-.479-5.394M2094.707 1218.705c0-1.62.089-3.15.255-4.738M2101.724 1213.966c-.075 1.47-.15 2.788-.255 4.258M2099.22 1215.946c-.104 1.648-.18 3.148-.255 4.768M2102.969 1215.466v3M2105.728 1215.706v3.748M2107.737 1212.947c.99 1.769 1.038 3.865 1.004 6.028M2113.406 1226.614c-.225-1.23-.013-3.23.541-4.25M2115.998 1221.973c.195-1.32.375-2.699.495-4.018M2120.465 1229.5c.335-1.528 1.037-4.348 1.037-6.152M2121.502 1231.235c.61-1.385 1.062-3.229 1.222-4.945M2122.563 1233.087c.855-1.35 1.326-3.263 1.442-5.116M2123.889 1234.767c.496-1.183.929-2.365.874-3.89M2119.252 1227.492c.315-1.202.63-4.108.63-5.128M2117.244 1219.724c.104-1.259.039-2.219-.216-3.389M2061.39 1228.481c0-1.589.055-3.309.657-5.082M2063.143 1225.992c-.029-1.14.083-2.205.563-3.014M2059.89 1224.852c-.167 1.254-.794 2.52-1.004 3.63M2057.256 1224.311c.249 1.38-.094 2.971-.365 4.17M2054.083 1227.297c-.151.83 0 1.243-.265 2.487M2051.861 1228.481c-.284.45-.575 1.61-.548 2.21M2054.662 1229.446c-.17 1.354-.276 2.196.107 3.294M2056.142 1223.982c.104.631.003 1.5-.173 2.01M2049.62 1235.258c-.092 1.35 0 2.73.254 3.988M2049.113 1239.268c-.187 1.795-.08 2.617.319 3.59M2049.874 1240.507a3.72 3.72 0 0 0 1.5 2.758M2050.623 1247.013c.03.78.42 1.53 1.004 2.01M2052.894 1234.523c.372 1.158.492 1.675.64 2.92M2051.313 1231.593c.06 2.115.548 3.646.89 5.445M2050.44 1237.237c.183 2.405.747 3.422 1.805 4.479M2098.71 1258.29c-1.124-.18-2.22-.72-3-1.5M2100.225 1258.05c-.96-.48-2.303-.63-3.074-1.26M2101.469 1257.54c-.96-.33-2.008-.688-2.999-.99M2094.954 1256.04c-1.334-1.081-2.6-2.1-4.252-2.518M2092.457 1257.648c-1.454-.299-2.954-.948-4.257-1.608M2095.891 1258.05c-1.016.087-1.805-.072-2.55-.24M2097.466 1256.04c-.676-.45-1.469-1.558-2.01-2.008M2123.015 1242.796c.653-1.267.931-1.93 1.748-3.145M2123.571 1244.008a37 37 0 0 1 1.627-2.785M2124.454 1247.92c.438-.851.85-1.703 1.531-2.745M2125.374 1251.692c.435-.9.726-1.607 1.451-2.793M2125.374 1257.379c.51-.99 1.268-2.11 1.833-2.945M2125.626 1258.997c.398-.623 1.02-1.618 1.677-2.386M2126.834 1262.047c.359-.51.979-1.43 1.43-1.91M2127.092 1267.274c.457-.706.96-1.635 1.427-2.324M2127.878 1272.662c.386-.783 1.025-1.986 1.683-2.856M2128.834 1276.582c.146-.513.448-1.145.83-1.923M2122.76 1238.498v-1.38M2121.63 1237.545v-1.776M2120.256 1236.136v-2.24M2118.758 1234.642c.135-.99-.12-2.894-.804-4.104M2127.63 1284.08c.272-.33 1.009-.99 1.398-.99M2128.694 1284.08c1.343.63 2.071-.102 2.071-.75M2130.765 1285.295c-.029-.48.257-1.184.768-1.215M2131.533 1285.134c.351-.447.786-.643 1.346-.33M2132.43 1285.416a.715.715 0 0 0 1.154-.121M2084.617 1256.964c.95.685 2.482 1.4 3.65 1.795M2084.44 1258.851c.406.302 1.354.848 1.608.938M2082.262 1259.412c.457.378 1.13.777 1.971 1.224M2050.088 1254.374c-.3.55-.364.844-.47 1.49M2047.864 1255.53c-.66 1.17-.66 2.7 0 4.019M2049.123 1261.558c.39.81 1.442 1.713 2.131 2.132M2053.22 1263.97c1.1 0 1.785-.592 2.329-1.463M2053.877 1262.039c.583-.138 1.105-.513 1.843-1.024M2064.404 1220.473v-2.759M2065.153 1219.215c.255-.45.4-1.605.295-2.326M2066.344 1218.379c.173-.892.172-1.323.053-2.163M2065.807 1215.67c0-.964-.22-1.94-.49-2.81M2074.655 1213.457c.222-.674.363-1.166.621-2.01M2075.703 1213.687c.338-1.22.584-2.24.216-3.739M2077.502 1213.297c.18-1.48.223-1.85.085-3.109M2079.26 1212.198c-.845-.621-.845-1.053-.845-1.562M2080.177 1212.799c0-.091.281-.722-.326-1.151M2078.358 1209.858c-.202-.718-.688-.961-.943-1.291M2076.669 1209.198c-.365-1.11-.878-1.254-1.244-2.02M2074.966 1206.59c-.788-1.174-1.503-1.96-1.24-3.025M2076.88 1212.077a9 9 0 0 0-.079-2.017M2105.413 1207.882c-.199-1.562-.516-2.864-.765-4.81M2106.362 1207.508c-.213-1.31-.284-1.866-.464-2.945M2108.3 1208.846c.106-.869-.288-2.065-.5-3.184M2109.502 1207.962c-.229-.78-.37-.958-.64-1.408M2111.135 1209.928c-.294-.765-.572-1.33-.915-2.14M2107.052 1206.554c-.162-1.702-.368-2.678-.83-4.377M2104.667 1200.31c.083.98.747 1.637 1.012 3.274M2128.378 1303.033c.519.313.6.479 1.037.979M2129.415 1303.023c.314.421.788 1.093 1.328 1.28M2121.74 1302.643c-.765-.45-.872-1.266-.238-1.769"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2135.285 1381.218h-3.812v5.171h3.812z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2131.585 1381.33h3.59v4.948h-3.59zm3.812-.223h-4.035v5.394h4.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2135.285 1386.39.529-.732v-5.288l-.53.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2135.406 1381.035.287-.336v4.92l-.287.396Zm.529-.991-.77.9v5.82l.77-1.066z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2120.837 1378.456s.83 1.973 2.884 2.179 3.028-1.04 3.485-1.6l-.311-1.036-4.543-.772Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2120.976 1378.487 1.406-1.142 4.425.752.274.913c-.461.566-1.414 1.708-3.35 1.513-1.736-.175-2.58-1.68-2.755-2.036m1.343-1.38-.04.032-1.578 1.283.033.078c.009.019.879 2.036 2.974 2.246 2.08.21 3.079-1.02 3.56-1.61l.063-.076-.35-1.161-.067-.011Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2119.459 1378.724 5.36.062 1.678.25-.308-9.315-7.1.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2119.207 1369.835 6.874-.001.3 9.07-1.545-.227-5.27-.063Zm7.09-.226h-7.324l.379 9.226.106.002 5.36.062 1.795.267-.004-.134Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2118.35 1373.351v-3.772s1.833-.044 5.723-.044l-.01 4.107s-3.076.016-5.713-.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2118.462 1369.688c.444-.009 2.246-.04 5.5-.04l-.01 3.881c-.568 0-3.194-.019-5.49-.278Zm5.723-.266h-.112c-3.848 0-5.708.044-5.726.044l-.11.003v3.982l.1.011c2.615.304 5.69.293 5.727.291h.11l.001-.112Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2124.33 1374.995c-.038-.804-.686-1.426-1.445-1.39-.76.037-1.345.719-1.306 1.523s.687 1.427 1.446 1.389c.76-.037 1.345-.718 1.306-1.522"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2123.5 1375.035c-.016-.318-.272-.565-.573-.551-.302.015-.533.285-.518.604s.272.565.573.55c.302-.014.534-.284.518-.603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2122.957 1375.528a.42.42 0 0 1-.282-.11.48.48 0 0 1-.155-.336.48.48 0 0 1 .113-.338.42.42 0 0 1 .3-.15h.018c.232 0 .426.197.438.447a.47.47 0 0 1-.12.346.42.42 0 0 1-.292.141Zm-.006-1.155-.03.001a.63.63 0 0 0-.455.225.7.7 0 0 0-.167.494c.01.19.09.364.227.488a.633.633 0 0 0 .906-.045.7.7 0 0 0 .178-.506.675.675 0 0 0-.659-.657"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2123.5 1375.035c-.016-.318-.272-.565-.573-.551-.302.015-.533.285-.518.604s.272.565.573.55c.302-.014.534-.284.518-.603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2122.957 1375.528a.42.42 0 0 1-.282-.11.48.48 0 0 1-.155-.336.48.48 0 0 1 .113-.338.42.42 0 0 1 .3-.15h.018c.232 0 .426.197.438.447a.47.47 0 0 1-.12.346.42.42 0 0 1-.292.141Zm-.006-1.155-.03.001a.63.63 0 0 0-.455.225.7.7 0 0 0-.167.494c.01.19.09.364.227.488a.633.633 0 0 0 .906-.045.7.7 0 0 0 .178-.506.675.675 0 0 0-.659-.657"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2124.073 1376.152h.747v-6.617h-.747z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.185 1369.647h.522v6.393h-.522zm.747-.225h-.971v6.842h.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2124.073 1373.58c-3.734-.042-5.85-.29-5.85-.29v.29s2.116.249 5.85.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2118.11 1373.164v.516l.1.01c.022.003 2.164.25 5.862.292l.002-.224c-3.24-.035-5.28-.231-5.738-.28v-.064c.507.053 2.542.243 5.736.278l.002-.224c-3.683-.04-5.816-.287-5.837-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2124.82 1376.152.197-.015v-6.602h-.197Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2125.128 1369.423h-.42v6.85l.421-.033Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2126.189 1369.721h12.426l-.228 10.206h-.954s-.498.581-1.35.705l.012.602h-.561s-1.098 1.058-2.945 1.068-3.2-1.065-3.2-1.065l-.63.005-.02-.625s-.86-.098-1.388-.825l-.83-.026Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2126.305 1369.834h12.196l-.224 9.98h-.895l-.035.04a2.26 2.26 0 0 1-1.28.669l-.095.014.008.586h-.491l-.033.03c-.011.012-1.091 1.029-2.868 1.038h-.027c-1.772 0-3.09-1.031-3.102-1.042l-.031-.024-.56.005-.02-.612-.095-.012c-.01-.001-.82-.103-1.312-.78l-.032-.043-.78-.025Zm12.424-.225h-12.656l.339 10.267.882.027c.45.584 1.094.762 1.337.81l.02.643.699-.006c.222.165 1.495 1.066 3.21 1.066h.029c1.713-.011 2.785-.887 2.989-1.068h.63l-.01-.62a2.5 2.5 0 0 0 1.284-.688h1.014l.003-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211915",
    d: "m2130.503 1369.699.15 6.243 3.513.005-.027-6.285ZM2133.071 1379.032l-.02-1.83-1.257-.004.032 1.825s.56.733 1.245.009"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m2131.537 1379.604-.282-.003-.052-2.406.287.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2131.372 1379.482-.045-2.165h.045l.042 2.166Zm-.291-2.407.056 2.647.523.002-.052-2.647Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m2133.664 1379.62-.285-.001-.022-2.416h.288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2133.498 1379.5-.021-2.176h.05l.016 2.176Zm-.263-2.417.025 2.655.525.004-.02-2.657z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m2133.666 1379.885-2.406-.02-.005-.264 2.409.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2131.378 1379.746-.001-.022 2.168.016v.025zm-.246-.265.01.503 2.645.023-.004-.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2131.546 1380.025s.01.831.929.84c.915.01.908-.772.908-.824l.284.003s.069 1.074-1.188 1.129c0 0-1.191-.012-1.215-1.151z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.473 1381.054c-.036 0-.982-.026-1.08-.91h.046c.043.255.231.834 1.034.841.343 0 .586-.087.768-.27a.94.94 0 0 0 .254-.553h.046a.98.98 0 0 1-.233.56q-.279.305-.835.332m-1.333-1.152.003.124c.026 1.24 1.321 1.267 1.334 1.267q.668-.029 1.012-.412c.325-.363.298-.826.297-.846l-.007-.11-.52-.007.003.124c0 .032 0 .311-.192.504q-.197.199-.58.2h-.016c-.786-.009-.808-.694-.809-.723l-.002-.117Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m2132.618 1381.33-.273-.003-.007-.447.273.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2132.463 1381.208-.003-.206h.033l.003.206Zm-.247-.45.01.687.514.006-.01-.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2134.876 1376.854-4.744-.015.015.512 4.729.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2130.243 1377.253-.01-.312 4.542.012v.318zm-.214-.513.02.71.097.002 4.829.019v-.716l-.1-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2135.312 1376.743-5.612-.016.007.223 5.604.018z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2129.804 1376.85v-.022l5.408.013v.026zm-.207-.223.013.421.096.001 5.705.018v-.424h-.099Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2135.311 1377.26-5.596-.02.007.22 5.588.023Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2129.82 1377.362-.002-.022 5.394.019v.024zm-.207-.223.012.42h.097l5.687.025.002-.423-.1-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2136.39 1369.728-1.88.02.006 2.256 1.854-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2134.619 1369.854 1.662-.017-.017 2.05-1.64.01Zm1.879-.235-2.096.021.007 2.473 2.069-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2136.26 1376.811-1.65-.004.001.608 1.646.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2134.758 1377.27v-.316l1.355.003-.001.318Zm-.294-.609.002.9 1.937.007.005-.902Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2135.352 1372-.478.003.002 4.728.466.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2134.983 1372.11.262-.002-.01 4.517-.25-.001Zm.48-.219-.698.004.004 4.944.681.002.001-.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2136.042 1371.996-.48.003-.015 4.734h.467z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2135.67 1372.107.264-.002-.03 4.521h-.25zm.48-.22-.696.004-.001.108-.014 4.841.682.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2136.413 1376.68-1.953-.006v.264l1.95.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2134.566 1376.834v-.055l1.741.006v.055Zm-.21-.265v.475l2.158.006.004-.475Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2136.408 1377.29-1.946-.007.001.263 1.943.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2134.567 1377.44v-.053l1.735.008v.053Zm-.21-.263v.473l2.152.01.004-.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2136.122 1377.989-1.351-.007-.001-.435 1.355.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2134.891 1377.862v-.195l1.112.005-.002.196Zm-.242-.437.002.677 1.591.008.003-.678Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2135.814 1378.565-.74-.005.001-.576.742.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2135.205 1378.43v-.314l.48.002-.001.315Zm-.261-.577v.837l1 .006.004-.839z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2130.058 1369.79-1.835.019.081 2.23 1.814-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2128.336 1369.915 1.617-.016.054 2.023-1.6.01zm1.828-.234-2.053.02.005.11.085 2.337 2.029-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2130.174 1376.793-1.615-.005.022.602 1.609.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2128.721 1377.244-.012-.31 1.322.005.007.31zm-.314-.603.032.894 1.901.008-.024-.896z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2129.123 1372.035-.468.003.162 4.676h.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2128.767 1372.145h.25l.144 4.461h-.24Zm.46-.219-.685.004.005.111.164 4.78.673.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2129.796 1372.03-.47.004.146 4.682h.457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2129.438 1372.142.253-.002.125 4.468h-.239Zm.462-.22-.685.004.004.112.148 4.785.672.003-.003-.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2130.317 1376.662-1.91-.005.01.262 1.907.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2128.517 1376.814-.002-.053 1.7.005.001.054zm-.219-.262.018.471 2.115.006-.013-.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2130.333 1377.266-1.903-.007.009.26 1.9.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2128.54 1377.414-.002-.051 1.693.008v.05zm-.22-.261.018.47 2.11.008-.012-.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2130.077 1377.958-1.321-.007-.015-.43 1.324.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2128.872 1377.83-.007-.19 1.083.005.006.192zm-.256-.431.024.672 1.56.008-.017-.674Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2129.796 1378.527-.724-.005-.02-.569.727.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2129.198 1378.392-.01-.308.464.001.009.31zm-.28-.57.027.83.984.006-.022-.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2131.904 1376.152h.747v-6.617h-.747z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.016 1369.647h.522v6.393h-.522zm.747-.225h-.973v6.842h.973z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2132.651 1376.152.196-.015v-6.602h-.196Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.96 1369.423h-.421v6.85l.422-.033Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2145.572 1379.017s-.906 1.973-3.15 2.18c-2.244.205-3.309-1.04-3.807-1.6l.34-1.037 4.963-.772z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2139.044 1378.665 4.844-.754 1.534 1.14c-.202.372-1.125 1.855-3.011 2.029-2.121.184-3.158-.94-3.663-1.51Zm4.904-1-5.081.79-.384 1.17.07.078c.523.59 1.615 1.819 3.88 1.609 2.284-.21 3.236-2.225 3.246-2.246l.039-.086Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2146.2 1379.343-5.856.062-1.402.264-.555-.249v-6.453l8.211-2.627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2138.504 1373.053 7.97-2.55-.386 8.725-5.745.06-1.387.26-.452-.205Zm8.219-2.876-8.453 2.704v6.614l.658.296 1.437-.27 5.948-.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2138.387 1378.676.575.297 7.39.047-.11-.402-7.265-.063-.59-.339Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2138.504 1378.605v-.187l.442.254h.03l7.177.062.045.168-7.207-.046Zm-.234-.59v.733l.692.342 7.543.048-.172-.636h-.09l-7.234-.064Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2146.328 1379.654-.111-.311-7.273-.044-.557-.265v.387l.555.249z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2138.504 1379.343v-.125l.44.197 7.19.044.028.076-7.195.017Zm-.234-.495v.647l.672.291 7.553-.016-.195-.542h-.081l-7.247-.047Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2144.48 1378.61.275-8.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2144.638 1370.337-.275 8.27.234.006.275-8.269Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2144.217 1378.609.289-8.264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2144.388 1370.341-.289 8.264.234.007.288-8.263Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2140.687 1378.627.2-8.286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2140.77 1370.338-.2 8.286.234.005.198-8.285Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#040006",
    d: "m2139.296 1370.351-.198 8.267-.711-.492v-7.679Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2138.86 1378.551-.015.418.235.008.014-.418ZM2138.828 1379.298l-.003.37.234.003.002-.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2139.133 1378.974h-.234v.325h.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2144.055 1375.33c.036-.87-.602-1.603-1.425-1.637-.822-.033-1.518.645-1.554 1.516-.036.87.602 1.603 1.425 1.638.823.033 1.52-.645 1.554-1.516"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2143.157 1375.294c.014-.345-.239-.636-.565-.648-.327-.014-.602.254-.617.6-.013.345.24.636.566.649s.601-.255.616-.601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2142.563 1375.778-.018-.001c-.26-.011-.464-.246-.453-.526.012-.274.223-.49.476-.49l.018.001a.45.45 0 0 1 .328.161.53.53 0 0 1 .126.366c-.012.273-.223.489-.477.489m.005-1.25c-.378 0-.693.314-.71.713-.016.408.288.754.678.77h.027c.38 0 .694-.314.711-.712a.76.76 0 0 0-.184-.531.7.7 0 0 0-.494-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2135.247 1390.17.264-.654v-2.653l-.264.757Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2135.358 1387.64.042-.117v1.971l-.042.102Zm.047-.813-.27.793v2.55l.215.041.273-.695v-2.652z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2147.187 1373.445v-3.91h-14.34v4.175s11.703.04 14.34-.265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.96 1369.647h14.115v3.697c-2.633.275-12.925.25-14.115.253Zm14.34-.225h-14.565v4.4h.113c.118 0 11.74.037 14.353-.267l.099-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2132.848 1373.567s5.953.094 14.48-.228v.29c-8.527.322-14.48.228-14.48.228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2147.44 1373.223-.116.004c-8.426.317-14.415.23-14.473.227l-.004.225c.062 0 5.997.088 14.368-.224v.066c-8.373.314-14.307.227-14.364.223l-.004.226c.061 0 6.054.087 14.485-.228l.108-.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2126.463 1377.999-.404.355-7.058.049.475-.404 6.55-.035.418-.352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2119.518 1378.11 6.549-.034.276-.232.006.106-.333.293-6.708.046Zm7.027-.729-.56.472-6.55.034-.74.63 7.406-.051.476-.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2128.74 1380.617c-.4-.108-1.042-.348-1.39-.824l-.829-.027.009.343.635.02c.647.682 1.57.846 1.57.846z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2126.64 1380-.004-.118.657.02c.338.43.893.67 1.333.8v.133c-.27-.072-.908-.284-1.38-.782l-.032-.033Zm-.234-.35.015.569.695.02c.662.673 1.561.84 1.6.848l.13.022.007-.578-.084-.022c-.354-.096-.995-.325-1.328-.782l-.032-.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2136.084 1380.632a2.36 2.36 0 0 0 1.349-.705h.954v.344l-.78.006s-.67.642-1.523.712z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2137.482 1380.04h.792v.12l-.71.006-.033.03c-.007.006-.592.555-1.334.669v-.137a2.5 2.5 0 0 0 1.285-.688m1.017-.225h-1.118l-.034.039a2.26 2.26 0 0 1-1.279.669l-.096.013v.576l.121-.01c.783-.065 1.408-.58 1.56-.713l.846-.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2136.444 1381.234h-.91s-1.099 1.068-2.945 1.068c-1.9 0-3.2-1.065-3.2-1.065l-.825.008v.334l.653-.01s1.388 1.075 3.382 1.076c1.94.001 3.076-1.069 3.076-1.069l.77-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2135.578 1381.347h.754v.108l-.7.01-.033.028c-.01.011-1.13 1.04-2.998 1.04h-.002c-1.93 0-3.3-1.042-3.313-1.053l-.031-.024-.578.01v-.11l.673-.007a5.55 5.55 0 0 0 3.238 1.066c1.713 0 2.786-.884 2.99-1.068m.979-.225h-1.07l-.031.033c-.011.01-1.091 1.036-2.868 1.036-1.84 0-3.115-1.03-3.127-1.04l-.032-.027-.977.008v.56l.73-.01c.224.164 1.55 1.074 3.417 1.075h.002c1.8 0 2.913-.89 3.119-1.07l.837-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2119 1379.036.364-.312 6.719-.024.38-.246.027.357-.36.195Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2119.406 1378.836 6.71-.023.248-.162.008.096-.27.146-6.798.03zm7.155-.58-.513.332-6.726.025-.625.536 7.462-.032.448-.242Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2121.125 1377.999-.175-4.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2121.061 1373.774-.225.009.177 4.22.224-.009Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2121.414 1377.999-.175-4.206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2121.35 1373.788-.224.01.176 4.206.224-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2124.62 1377.999-.076-1.847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2124.657 1376.147-.225.01.076 1.846.225-.009Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#040006",
    d: "m2125.691 1369.721.27 8.277.465-.458-.237-7.819Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2126.136 1377.989-.224.02.036.404.221-.02zM2126.193 1378.683l-.221.034.054.335.22-.034z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2126.17 1378.394-.223.018.024.296.223-.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2132.98 1382.645h-.952v.416h.952z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.129 1382.745h.751v.217h-.751zm.951-.2h-1.151v.617h1.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2132.866 1383.429h-.724v-.368h.724z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.243 1383.162h.523v.167h-.523zm.724-.2h-.924v.567h.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2132.028 1383.797h.952v-.367h-.952z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.129 1383.529h.751v.167h-.751zm.951-.2h-1.151v.567h1.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2131.668 1386.693v.926h.436v2.552h2.769v-2.562l.412.001v-.917Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2131.78 1386.804h3.395v.693l-.414-.002v2.563h-2.546v-2.55h-.435Zm3.617-.224h-3.84v1.15h.435v2.551h2.993v-2.56l.412.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2135.285 1387.61.265-.381v-.808l-.265.272Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2135.397 1386.738.042-.043v.499l-.042.06Zm.265-.593-.488.502v1.32l.488-.703Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2132.103 1390.171h-.436v-2.552h.436z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2131.78 1387.73h.212v2.328h-.212zm.435-.223h-.657v2.773h.657zM2134.07 1390.919s-.102.202-.074.534c.028.33.064.176.13.539.067.382.095.669.105.833.01.165.041.484.081.639 0 0 .25.178.362.285.114.108.141.188.193.274 0 0-.002.187.001.264 0 0 .068.068.087.096.018.029.02.064.026.122.007.058.06.149.032.172-.014.013-.004.024-.027.04-.022.016-.012.029-.03.027-.029-.002-.05-.11-.07-.152-.02-.044-.053-.077-.01-.178l-.046-.038s-.045.013-.099-.028c-.053-.042-.389-.29-.549-.346-.113-.04-.163-.027-.269-.02-.106.01-.189.004-.207.122-.019.117-.01.336-.08.434-.07.1-.185.169-.31.127-.128-.041-.187-.131-.153-.283s.18-.378.11-.4c-.069-.024-.13-.08-.209-.111-.078-.032-.099-.073-.228-.071-.189.002-.43.117-.594.165 0 0-.056-.015-.08.003s-.034.013-.027.055 0 .055-.053.12c-.054.065-.078.11-.112.116-.022.003-.04.006-.055-.026-.017-.032-.016-.015-.022-.042-.007-.026-.01-.04-.003-.061.01-.022.04-.064.056-.125.016-.062.04-.072.097-.111.048-.034.064-.001.127-.05 0 0 .015-.158.02-.188 0 0 .15-.1.235-.14.087-.041.201-.096.402-.175 0 0 .027-.361.032-.714.005-.35.065-.524.115-.76.051-.234.111-.3.116-.524.003-.226-.102-.548-.102-.548z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2135.285 1387.61h-.412v2.561h.412z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2134.985 1387.721h.189v2.337h-.189zm.412-.222h-.636v2.782h.636zM2130.844 1386.864l.63-.755v.28h3.81l.53-.731v-.412l.63.464-.707 1.154Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2134.6 1390.459s.001.775-.852.793h-.4c-.853-.018-.852-.793-.852-.793Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.619 1390.57h1.858c-.034.195-.173.559-.73.57h-.4c-.555-.011-.694-.375-.728-.57m2.093-.223h-2.327v.113c0 .007.009.883.962.903h.402c.954-.02.963-.896.963-.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2131.395 1390.413.264-.466v.25h3.626l.225-.68v-.104l.27.073-.32.927Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2135.4 1389.266v.232l-.195.588h-3.435v-.564l-.486.78.054.222h4.202l.35-1.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2135.418 1390.413v.886h-.242v-.444h-3.538v.444h-.242v-.886Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2131.507 1390.524h3.8v.662h-.02v-.442h-3.761v.442h-.02Zm4.022-.223h-4.245v1.109h.465v-.444h3.316v.444h.464z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2135.418 1390.413.36-.927v.396l-.36.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2135.675 1389.445-.368.968v.46l.222.089.362-1.08v-.396Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2133.89 1390.413v.442s-.14.322-.525.322c-.384 0-.524-.322-.524-.322v-.442Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2132.953 1390.524h.824v.305a.47.47 0 0 1-.412.236.47.47 0 0 1-.412-.236Zm1.047-.223h-1.27l.009.599a.69.69 0 0 0 .626.388c.453 0 .62-.372.627-.388l.008-.045ZM2133.478 1394.992c-.267 0-.5-.26-.5-.555 0-.285.23-.526.5-.526.284 0 .515.236.515.526 0 .295-.24.555-.515.555m0-1.177c-.322 0-.595.285-.595.622 0 .346.278.65.595.65.33 0 .61-.297.61-.65a.617.617 0 0 0-.61-.622"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.198,
    d: "M2119.09 1372.882s1.747.175 3.663.175M2119.003 1372.41s1.441.106 3.34.158M2118.915 1371.936s1.228.071 3.095.15M2118.859 1371.499s.957.024 2.823.104M2118.814 1371.07s1.114.038 2.563.08M2118.786 1370.684s1.514.043 2.36.065M2118.746 1370.316s1.414.002 2.083.022M2118.686 1369.95h1.838M2133.843 1373.08s5.13.024 12.64-.143M2133.785 1372.595s3.523.043 11.015-.046M2133.645 1372.07s7.256.136 9.732.06M2133.577 1371.633s6.258.1 8.28.035M2133.522 1371.207s5.32.074 6.923.056M2133.485 1370.822s4.284.043 5.13.045M2133.436 1370.456s2.682-.02 3.351-.016M2133.367 1370.045s1.402.01 1.838 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2143.108 1204.16c.66-6.117 1.664-16.554-10.437-28.31 4.47-4.648 10.437-7.795 19.884-7.616 9.447.149 16.884-.18 25.505 7.766-3.807 3.149-14.244 12.086-9.942 28.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 0.276,
    d: "M2143.108 1204.16c.66-6.117 1.664-16.554-10.437-28.31 4.47-4.648 10.437-7.795 19.884-7.616 9.447.149 16.884-.18 25.505 7.766-3.807 3.149-14.244 12.086-9.942 28.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "m2179.162 1204.629 1.188-3.188c.332 1.33.437 2.344.557 4.03l1.324-3.2c.667 1.463.914 4.315.914 4.315l.84-3.173c1.613 2.389 3.579 6.35 4.047 8.676l.229-3.937 1.258 4.998.4-3.054c1.43 4.317 2.185 4.512 1.282 11.14-.898 6.584-6.155 10.645-8.391 11.438-1.268.45-2 1.936-6.055 3.512-3.038 1.178-4.89.749-6.372 1.229-1.5.51-3.535 1.554-7.086 1.344-4.065-.242-3.268-.531-6.17-.773-2.488-.206-5.053.663-9.027-.391-3.697-.981-8.783-5.414-11.833-8.277-3.265-3.064-5.891-6.93-7.63-11.987l1.65.562c-1.618-3.222-1.826-6.793-1.826-6.793l1.583.863s-.343-1.712-.277-3.263l2.18 1.653s-.49-2.253-.332-3.921c0 0 1.16 1.014 2.162 2.087 0 0-.155-2.494.099-4.181l2.11 2.509s-.048-2.142.25-4.037l1.826 2.59s.068-1.943.54-4.014l1.754 2.74s.117-1.815.73-3.793l1.713 2.807c.476-2.062.498-2.509 1.728-4.686l1.952 3.582s.797-2.804 2.385-4.687l1.74 3.899s.313-2.082 1.964-4.409l1.827 4.155s.392-2.235 1.915-4.393c0 0 1.26 2.208 1.892 4.392l2.254-4.392s1.42 2.065 2.046 4.782l2.236-4.176s1.22 2.36 1.835 4.637l1.575-4.434c.546 1.354 1.285 3.237 1.542 4.706l1.057-4.146s.875 2.012 1.158 4.443l1.37-3.676s.707 2.121.77 4.072l1.225-3.345s.479 1.904.542 3.821l1.137-3.184s.496 1.82.604 3.786l1.006-3.133s.494 1.654.603 3.874"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeMiterlimit: 10,
    strokeWidth: 0.276,
    d: "m2179.162 1204.629 1.188-3.188c.332 1.33.437 2.344.557 4.03l1.324-3.2c.667 1.463.914 4.315.914 4.315l.84-3.173c1.613 2.389 3.579 6.35 4.047 8.676l.229-3.937 1.258 4.998.4-3.054c1.43 4.317 2.185 4.512 1.282 11.14-.898 6.584-6.155 10.645-8.391 11.438-1.268.45-2 1.936-6.055 3.512-3.038 1.178-4.89.749-6.372 1.229-1.5.51-3.535 1.554-7.086 1.344-4.065-.242-3.268-.531-6.17-.773-2.488-.206-5.053.663-9.027-.391-3.697-.981-8.783-5.414-11.833-8.277-3.265-3.064-5.891-6.93-7.63-11.987l1.65.562c-1.618-3.222-1.826-6.793-1.826-6.793l1.583.863s-.343-1.712-.277-3.263l2.18 1.653s-.49-2.253-.332-3.921c0 0 1.16 1.014 2.162 2.087 0 0-.155-2.494.099-4.181l2.11 2.509s-.048-2.142.25-4.037l1.826 2.59s.068-1.943.54-4.014l1.754 2.74s.117-1.815.73-3.793l1.713 2.807c.476-2.062.498-2.509 1.728-4.686l1.952 3.582s.797-2.804 2.385-4.687l1.74 3.899s.313-2.082 1.964-4.409l1.827 4.155s.392-2.235 1.915-4.393c0 0 1.26 2.208 1.892 4.392l2.254-4.392s1.42 2.065 2.046 4.782l2.236-4.176s1.22 2.36 1.835 4.637l1.575-4.434c.546 1.354 1.285 3.237 1.542 4.706l1.057-4.146s.875 2.012 1.158 4.443l1.37-3.676s.707 2.121.77 4.072l1.225-3.345s.479 1.904.542 3.821l1.137-3.184s.496 1.82.604 3.786l1.006-3.133s.494 1.654.603 3.874z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2133.92 1209.08c3.674 8.17 12.449 16.49 20.603 18.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2132.577 1211.493c2.083 3.343 6.977 9.28 12.608 12.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2130.364 1212.526c1.802 2.7 9.039 10.678 16.77 13.392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2130.133 1215.345c6.364 6.793 14.246 13.275 24.03 12.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2130.704 1218.492c5.283 5.222 14.48 11.49 24.292 10.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2131.097 1221.285c5.405 4.38 15.827 11.452 24.352 7.576"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2133.26 1224.942c4.077 2.909 15.026 9.372 23.253 4.573"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2136.667 1228.675c5.589 3.362 14.645 5.635 19.532 1.485"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2140.32 1231.989c3.778 2.189 11.611 2.98 15.926-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2148.283 1237.174c3.836-1.977 8.121-2.055 9.963-7.463M2154.996 1237.628c1.653-1.652 2.903-3.903 3.158-6.393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2144.098 1235.138c4.851 1.08 11.192-1.92 12.438-3.75M2151.483 1237.628c2.04-1.05 5.278-3.321 6.057-5.54M2162.4 1238.373c-1.995-2.49-3.342-6.263-3.837-9.112M2167.391 1237.803c-2.938-1.498-5.233-2.519-6.947-6.319M2172.588 1236.395c-4.552-.652-9.328-3.685-12.342-7.523M2180.082 1233.817c-5.421.05-6.747-1.106-11.493-2.215M2189.241 1224.085c-2.412 5.956-7.624 8.626-15.586 7.774M2163.89 1228.882c3.153 1.334 6.822 1.628 10.195 1.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2175.496 1230.58c8.022-.3 13.868-8.936 14.08-16.554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2176.651 1228.93c6.304-2.043 11.365-8.426 11.425-15.323M2182.536 1229.73c5.54-2.813 7.34-8.006 7.834-13.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2171.762 1227.108c7.902-1.11 14.564-8.06 14.83-16.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2171.522 1228.685c7.243-.916 13.897-5.922 15.307-12.818M2163.739 1228.03c2.641.48 3.537.549 6.486.729M2162.992 1227.042c3.763-.42 6.214-1.265 8.95-2.474M2162.48 1226.681c1.8-.51 4.248-2.054 5.673-3.224M2161.437 1225.271c1.616-1.097 2.868-1.813 4.942-3.349M2163.523 1219.904c-1.52 1.855-2.654 4.049-3.77 5.927M2160.412 1220.489c-.496 1.199-1.154 2.549-1.648 3.794M2157.464 1220.489c-.444 1.664-.531 3.225-.155 5.106M2152.192 1215.526c.854 3.718 1.87 6.359 4.277 9.506M2146.977 1214.499c1.975 4.078 5.866 9.129 9.522 11.769M2142.696 1215.345c1.978 3.146 7.229 9.047 13.952 11.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2140.427 1215.526c2.682 3.718 8.968 10.069 16.356 12.086M2173.338 1223.953c6.64-2.82 9.775-6.657 10.855-13.734M2172.588 1222.524c5.046-3.718 8.967-10.829 9.434-18.364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2169.253 1222.633c6.243-4.048 10.062-10.793 10.726-18.779M2167.044 1221.285c5.259-4.373 8.123-9.971 8.527-17.185"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2172.588 1217.924c3.096-3.988 4.403-8.152 4.724-12.95M2176.651 1220.553c3.005-2.853 5.152-6.866 6.304-12.645M2163.812 1222.153c5.402-3.928 9.36-11.494 9.843-18.232M2164.305 1218.806c3.257-4.308 4.96-8.839 5.286-15.798M2162.825 1216.006c2.234-4.334 2.879-6.927 3.556-13.165M2159.258 1214.117c.665-4.47 1.454-10.017 1.243-15.325M2156.513 1218.586c-.139-5.013.966-11.107 1.215-16.735M2154.377 1216.912c-1.162-6.56-.38-9.434-.247-14.641M2151.918 1213.936c-.657-3.93-1.324-6.17-1.274-11.665M2153.046 1221.529c-1.79-2.795-4.61-9.277-5.555-12.105-.648-1.946-1.112-4.513-1.057-6.582M2146.002 1213.156c-1.812-3.78-2.414-5.098-3.173-9.235M2140.427 1204.91c.478 2.568 2.035 6.616 3.16 8.415M2138.122 1206.242c.255 1.83 1.965 5.88 3.337 7.529M2135.987 1207.478c.956 2.836 1.732 4.48 3.308 6.64M2157.682 1219.761c.335-1.16.905-1.884 1.405-4.519M2160.412 1226.726c2.423-.589 3.899-1.424 5.249-2.443M2162.4 1229.593c1.123.68 4.151 2.09 4.991 2.658M2159.367 1229.11c.43.75.47 1 .879 1.913M2157.82 1228.361c-.614 1.141-.407.93-1.172 1.949M2157.267 1228.607c-1.722.658-3.193 1.782-6.525 1.973M2157.539 1228.089c-.755-.058-1.882-.388-2.585-.596M2158.013 1226.622c-.33-1.26-.312-3.755.66-6.718M2158.477 1226.026c.284-.96 2.592-5.13 3.057-6.029M2159.679 1226.861c.575-.835 1.55-.918 2.231-1.266M2159.513 1228.122c.954.167 1.364.719 2.233 1.139M2159.26 1227.43c1.077-.339 4.264.271 5.44.091M2158.154 1228.42c-.215.901-.657 1.991-1.168 2.76M2160.337 1232.953c.377.82 1.3 2.819 2.699 3.937M2144.887 1215.064c1.83 3.161 4.398 5.635 7.305 8.56M2160.712 1219.761c.45-.955 1.035-1.837 1.645-2.85M2146.843 1196.873c-.338-11.813-4.495-17.506-8.52-24.681M2148.85 1195.798c-.409-5.553-.838-7.98-1.678-11.16M2146.752 1182.959c-1.656-4.287-3.463-8.187-6-12.085M2134.41 1174.772c2.896 3.448 6.134 7.616 8.113 12.174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2136.373 1173.437c2.657 3.8 4.637 7.203 6.826 11.86M2164.38 1193.199c.953-4.63 1.568-7.135 3.247-10.854M2161.656 1192.735c1.274-7.648 3.164-15.084 7.872-21.203M2167.982 1181.449c1.557-3.288 3.523-5.638 5.681-8.148M2156.693 1194.144c.164-7.888-.715-17.533-.715-25.39M2155.03 1190.83c-.224-7.871-1.168-15.153-1.915-22.076M2160.272 1190.425c.467-4.918 1.55-15.029 5.118-20.707M2158.44 1192.735c.226-6.868.37-16.156 1.49-23.655M2145.508 1169.222c1.07 2.83 2.504 7.501 3.44 11.052M2142.868 1169.973c1.808 3.63 4.458 8.956 5.609 13.5M2150.718 1168.754c.46 2.956 1.19 6.718 1.619 10.613M2151.682 1196.303c0-3.449-.593-9.595-1.182-13.345M2165.39 1192.324c.658-2.906 1.095-4.364 1.981-6.816M2162.571 1197.533c.525-3.51 1.166-6.526 1.902-9.776M2168.373 1186.95c.81-2.055 1.452-3.478 3.389-5.911M2164.722 1186.66c1.251-4.314 1.866-5.69 3.526-9.044M2168.84 1176.557a32 32 0 0 1 2.922-4.314M2171.762 1178.664c.885-1.195 2.564-2.666 3.7-3.862M2143.125 1188.388c.974 2.677 1.214 4.761 1.55 8.484M2146.03 1199.8c-.016-1.2-.235-4.033-.47-5.477M2155.007 1196.527c.104-1.32.029-3.103 0-4.452M2153.27 1190.217c-.156-3.538-.61-7.89-.806-9.419M2149.815 1178.16c-.373-2.592-1.099-5.655-1.488-6.886M2146.843 1176.09c-.89-2.364-1.604-4.291-2.598-6.371M2161.681 1197.052c.427-2.908.722-4.572 1.443-7.706M2163.477 1198.748c.23-1.528.442-3.148.685-4.447M2167.982 1184.202c.743-1.874 1.6-3.076 2.63-4.41M2158.807 1227.43c.375-.645.375-.645.705-1.139M2158.901 1228.181c.718.426 1.164 1.141 1.436 1.664M2161.534 1229.593c1.287 1.136 2.205 1.43 3.782 2.42M2161.98 1228.758c1.28.502 3.336 1.821 5.613 2.477M2159.075 1227.78c.951-.147 2.362.027 3.746.25M2158.386 1227.27c.286-.922 2.483-4.8 3.282-6.076M2157.906 1227.304c-.514-1.202-2.646-2.362-3.987-4.437M2157.682 1227.54c-1.213-.56-3.713-1.173-5.643-2.454M2156.83 1228.377c-.776.062-1.418-.288-2.181-.37M2156.932 1231.602c-1.446 2.108-3.604 2.776-4.239 3.058M2158.574 1228.345c.501 1.08.848 2.422 1.432 3.742M2158.386 1230.58c.113.872.378 1.409.378 2.373M2160.63 1230.273c.302.456.599 1.155 1.196 1.814M2160.63 1228.122c1.117.148 1.543.29 2.63.52M2162.4 1225.35c2.432-1.067 5.753-3.682 7.63-5.762M2160.444 1225.595c.553-.75 1.834-2.189 2.448-2.729M2158.31 1224.844c.362-2.458.7-4.462 1.9-6.619M2156.274 1223.038c-.825-1.63-1.32-3.484-1.575-4.7M2152.332 1227.304a18.8 18.8 0 0 1-4.137-1.037M2152.959 1229.17c-1.855.411-6.07-.075-7.936-.75M2158.763 1233.579c.13 1.229-.253 3.43-.253 4.12M2162.207 1232.485c.826 1.147 2.268 2.653 5.387 3.751M2165.902 1232.402c3.576 2.52 8.525 2.938 10.55 3.237M2168.875 1223.953c1.434-.93 2.782-1.893 4.097-3.072M2166.755 1223.458c1.979-1.43 3.432-2.77 4.902-4.303M2172.469 1216.674c1.186-1.618 2.822-5.001 3.256-7.026M2175.932 1208.521c.36-1.618.703-4.655.72-6.244M2167.79 1219.589c5.548-5.652 6.998-12.917 7.167-17.915M2167.044 1217.086c2.276-3.466 4.314-8.277 4.613-13.532M2165.653 1213.687c1.825-3.669 2.631-10.232 2.346-13.957M2177.963 1223.352c4.275-2.879 6.294-6.267 7.145-10.315M2185.35 1211.82c.136-1.462.275-2.18.136-4.356M2184.262 1209.206c.113-1.101.063-3.026-.069-3.807M2184.036 1225.31c2.172-1.8 4.174-6.363 4.344-8.009M2184.54 1227.288c1.437-1.191 3.536-3.757 4.578-7.7M2189.485 1223.383c.314-.75.616-2.019.782-2.83M2148.605 1198.748c-.465 3.786.063 8.288 1.558 13.539M2165.592 1197.533c.136-2.058.479-6.04 1.848-9.761M2166.485 1195.767c.03-1.764.708-5.604 1.305-7.178M2164.826 1196.431c.068-1.024.176-1.66.353-3.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeLinecap: "round",
    strokeWidth: 0.248,
    d: "M2163.477 1187.757c.503-2.187 1.103-3.939 1.805-5.724M2166.213 1179.367c.585-1.261 1.712-3.45 2.43-4.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292723",
    d: "M2194.754 1315.191s.154-.721.515-1.103c.403-.426 1.064-.437 1.91-.305.72.112.805.28 1.129.663l.18-3.248-3.734.258Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2115.954 1627.398c-7.588-8.623-2.91-14.875-19.718-17.559-2.954-.479-6.673 1.02-9.461-2.458-.585-.735-.705-2.865-1.321-3.284-2.938-2.039-2.307-4.889-1.348-6.944 2.879 5.61 3.343 1.756 7.81 4.5 3.39 2.083 4.11 3.508 9.883 3.87-.3-4.155-2.894-6.329-3.6-9.434-.718-3.149.932-7.45 4.545-7.242-2.624 5.024 2.803 3.33 2.158 7.602-.81 5.294 3.794 10.782 7.123 8.907 3.479-1.964 10.42-4.768 9.52-9.37 2.88 2.907 2.536 6.506-.148 8.665-3.06 2.475-7.827 3.134-5.563 11.336 1.169 4.258 6.973 9.821 8.92 14.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.048,
    d: "M2115.954 1627.398c-7.588-8.623-2.91-14.875-19.718-17.559-2.954-.479-6.673 1.02-9.461-2.458-.585-.735-.705-2.865-1.321-3.284-2.938-2.039-2.307-4.889-1.348-6.944 2.879 5.61 3.343 1.756 7.81 4.5 3.39 2.083 4.11 3.508 9.883 3.87-.3-4.155-2.894-6.329-3.6-9.434-.718-3.149.932-7.45 4.545-7.242-2.624 5.024 2.803 3.33 2.158 7.602-.81 5.294 3.794 10.782 7.123 8.907 3.479-1.964 10.42-4.768 9.52-9.37 2.88 2.907 2.536 6.506-.148 8.665-3.06 2.475-7.827 3.134-5.563 11.336 1.169 4.258 6.973 9.821 8.92 14.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M2133.108 1600.992c0 4.064 1.453 6.478 5.367 6.028 4.558-.525 14.32-3.779 17.65.78 2.113 2.91 1.423 8.668 1.364 12.16 2.083-.03 4.153-.09 6.252-.119-.765-3.899-2.489-11.217-.749-15.055 1.753-3.854 8.005-2.983 7.196-7.828 1.95-1.394 1.875-4.062.494-6.132-.464 2.88-2.187 2.4-3.659 3.614-.658.554-2.294.15-3.282.93-.796.63-1.02 1.724-1.56 2.084-5.504 3.764-4.843-2.879-6.028-4.844-1.41-2.354.36-5.248-3.748-4.843-.569-.915-1.41-2.099.075-3.643-8.366-1.86-.375 9.806-.78 13.854-3.524.405-5.383-7.977-10.736-5.907-.915-.765-2.025-2.429-1.485-4.273-2.488 1.873-2.608 4.708-.345 7.167-3.267 4.723 6.553 4.198 10.347 8.006.105-.029.284.046.15-.014-3.853.63-6.163-1.799-9.447-2.1-3.058-.269-3.763 2.655-7.076.135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.048,
    d: "M2133.108 1600.992c0 4.064 1.453 6.478 5.367 6.028 4.558-.525 14.32-3.779 17.65.78 2.113 2.91 1.423 8.668 1.364 12.16 2.083-.03 4.153-.09 6.252-.119-.765-3.899-2.489-11.217-.749-15.055 1.753-3.854 8.005-2.983 7.196-7.828 1.95-1.394 1.875-4.062.494-6.132-.464 2.88-2.187 2.4-3.659 3.614-.658.554-2.294.15-3.282.93-.796.63-1.02 1.724-1.56 2.084-5.504 3.764-4.843-2.879-6.028-4.844-1.41-2.354.36-5.248-3.748-4.843-.569-.915-1.41-2.099.075-3.643-8.366-1.86-.375 9.806-.78 13.854-3.524.405-5.383-7.977-10.736-5.907-.915-.765-2.025-2.429-1.485-4.273-2.488 1.873-2.608 4.708-.345 7.167-3.267 4.723 6.553 4.198 10.347 8.006.105-.029.284.046.15-.014-3.853.63-6.163-1.799-9.447-2.1-3.058-.269-3.763 2.655-7.076.135Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2119.237 1730.093c-5.248 4.98-10.825 8.952-18.112 18.354-7.288 9.416-33.483 29.838-61.507 39.78-28.01 9.956-75.707 33.767-56.44 5.623 1.455-1.425-.163-2.729-4.467-.375-4.288 2.354-12.745 10.481-20.002 12.564-7.258 2.1-46.333 1.831-57.16-4.153-10.84-5.966-3.598-9.295 10.812-15.144 14.395-5.848 41.894-17.887 58.132-30.453 16.225-12.58 34.563-23.572 41.896-27.499 7.332-3.93 4.557-3.675 10.795-3.93 6.224-.255 57.189-4.707 64.177-36.136-4.53-3.404-34.113-57.352-13.436-60.502 20.692-3.133 35.492-2.67 38.16-1.619l-.99-3.929s6.163 1.815 8.264-2.368c3.147 1.83 5.562 8.141 10.795 8.395 5.249.271 8.726 1.095 12.91-.733 4.184-1.83 12.566-8.907 14.41-12.566 2.353-.525 3.643.54 5.232-1.049 1.41-1.409 5.758 7.332 5.758 12.835 0 5.487 4.979 4.184 8.112.255 3.149-3.93 12.836-29.854 18.339-29.585 5.503.255 6.027 2.88 7.857 3.93 2.624-1.845 6.55.51 8.382 4.183 5.757-1.05 12.834 2.1 12.834 9.431 6.283-.525 10.21 1.83 10.21 7.333 3.93 0 10.738 2.608 10.467 8.382 3.405.523 11.53 5.487 6.029 10.465-5.503 4.978-45.824 26.72-62.062 31.683-16.238 4.978-24.097 9.702-24.352 13.885-.268 4.198 17.274 7.332 23.827 24.351 6.553 17.033-8.382 23.317.78 29.074 9.176 5.758 35.626 22.777 65.209 32.477 29.6 9.687 72.799 26.706 63.907 29.585-8.906 2.88-30.903 8.38-48.972 9.16-18.083.796-76.216 1.576-93.49-4.182-17.287-5.758-33.003-8.907-43.213-34.563-10.212-25.67-8.382-42.434-12.311-48.972Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#59595b",
    strokeWidth: 1.571,
    d: "M2119.237 1730.093c-5.248 4.98-10.825 8.952-18.112 18.354-7.288 9.416-33.483 29.838-61.507 39.78-28.01 9.956-75.707 33.767-56.44 5.623 1.455-1.425-.163-2.729-4.467-.375-4.288 2.354-12.745 10.481-20.002 12.564-7.258 2.1-46.333 1.831-57.16-4.153-10.84-5.966-3.598-9.295 10.812-15.144 14.395-5.848 41.894-17.887 58.132-30.453 16.225-12.58 34.563-23.572 41.896-27.499 7.332-3.93 4.557-3.675 10.795-3.93 6.224-.255 57.189-4.707 64.177-36.136-4.53-3.404-34.113-57.352-13.436-60.502 20.692-3.133 35.492-2.67 38.16-1.619l-.99-3.929s6.163 1.815 8.264-2.368c3.147 1.83 5.562 8.141 10.795 8.395 5.249.271 8.726 1.095 12.91-.733 4.184-1.83 12.566-8.907 14.41-12.566 2.353-.525 3.643.54 5.232-1.049 1.41-1.409 5.758 7.332 5.758 12.835 0 5.487 4.979 4.184 8.112.255 3.149-3.93 12.836-29.854 18.339-29.585 5.503.255 6.027 2.88 7.857 3.93 2.624-1.845 6.55.51 8.382 4.183 5.757-1.05 12.834 2.1 12.834 9.431 6.283-.525 10.21 1.83 10.21 7.333 3.93 0 10.738 2.608 10.467 8.382 3.405.523 11.53 5.487 6.029 10.465-5.503 4.978-45.824 26.72-62.062 31.683-16.238 4.978-24.097 9.702-24.352 13.885-.268 4.198 17.274 7.332 23.827 24.351 6.553 17.033-8.382 23.317.78 29.074 9.176 5.758 35.626 22.777 65.209 32.477 29.6 9.687 72.799 26.706 63.907 29.585-8.906 2.88-30.903 8.38-48.972 9.16-18.083.796-76.216 1.576-93.49-4.182-17.287-5.758-33.003-8.907-43.213-34.563-10.212-25.67-8.382-42.434-12.311-48.972Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2087.284 1685.05a4.22 4.22 0 0 0-4.004 2.94c-8.816 28.144-42.943 30.917-59.797 32.597-2.848.286-7.407.69-9.206 1.724-21.097 12.056-54.82 37.306-78.48 50.577-21.037 11.785-67.159 24.335-66.636 26.6.525 2.25 49.123-8.816 71.208-21.203 21.863-12.265 63.081-36.796 77.416-48.057 1.485-.195 3.39-.39 5.547-.599 18.654-1.844 57.46-5.698 67.955-39.136a4.19 4.19 0 0 0-4.003-5.443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2087.284 1685.05a4.22 4.22 0 0 0-4.004 2.94c-8.816 28.144-42.943 30.917-59.797 32.597-2.848.286-7.407.69-9.206 1.724-21.097 12.056-54.82 37.306-78.48 50.577-21.037 11.785-67.159 24.335-66.636 26.6.525 2.25 49.123-8.816 71.208-21.203 21.863-12.265 63.081-36.796 77.416-48.057 1.485-.195 3.39-.39 5.547-.599 18.654-1.844 57.46-5.698 67.955-39.136a4.19 4.19 0 0 0-4.003-5.443Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1883.017 1805.26c-8.501 3.944-.48 6.913 14.155 1.05 6.448-2.593 20.527-8.592 32.462-16.763 14.935-10.211-39.301 12.31-46.617 15.713"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1883.017 1805.26c-8.501 3.944-.48 6.913 14.155 1.05 6.448-2.593 20.527-8.592 32.462-16.763 14.935-10.211-39.301 12.31-46.617 15.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2084.15 1682.262c-1.35 0-2.667.645-3.478 1.844-1.29 1.919-.794 4.528 1.125 5.818 13.644 9.222 30.093 25.566 33.992 36.99 1.544 4.515 2.758 10.437 4.049 16.705 2.413 11.8 4.257 26.945 10.392 37.8 11.138 19.703 26.854 27.62 52.059 31.728 30.753 5.009 93.879 5.714 116.312-.45 20.96-5.742 63.934-21.426 63.14-23.616-.78-2.174-43.033 9.417-65.36 15.535-21.127 5.788-83.414 5.039-112.758.255-26.15-4.26-35.402-15.19-43.618-29.734-5.487-9.701-9.672-22.012-11.966-33.198-1.334-6.537-2.594-12.715-4.32-17.737-5.247-15.34-25.144-33.048-37.23-41.22a4.2 4.2 0 0 0-2.338-.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 2.095,
    d: "M2084.15 1682.262c-1.35 0-2.667.645-3.478 1.844-1.29 1.919-.794 4.528 1.125 5.818 13.644 9.222 30.093 25.566 33.992 36.99 1.544 4.515 2.758 10.437 4.049 16.705 2.413 11.8 4.257 26.945 10.392 37.8 11.138 19.703 26.854 27.62 52.059 31.728 30.753 5.009 93.879 5.714 116.312-.45 20.96-5.742 63.934-21.426 63.14-23.616-.78-2.174-43.033 9.417-65.36 15.535-21.127 5.788-83.414 5.039-112.758.255-26.15-4.26-35.402-15.19-43.618-29.734-5.487-9.701-9.672-22.012-11.966-33.198-1.334-6.537-2.594-12.715-4.32-17.737-5.247-15.34-25.144-33.048-37.23-41.22a4.2 4.2 0 0 0-2.338-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1874.02 1798.859c-8.893 2.879-1.289 6.792 13.93 2.744 6.717-1.77 21.427-6.029 34.277-12.686 16.06-8.322-40.516 7.452-48.208 9.942"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1874.02 1798.859c-8.893 2.879-1.289 6.792 13.93 2.744 6.717-1.77 21.427-6.029 34.277-12.686 16.06-8.322-40.516 7.452-48.208 9.942Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1893.378 1810.299c-8.083 4.692.164 6.913 14.2-.254 6.176-3.181 19.657-10.453 30.797-19.674 13.931-11.545-38.01 15.864-44.997 19.928"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1893.378 1810.299c-8.083 4.692.164 6.913 14.2-.254 6.176-3.181 19.657-10.453 30.797-19.674 13.931-11.545-38.01 15.864-44.997 19.928Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1904.623 1811.873c-7.932 4.978.405 6.913 14.17-.734 6.073-3.39 19.282-11.125 30.108-20.722 13.511-12.027-37.44 17.168-44.278 21.456"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1904.623 1811.873c-7.932 4.978.405 6.913 14.17-.734 6.073-3.39 19.282-11.125 30.108-20.722 13.511-12.027-37.44 17.168-44.278 21.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1916.365 1811.977c-7.903 5.024.435 6.913 14.169-.809 6.057-3.404 19.237-11.2 30.004-20.873 13.465-12.069-37.351 17.35-44.173 21.682"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1916.365 1811.977c-7.903 5.024.435 6.913 14.169-.809 6.057-3.404 19.237-11.2 30.004-20.873 13.465-12.069-37.351 17.35-44.173 21.682Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1930.669 1812.143c-7.812 5.157.554 6.897 14.155-1.08 5.997-3.508 19.027-11.546 29.614-21.397 13.255-12.31-37.022 18.01-43.77 22.477"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1930.669 1812.143c-7.812 5.157.554 6.897 14.155-1.08 5.997-3.508 19.027-11.546 29.614-21.397 13.255-12.31-37.022 18.01-43.77 22.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1945.303 1812.533c-7.467 5.638.99 6.853 14.064-1.95 5.758-3.883 18.264-12.73 28.22-23.21 12.446-13.137-35.837 20.286-42.284 25.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1945.303 1812.533c-7.467 5.638.99 6.853 14.064-1.95 5.758-3.883 18.264-12.73 28.22-23.21 12.446-13.137-35.837 20.286-42.284 25.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1961.254 1812.908c-5.783 5.633 1.575 5.775 11.81-3.204 4.526-3.955 14.276-12.88 21.677-22.962 9.25-12.618-28.482 21.285-33.487 26.166"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1961.254 1812.908c-5.783 5.633 1.575 5.775 11.81-3.204 4.526-3.955 14.276-12.88 21.677-22.962 9.25-12.618-28.482 21.285-33.487 26.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1974.992 1810.674c-4.902 6.432 2.4 5.487 11.2-4.903 3.884-4.574 8.682-8.667 14.5-19.733 7.287-13.854-21.487 19.073-25.7 24.636"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1974.992 1810.674c-4.902 6.432 2.4 5.487 11.2-4.903 3.884-4.574 8.682-8.667 14.5-19.733 7.287-13.854-21.487 19.073-25.7 24.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1982.115 1810.718c-5.34 6.072 2.023 5.653 11.545-4.078 4.199-4.288 13.24-13.929 19.853-24.56 8.262-13.287-26.78 23.39-31.398 28.638"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1982.115 1810.718c-5.34 6.072 2.023 5.653 11.545-4.078 4.199-4.288 13.24-13.929 19.853-24.56 8.262-13.287-26.78 23.39-31.398 28.638Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1990.502 1810.897c-5.8 5.822 2.483 6.202 12.76-3.07 4.517-4.087 17.783-18.354 25.136-28.685 9.203-12.921-32.893 26.73-37.896 31.755"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M1990.502 1810.897c-5.8 5.822 2.483 6.202 12.76-3.07 4.517-4.087 17.783-18.354 25.136-28.685 9.203-12.921-32.893 26.73-37.896 31.755Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2015.386 1796.918c-5.406 6.004 1.948 5.657 11.582-3.953 4.243-4.252 9.353-7.931 16.092-18.47 8.4-13.201-22.996 17.219-27.674 22.423"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2015.386 1796.918c-5.406 6.004 1.948 5.657 11.582-3.953 4.243-4.252 9.353-7.931 16.092-18.47 8.4-13.201-22.996 17.219-27.674 22.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2025.342 1796.16c-5.181 6.209 2.152 5.599 11.42-4.372 4.089-4.395 12.894-14.266 19.217-25.062 7.919-13.478-26.155 24.07-30.637 29.435"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2025.342 1796.16c-5.181 6.209 2.152 5.599 11.42-4.372 4.089-4.395 12.894-14.266 19.217-25.062 7.919-13.478-26.155 24.07-30.637 29.435Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2036.252 1794.2c-4.602 6.645 2.657 5.372 10.978-5.39 3.672-4.758 11.537-15.381 16.871-26.708 6.665-14.144-23.872 26.34-27.849 32.099"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2036.252 1794.2c-4.602 6.645 2.657 5.372 10.978-5.39 3.672-4.758 11.537-15.381 16.871-26.708 6.665-14.144-23.872 26.34-27.849 32.099Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2050.009 1786.652c-4.199 6.913 4.183 4.949 11.875-6.281 3.389-4.949 9.401-15.775 14.049-27.38 5.833-14.529-22.296 27.695-25.924 33.661"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2050.009 1786.652c-4.199 6.913 4.183 4.949 11.875-6.281 3.389-4.949 9.401-15.775 14.049-27.38 5.833-14.529-22.296 27.695-25.924 33.661Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2064.748 1776.816c-3.194 5.878 3.75 4.559 9.67-4.962 2.61-4.2 7.138-13.435 10.497-23.422 4.199-12.49-17.408 23.302-20.167 28.384"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2064.748 1776.816c-3.194 5.878 3.75 4.559 9.67-4.962 2.61-4.2 7.138-13.435 10.497-23.422 4.199-12.49-17.408 23.302-20.167 28.384Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2075.769 1771.929c-2.79 6.162 4.258 7.137 9.52-2.79 2.31-4.377 6.165-14.095 8.758-24.755 3.24-13.331-15.88 22.222-18.278 27.545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2075.769 1771.929c-2.79 6.162 4.258 7.137 9.52-2.79 2.31-4.377 6.165-14.095 8.758-24.755 3.24-13.331-15.88 22.222-18.278 27.545Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2087.824 1763.097c-2.279 6.281 4.394 3.943 8.831-6.343 1.95-4.543 3.614-9.612 4.184-12.655 2.4-12.956-11.034 13.57-13.015 18.998"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2087.824 1763.097c-2.279 6.281 4.394 3.943 8.831-6.343 1.95-4.543 3.614-9.612 4.184-12.655 2.4-12.956-11.034 13.57-13.015 18.998Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2098.17 1751.941c.465 9.505 9.972-12.311 10.06-15.414.092-3.329-10.21 12.16-10.06 15.414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2098.17 1751.941c.465 9.505 9.972-12.311 10.06-15.414.092-3.329-10.21 12.16-10.06 15.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2104.574 1746.602c-1.71 6.883 7.495-7.436 7.585-10.54.091-3.33-6.836 7.497-7.586 10.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2104.574 1746.602c-1.71 6.883 7.495-7.436 7.585-10.54.091-3.33-6.836 7.497-7.586 10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2281.596 1781.42c8.637.135 28.548 1.11 28.548 2.91 0 1.813-16.763 6.267-35.1 5.742-18.325-.525-27.485-9.177 6.552-8.652"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2281.596 1781.42c8.637.135 28.548 1.11 28.548 2.91 0 1.813-16.763 6.267-35.1 5.742-18.325-.525-27.485-9.177 6.552-8.652Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2259.975 1772.559c8.59.869 28.34 3.508 28.188 5.308-.15 1.799-17.229 4.827-35.447 2.759-18.218-2.085-26.63-11.456 7.26-8.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2259.975 1772.559c8.59.869 28.34 3.508 28.188 5.308-.15 1.799-17.229 4.827-35.447 2.759-18.218-2.085-26.63-11.456 7.26-8.067Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2278.448 1791.645c4.257 1.321 34.456 1.906 42.164 3.134 7.706 1.23.27-9.685-21.728-7.587-21.997 2.084-29.598 1.56-20.436 4.453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2278.448 1791.645c4.257 1.321 34.456 1.906 42.164 3.134 7.706 1.23.27-9.685-21.728-7.587-21.997 2.084-29.598 1.56-20.436 4.453Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2305.317 1795.59c6.463.089 21.367.869 21.383 2.489 0 1.618-12.522 5.667-26.24 5.261-13.72-.388-20.634-8.08 4.857-7.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2305.317 1795.59c6.463.089 21.367.869 21.383 2.489 0 1.618-12.522 5.667-26.24 5.261-13.72-.388-20.634-8.08 4.857-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2226.867 1769.23c3.628 1.229 29.465 1.769 36.06 2.893 6.598 1.125.226-8.906-18.592-6.986-18.818 1.933-25.31 1.454-17.468 4.093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2226.867 1769.23c3.628 1.229 29.465 1.769 36.06 2.893 6.598 1.125.226-8.906-18.592-6.986-18.818 1.933-25.31 1.454-17.468 4.093Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2212.803 1763.097c3.747 1.14 30.407 1.634 37.2 2.684 6.807 1.048.24-8.293-19.179-6.509-19.403 1.8-26.105 1.35-18.022 3.825"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.366,
    d: "M2212.803 1763.097c3.747 1.14 30.407 1.634 37.2 2.684 6.807 1.048.24-8.293-19.179-6.509-19.403 1.8-26.105 1.35-18.022 3.825Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2198.738 1753.546c3.073 1.648 25.835 4.511 31.532 6.326 5.698 1.815 1.17-9.73-15.653-9.28-16.823.464-22.508-.646-15.879 2.953"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.377,
    d: "M2198.738 1753.546c3.073 1.648 25.835 4.511 31.532 6.326 5.698 1.815 1.17-9.73-15.653-9.28-16.823.464-22.508-.646-15.879 2.953Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2181.629 1742.69c2.174 1.89 19.687 6.462 23.93 8.681 4.229 2.234 2.31-9.507-11.005-10.36-13.315-.856-17.633-2.37-12.925 1.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2181.629 1742.69c2.174 1.89 19.687 6.462 23.93 8.681 4.229 2.234 2.31-9.507-11.005-10.36-13.315-.856-17.633-2.37-12.925 1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2177.91 1734.818c2.189 1.888 19.702 6.462 23.93 8.697 4.229 2.218 2.326-9.523-10.99-10.377-13.331-.84-17.648-2.369-12.94 1.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2177.91 1734.818c2.189 1.888 19.702 6.462 23.93 8.697 4.229 2.218 2.326-9.523-10.99-10.377-13.331-.84-17.648-2.369-12.94 1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2179.724 1727.56c2.175 1.889 19.703 6.463 23.932 8.697 4.228 2.219 2.308-9.521-11.006-10.377-13.316-.84-17.633-2.37-12.926 1.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2179.724 1727.56c2.175 1.889 19.703 6.463 23.932 8.697 4.228 2.219 2.308-9.521-11.006-10.377-13.316-.84-17.633-2.37-12.926 1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2178.645 1720.858c2.294 1.739 20.047 5.217 24.41 7.183 4.363 1.963 1.725-9.643-11.62-9.658s-17.754-1.275-12.79 2.475"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2178.645 1720.858c2.294 1.739 20.047 5.217 24.41 7.183 4.363 1.963 1.725-9.643-11.62-9.658s-17.754-1.275-12.79 2.475Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2177.774 1712.866c2.296 1.74 20.05 5.217 24.412 7.167 4.363 1.964 1.725-9.642-11.62-9.656-13.346-.015-17.754-1.274-12.792 2.489"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2177.774 1712.866c2.296 1.74 20.05 5.217 24.412 7.167 4.363 1.964 1.725-9.642-11.62-9.656-13.346-.015-17.754-1.274-12.792 2.489Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2173.083 1707.452c2.504 1.41 20.587 2.444 25.16 3.778 4.588 1.35.404-9.776-12.82-7.976s-17.768 1.155-12.34 4.198"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2173.083 1707.452c2.504 1.41 20.587 2.444 25.16 3.778 4.588 1.35.404-9.776-12.82-7.976s-17.768 1.155-12.34 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2167.43 1700.51c-4.709 2.534 15.64.57 19.326 1.574 3.69.99 9.956-6.793-1.784-7.077-8.906-.226-17.543 5.503-17.543 5.503"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.571,
    d: "M2167.43 1700.51c-4.709 2.534 15.64.57 19.326 1.574 3.69.99 9.956-6.793-1.784-7.077-8.906-.226-17.543 5.503-17.543 5.503Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2164.626 1697.975c-3.42 3.315 13.18-2.174 16.464-1.844s6.927-8.382-2.94-6.612c-7.481 1.351-13.524 8.456-13.524 8.456"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.452,
    d: "M2164.626 1697.975c-3.42 3.315 13.18-2.174 16.464-1.844s6.927-8.382-2.94-6.612c-7.481 1.351-13.524 8.456-13.524 8.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2161.026 1694.633c-.899 4.333 11.937-4.798 15.115-5.144 3.164-.345 4.618-9.565-4.273-5.833-6.748 2.834-10.842 10.977-10.842 10.977"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.424,
    d: "M2161.026 1694.633c-.899 4.333 11.937-4.798 15.115-5.144 3.164-.345 4.618-9.565-4.273-5.833-6.748 2.834-10.842 10.977-10.842 10.977Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2058.21 1651.538c-5.321-8.816-2.744-18.309 5.729-21.997 10.616-4.632 14.514.555 21.516 7.527 3.794 3.765 12.326 10.542 5.518 16.51 5.953 1.02 7.752 7.647 3.389 10.555 8.352 7.227-.06 18.414-9.386 18.084-2.864 5.712-9.823 7.243-12.91.794-11.321 3.194-17.588-12.624-13.061-21.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#909294",
    strokeWidth: 1.424,
    d: "M2058.21 1651.538c-5.321-8.816-2.744-18.309 5.729-21.997 10.616-4.632 14.514.555 21.516 7.527 3.794 3.765 12.326 10.542 5.518 16.51 5.953 1.02 7.752 7.647 3.389 10.555 8.352 7.227-.06 18.414-9.386 18.084-2.864 5.712-9.823 7.243-12.91.794-11.321 3.194-17.588-12.624-13.061-21.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4ac64",
    d: "M2048.554 1666.728c2.594-1.05 4.948-.27 9.655 1.05 4.726 1.304 12.838-.795 12.057-9.177-.796-8.367-7.123-13.614-14.816-10.99-7.705 2.623-18.021 5.502-23.345 5.502-5.309 0-16.044-.525-19.717 7.332-3.658 7.857-2.878 5.758-4.978 6.538-2.085.794-3.404 7.602-1.305 10.481 2.1 2.88 11.516 12.91 19.898 11.815 8.382-1.08 10.48-4.229 15.458-14.169 4.965-9.957 7.092-8.382 7.092-8.382"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.424,
    d: "M2048.554 1666.728c2.594-1.05 4.948-.27 9.655 1.05 4.726 1.304 12.838-.795 12.057-9.177-.796-8.367-7.123-13.614-14.816-10.99-7.705 2.623-18.021 5.502-23.345 5.502-5.309 0-16.044-.525-19.717 7.332-3.658 7.857-2.878 5.758-4.978 6.538-2.085.794-3.404 7.602-1.305 10.481 2.1 2.88 11.516 12.91 19.898 11.815 8.382-1.08 10.48-4.229 15.458-14.169 4.965-9.957 7.092-8.382 7.092-8.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1991.17 1662.53c-.78 4.453 3.404 13.404 11.786 13.36 11.292-.06 12.58-8.637 12.58-10.992 0-2.368-8.936-2.099-10.496-.524-1.559 1.558-7.572 3.657-13.87-1.844"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.424,
    d: "M1991.17 1662.53c-.78 4.453 3.404 13.404 11.786 13.36 11.292-.06 12.58-8.637 12.58-10.992 0-2.368-8.936-2.099-10.496-.524-1.559 1.558-7.572 3.657-13.87-1.844Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e53c",
    d: "M1994.575 1657.49c6.627-2.787 20.737-3.853 20.183 1.905-.54 5.758-7.35 4.184-8.397 2.085-1.035-2.085-5.233-3.66-11.786-3.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#473125",
    strokeWidth: 1.424,
    d: "M1994.575 1657.49c6.627-2.787 20.737-3.853 20.183 1.905-.54 5.758-7.35 4.184-8.397 2.085-1.035-2.085-5.233-3.66-11.786-3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473125",
    d: "M2008.205 1675.89c2.354 4.453 9.942 12.174 16.749 11.32 6.808-.84 10.406-1.334 12.28-4.438 2.655 2.549 2.174 6.478.45 7.527-1.725 1.05-3.404 1.98-5.58 3.869-2.173 1.889-6.776.585-8.92-1.514-2.158-2.1-1.364.524-6.597-1.305-5.248-1.844-.796-2.37-6.553-3.42-5.759-1.033-10.826-4.182-6.718-9.94 4.093-5.758 4.889-2.1 4.889-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272425",
    strokeWidth: 1.424,
    d: "M2008.205 1675.89c2.354 4.453 9.942 12.174 16.749 11.32 6.808-.84 10.406-1.334 12.28-4.438 2.655 2.549 2.174 6.478.45 7.527-1.725 1.05-3.404 1.98-5.58 3.869-2.173 1.889-6.776.585-8.92-1.514-2.158-2.1-1.364.524-6.597-1.305-5.248-1.844-.796-2.37-6.553-3.42-5.759-1.033-10.826-4.182-6.718-9.94 4.093-5.758 4.889-2.1 4.889-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeWidth: 1.424,
    d: "M2013.528 1674.06c3.059-1.05 7.766 7.333 13.524 1.305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272425",
    d: "M2016.316 1673.266a2.62 2.62 0 0 0 2.624 2.624c1.44 0 2.608-1.17 2.608-2.624a2.61 2.61 0 0 0-2.608-2.61 2.615 2.615 0 0 0-2.624 2.61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBo);
export default __webpack_public_path__ + "static/media/bo.d62c81657920bee6760800a878c81c08.svg";
export { ForwardRef as ReactComponent };